(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBarRotator extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('[data-announcement-message]'));
      this.index = 0;
      this.intervalMs = parseInt(this.getAttribute('data-interval'), 10) || 5000;
      this.visible = true;

      this.classList.add('is-ready');
      this.activate(0);

      // Rotation is driven by the actual message count, not a Liquid flag:
      // in a section group `section.blocks` is unreliable, so the DOM is the
      // source of truth. The fade transition is removed under reduced motion
      // (see the stylesheet) while the content still cycles.
      if (this.messages.length <= 1) return;

      // Bound handlers stored so they can be removed on disconnect.
      this.pause = this.stop.bind(this);
      this.resume = this.start.bind(this);
      this.onVisibilityChange = () => {
        if (document.hidden) {
          this.stop();
        } else {
          this.start();
        }
      };

      this.addEventListener('pointerenter', this.pause);
      this.addEventListener('pointerleave', this.resume);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.resume);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      // Only run the timer while the bar is actually on screen.
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) {
            this.start();
          } else {
            this.stop();
          }
        });
        this.observer.observe(this);
      } else {
        this.start();
      }
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener('pointerenter', this.pause);
      this.removeEventListener('pointerleave', this.resume);
      this.removeEventListener('focusin', this.pause);
      this.removeEventListener('focusout', this.resume);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    start() {
      if (this.timer || this.messages.length <= 1) return;
      if (!this.visible || document.hidden) return;
      this.timer = window.setInterval(this.next.bind(this), this.intervalMs);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.activate((this.index + 1) % this.messages.length);
    }

    activate(i) {
      this.index = i;
      this.messages.forEach((el, n) => {
        const isActive = n === i;
        el.toggleAttribute('data-active', isActive);
        el.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        /* A message can hold a link, and hiding the wrapper from assistive tech
           does not take its link out of the tab order: keyboard focus still
           landed on a link inside an aria-hidden message, announced as nothing.
           Rotate tabbability with visibility. */
        el.querySelectorAll('a[href]').forEach((link) => {
          if (isActive) {
            link.removeAttribute('tabindex');
          } else {
            link.setAttribute('tabindex', '-1');
          }
        });
      });
    }
  }

  // Region switcher: opens the menu of regions; each option is a real link, so
  // selecting one navigates straight to that region's URL (spring-loaded).
  class RegionSelector extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-region-trigger]');
      this.list = this.querySelector('[data-region-list]');
      if (!this.trigger || !this.list) return;

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.trigger.addEventListener('click', this.toggle.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    get isOpen() {
      return !this.list.hidden;
    }

    open() {
      this.list.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.list.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    toggle(event) {
      event.preventDefault();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
        this.trigger.focus();
      }
    }
  }

  if (!customElements.get('announcement-bar-rotator')) {
    customElements.define('announcement-bar-rotator', AnnouncementBarRotator);
  }
  if (!customElements.get('region-selector')) {
    customElements.define('region-selector', RegionSelector);
  }

  // Publish the announcement bar height to :root as --announcement-height. The
  // bar is not sticky (it scrolls away above the sticky header), so sections at
  // the top of the page that fill the viewport can subtract it in addition to
  // --header-height. Falls back to 0 when there is no announcement bar.
  (function () {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    function publish() {
      document.documentElement.style.setProperty('--announcement-height', bar.offsetHeight + 'px');
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(publish).observe(bar);
    } else {
      window.addEventListener('resize', publish, { passive: true });
    }
    publish();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["assembly"] && !Shopify.designMode) return;
  try {
    
  // <assembly-tile>: a media tile with a bottom accordion. Opens on hover /
  // focus on pointer devices and on tap or keyboard via the toggle button
  // everywhere else, matching the product features tile. The one thing it does
  // not copy is the hover accordion, where the open tile widens to a double
  // column: these tiles keep a fixed width.
  (function () {
    if (customElements.get('assembly-tile')) return;

    var HOVER = window.matchMedia('(hover: hover)');
    var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

    class AssemblyTile extends HTMLElement {
      connectedCallback() {
        this.toggleBtn = this.querySelector('.assembly__toggle');
        this.panel = this.querySelector('.assembly__panel');
        this.video = this.querySelector('video');
        this._open = false;
        // Collapsed: keep the copy out of the a11y tree and tab order while JS
        // is on. The noscript style keeps it reachable when JS is off.
        if (this.panel) this.panel.inert = true;

        this._onClick = this._onClick.bind(this);
        this._onEnter = this._onEnter.bind(this);
        this._onLeave = this._onLeave.bind(this);

        // Click / tap anywhere on the tile toggles it. This is the path touch
        // devices take at any width; the toggle button's click and keyboard
        // Enter / Space bubble up here too.
        this.addEventListener('click', this._onClick);
        // Hover preview, pointer devices only.
        if (HOVER.matches) {
          this.addEventListener('pointerenter', this._onEnter);
          this.addEventListener('pointerleave', this._onLeave);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('pointerenter', this._onEnter);
        this.removeEventListener('pointerleave', this._onLeave);
      }

      // #1169: a tile that is only partly on screen when tapped opens but stays
      // cut off, so the change goes unseen. A click that opens a tile also
      // brings it to the start of the row. Only ever a click: hover previews
      // must not move the row, and closing a tile never scrolls.
      //
      // On pointer devices the hover preview has already opened the tile by
      // the time it is clicked, so a plain toggle would collapse it under the
      // cursor and no click could ever scroll. That first click instead pins
      // the tile open and slides it into view; the next click closes it. A
      // pinned tile ignores pointerleave (the slide moves it away from the
      // cursor) but still closes when another tile opens.
      _onClick(event) {
        if (event.target.closest('a')) return; // let links in the copy work
        if (!this.panel) return;
        if (this._open && this._pinned) {
          this.setOpen(false);
          return;
        }
        if (!this._open) this.setOpen(true);
        this._pinned = true;
        this._scrollToStart();
      }
      _onEnter() {
        // Chrome replays the resting pointer position once a scroll ends, which
        // would preview whatever tile slid under the cursor and close the one
        // just clicked. Ignore hover until the row has come to rest.
        var row = this.closest('.assembly__media-col');
        if (row && row.__asSettling) return;
        this.setOpen(true);
      }
      _onLeave() {
        if (this._pinned) return;
        this.setOpen(false);
      }

      // Start edge to the row's start edge plus its scroll-padding (the snap
      // position the arrows land on), clamped to the scrollable range. No
      // behavior argument, so the row's CSS scroll-behavior (smooth; auto under
      // reduced motion) decides, as the arrows do. The tiles keep one width
      // open or closed, so the measurement at click time is the settled one.
      _scrollToStart() {
        var row = this.closest('.assembly__media-col');
        if (!row) return;
        var max = row.scrollWidth - row.clientWidth;
        if (max < 2) return;
        var pad = parseFloat(window.getComputedStyle(row).scrollPaddingInlineStart) || 0;
        var offset = this.getBoundingClientRect().left - row.getBoundingClientRect().left;
        var target = Math.min(Math.max(0, row.scrollLeft + offset - pad), max);
        if (Math.abs(target - row.scrollLeft) < 1) return;

        row.__asSettling = true;
        clearTimeout(row.__asSettleTimer);
        var release = function () { row.__asSettling = false; };
        row.__asSettleTimer = setTimeout(release, REDUCE.matches ? 200 : 900);
        var onEnd = function () {
          row.removeEventListener('scrollend', onEnd);
          clearTimeout(row.__asSettleTimer);
          row.__asSettleTimer = setTimeout(release, 120);
        };
        row.addEventListener('scrollend', onEnd);
        row.scrollTo({ left: Math.round(target) });
      }

      setOpen(open) {
        if (open === this._open) return;
        if (!open) this._pinned = false;
        // Single open row: opening one tile closes any other open tile.
        if (open) this._closeSiblings();
        this._open = open;
        this.classList.toggle('is-open', open);
        if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (this.panel) {
          this.panel.style.height = open ? this.panel.scrollHeight + 'px' : '0px';
          this.panel.inert = !open;
        }
        if (this.video) {
          // A feature tile's video is decorative: muted, looping, and only
          // while the tile is expanded. Left on its poster under reduced motion.
          if (open && !REDUCE.matches) {
            var playing = this.video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            this.video.pause();
          }
        }
        var row = this.closest('.assembly__media-col');
        if (row) row.dispatchEvent(new CustomEvent('as:toggle', { bubbles: true }));
      }

      _closeSiblings() {
        var row = this.closest('.assembly__media-col');
        if (!row) return;
        var self = this;
        row.querySelectorAll('assembly-tile.is-open').forEach(function (tile) {
          if (tile !== self && typeof tile.setOpen === 'function') tile.setOpen(false);
        });
      }
    }

    customElements.define('assembly-tile', AssemblyTile);
  })();

  // Carousel arrows: revealed by CSS on desktop when the row overflows. A click
  // scrolls by one tile plus the gap; the buttons disable at each end. The row
  // is natively swipeable, so these are a pointer-only, aria-hidden extra.
  (function () {
    if (window.__esAssemblyCarousel) return;
    window.__esAssemblyCarousel = true;

    var GAP = 8; // --spacing-8, the gap between tiles

    function setup(section) {
      if (section.__asCarousel) return;
      section.__asCarousel = true;

      var row = section.querySelector('[data-assembly-track]');
      var head = section.querySelector('[data-assembly-head]');
      if (!row || !head) return;
      var prev = head.querySelector('[data-as-arrow="prev"]');
      var next = head.querySelector('[data-as-arrow="next"]');

      function sync() {
        var max = row.scrollWidth - row.clientWidth;
        head.setAttribute('data-scrollable', max > 1 ? 'true' : 'false');
        if (prev) prev.disabled = row.scrollLeft <= 1;
        if (next) next.disabled = row.scrollLeft >= max - 1;
      }

      function step(direction) {
        var tile = row.querySelector('.assembly__tile');
        var amount = tile ? tile.getBoundingClientRect().width + GAP : row.clientWidth * 0.8;
        // No explicit behavior so the CSS scroll-behavior (and its
        // reduced-motion override) is respected.
        row.scrollBy({ left: direction * amount });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      row.addEventListener('as:toggle', sync);
      sync();
    }

    function init(root) {
      (root || document).querySelectorAll('.section--assembly').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  // A Video block plays with sound, so it must not keep playing once it is
  // scrolled out of sight in the carousel (audible but invisible). Pause it
  // whenever it leaves the viewport, including when an ancestor scroll
  // container clips it. Never auto-resumes: the visitor started it, so coming
  // back into view leaves it paused for them to start again.
  (function () {
    if (window.__esAssemblyVideoVisibility) return;
    window.__esAssemblyVideoVisibility = true;

    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio >= 0.35) return;
        var video = entry.target.querySelector('video');
        if (video && !video.paused && typeof video.pause === 'function') video.pause();
      });
    }, { threshold: [0, 0.35] });

    function setup(tile) {
      if (tile.__asVideoObserved) return;
      tile.__asVideoObserved = true;
      io.observe(tile);
    }

    function init(root) {
      (root || document).querySelectorAll('.assembly__tile--video').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-article-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__esBlogCarousel) return;
    window.__esBlogCarousel = true;

    function setup(el) {
      if (el.__bcInit) return;
      el.__bcInit = true;

      var vp = el.querySelector('.blog-carousel__viewport');
      if (!vp) return;
      var prev = el.querySelector('[data-bc-arrow="prev"]');
      var next = el.querySelector('[data-bc-arrow="next"]');

      function sync() {
        var max = vp.scrollWidth - vp.clientWidth;
        el.setAttribute('data-scrollable', max > 1 ? 'true' : 'false');
        if (prev) prev.disabled = vp.scrollLeft <= 1;
        if (next) next.disabled = vp.scrollLeft >= max - 1;
      }

      function scrollByCard(direction) {
        var card = vp.querySelector('.blog-carousel__slide');
        var step = card ? card.getBoundingClientRect().width + 8 : vp.clientWidth * 0.8;
        vp.scrollBy({ left: direction * step });
      }

      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
      vp.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function init(root) {
      (root || document).querySelectorAll('blog-article-carousel').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-listing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready() {
      if (customElements.get('blog-listing-grid')) return;

      customElements.define(
        'blog-listing-grid',
        class extends HTMLElement {
          connectedCallback() {
            if (this.__init) return;
            this.__init = true;

            this.sectionId = this.getAttribute('data-section-id');
            this.baseUrl = this.getAttribute('data-base-url') || window.location.pathname;
            this.showingTemplate = this.getAttribute('data-showing-template') || '';

            this.grid = this.querySelector('[data-blog-grid]');
            this.loadedPages = 1;

            this.bindLoadMore();
            this.bindBackNav();
            this.restoreState();
          }

          // ---- Load more (Section Rendering API) -------------------------
          bindLoadMore() {
            var self = this;
            this.addEventListener('click', function (event) {
              var btn = event.target.closest('[data-blog-load-more]');
              if (!btn) return;
              event.preventDefault();
              self.loadNext(btn);
            });
          }

          buildUrl(nextUrl) {
            var url = new URL(nextUrl, window.location.origin);
            url.searchParams.set('section_id', this.sectionId);
            return url.toString();
          }

          loadNext(btn) {
            var self = this;
            var nextUrl = btn.getAttribute('data-next-url');
            if (!nextUrl || btn.getAttribute('aria-busy') === 'true') return;
            btn.setAttribute('aria-busy', 'true');
            btn.disabled = true;

            return fetch(this.buildUrl(nextUrl))
              .then(function (r) {
                return r.text();
              })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                self.appendFrom(doc);
                var pageMatch = nextUrl.match(/[?&]page=(\d+)/);
                if (pageMatch) self.loadedPages = parseInt(pageMatch[1], 10);
                // Reflect the loaded depth so it survives a share / refresh. A
                // custom 'loaded' param, NOT Shopify's reserved 'page'.
                self.writeParam('loaded', self.loadedPages > 1 ? String(self.loadedPages) : null);
                self.saveState();
              })
              .catch(function () {
                btn.removeAttribute('aria-busy');
                btn.disabled = false;
              });
          }

          appendFrom(doc) {
            var incomingGrid = doc.querySelector('[data-blog-grid]');
            if (incomingGrid && this.grid) {
              var cells = incomingGrid.querySelectorAll('.blog-listing__cell');
              cells.forEach(function (cell) {
                this.grid.appendChild(cell);
              }, this);
            }

            var pagination = this.querySelector('[data-blog-pagination]');
            var incomingPagination = doc.querySelector('[data-blog-pagination]');
            if (pagination && incomingPagination) {
              pagination.replaceWith(incomingPagination);
            }
            this.updateShowing();
          }

          updateShowing() {
            var count = this.grid
              ? this.grid.querySelectorAll('.blog-listing__cell').length
              : 0;

            var pagination = this.querySelector('[data-blog-pagination]');
            var total = pagination ? parseInt(pagination.getAttribute('data-total'), 10) || 0 : 0;

            var showing = this.querySelector('[data-blog-showing]');
            if (showing && this.showingTemplate) {
              showing.textContent = this.showingTemplate
                .replace('XCOUNTX', count)
                .replace('XTOTALX', total);
            }

            var fill = this.querySelector('[data-blog-progress-fill]');
            if (fill) {
              var pct = total > 0 ? Math.min(100, (count / total) * 100) : 0;
              fill.style.width = pct + '%';
            }
            var bar = this.querySelector('[data-blog-progress]');
            if (bar) bar.setAttribute('aria-valuenow', count);

            // Everything is on screen: nothing left to page through and nothing
            // left to report, so drop the whole block.
            if (pagination && total > 0 && count >= total) pagination.hidden = true;
          }

          // ---- URL + scroll state ----------------------------------------
          writeParam(key, value) {
            var url = new URL(window.location.href);
            if (value === null) {
              url.searchParams.delete(key);
            } else {
              url.searchParams.set(key, value);
            }
            window.history.replaceState(window.history.state, '', url.toString());
          }

          stateKey() {
            return 'es-blog:' + this.baseUrl;
          }

          saveState() {
            try {
              sessionStorage.setItem(
                this.stateKey(),
                JSON.stringify({ pages: this.loadedPages, y: window.scrollY })
              );
            } catch (e) {}
          }

          bindBackNav() {
            var self = this;
            window.addEventListener('pagehide', function () {
              self.saveState();
            });
            if ('scrollRestoration' in window.history) {
              window.history.scrollRestoration = 'manual';
            }
          }

          restoreState() {
            var params = new URL(window.location.href).searchParams;

            var targetPages = 1;
            var scrollY = 0;

            // Only restore the loaded depth + scroll from session state on a
            // genuine back/forward navigation (returning from an article). A
            // fresh visit or a reload starts at page 1 so articles_per_page is
            // respected - the session state lingers for the whole tab session,
            // so replaying it on every load would expand the grid unexpectedly.
            var navType = 'navigate';
            try {
              var navEntries = performance.getEntriesByType('navigation');
              if (navEntries && navEntries.length) navType = navEntries[0].type;
            } catch (e) {}

            if (navType === 'back_forward') {
              var saved = null;
              try {
                saved = JSON.parse(sessionStorage.getItem(this.stateKey()) || 'null');
              } catch (e) {}
              if (saved && saved.pages) {
                targetPages = saved.pages;
                scrollY = saved.y || 0;
              }
            }

            // An explicit `loaded` param (a shared or bookmarked deep link)
            // restores depth on any navigation type.
            var urlLoaded = parseInt(params.get('loaded'), 10);
            if (urlLoaded && urlLoaded > targetPages) {
              targetPages = urlLoaded;
            }
            if (targetPages <= 1) return;

            this.replayPages(targetPages, scrollY);
          }

          replayPages(target, scrollY) {
            var self = this;
            var page = 2;

            function step() {
              if (page > target) {
                window.scrollTo(0, scrollY);
                return;
              }
              var url = new URL(self.baseUrl, window.location.origin);
              url.searchParams.set('page', page);
              url.searchParams.set('section_id', self.sectionId);
              fetch(url.toString())
                .then(function (r) {
                  return r.text();
                })
                .then(function (html) {
                  var doc = new DOMParser().parseFromString(html, 'text/html');
                  self.appendFrom(doc);
                  self.loadedPages = page;
                  page += 1;
                  step();
                })
                .catch(function () {});
            }
            step();
          }
        }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ready);
    } else {
      ready();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    if (window.__esCart) { return; }
    window.__esCart = true;

    function initHomeClub(root) {
      if (root.__hcBound) { return; }
      root.__hcBound = true;
      var trigger = root.querySelector('[data-hc-signup]');
      var form = root.querySelector('[data-hc-form]');
      if (!trigger || !form) { return; }
      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) {
          form.style.maxHeight = form.scrollHeight + 'px';
          form.offsetHeight;
          form.style.maxHeight = '0px';
        } else {
          form.hidden = false;
          form.style.maxHeight = form.scrollHeight + 'px';
          var done = function (ev) {
            if (ev && ev.propertyName !== 'max-height') { return; }
            form.style.maxHeight = 'none';
            form.removeEventListener('transitionend', done);
          };
          form.addEventListener('transitionend', done);
        }
      });
    }

    function initStickyCta(bar) {
      var summary = document.querySelector('[data-cart-summary]');
      var trigger = bar.querySelector('[data-cart-sticky-trigger]');
      if (!summary) { return; }
      // Switch from the no-JS hidden attribute to class-driven visibility so it
      // can fade/slide.
      bar.removeAttribute('hidden');
      if (trigger) {
        trigger.addEventListener('click', function () {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          // scroll-margin-top on the summary lands it below the sticky header.
          summary.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { threshold: 0.05 });
        observer.observe(summary);
      } else {
        bar.classList.add('is-visible');
      }
    }

    var recsProductId = null;

    /* Resolves to the parsed body on success, or null on failure - unchanged for
       existing callers. 'onRefusal' is handed Shopify's own explanation when the
       request is refused rather than broken: /cart/change answers 422 with a
       'description' when the quantity is above what it will sell ("Only 210
       items were added to your cart due to availability"). That was previously
       thrown away, which is what let the stepper keep showing a quantity the
       cart did not have (#19498864). */
    /* Shopify does not answer the two cart endpoints the same way. /cart/add puts
       its reason in 'description'; /cart/change puts it in 'errors', which can be
       a plain string or a field-keyed object. Reading only the first shape is
       what made the refusal look like silence (#19498864), so all three are
       handled here rather than at the call site. */
    function refusalMessage(err) {
      if (!err) { return ''; }
      var e = err.errors;
      if (typeof e === 'string' && e) { return e; }
      if (e && typeof e === 'object') {
        for (var k in e) {
          if (Object.prototype.hasOwnProperty.call(e, k) && e[k]) {
            return String([].concat(e[k])[0]);
          }
        }
      }
      return err.description || err.message || '';
    }

    function postJSON(url, body, onRefusal) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (r.ok) { return r.json(); }
        if (!onRefusal) { return null; }
        return r.json()
          .catch(function () { return null; })
          .then(function (err) {
            onRefusal(refusalMessage(err), r.status);
            return null;
          });
      });
    }

    function parseHtml(html) {
      var d = document.createElement('div');
      d.innerHTML = html;
      return d;
    }

    // theWishlist.io exposes no "added" event, but checkVariantInWishlist is the
    // reliable membership check (twc-scripts relies on it too). Used to confirm a
    // Save-for-later item landed in a list before removing it from the cart.
    function inWishlist(variantId) {
      if (!variantId) { return false; }
      if (typeof theWishlist === 'undefined' || typeof theWishlist.checkVariantInWishlist !== 'function') { return false; }
      return theWishlist.checkVariantInWishlist(parseInt(variantId, 10));
    }

    // "Pairs perfectly with": one carousel below the lines, for the most recent
    // cart item. Arrows show only when the track overflows.
    function setupRecsCarousel(el) {
      var list = el.querySelector('[data-cart-recs-list]');
      var arrows = el.querySelector('[data-cart-recs-arrows]');
      var prev = el.querySelector('[data-cart-recs-prev]');
      var next = el.querySelector('[data-cart-recs-next]');
      if (!list) { return; }
      // One item's advance = the offset between two cards (card width + gap),
      // so the arrows step a single item at a time.
      function step() {
        var items = list.children;
        if (items.length > 1) { return items[1].offsetLeft - items[0].offsetLeft; }
        if (items.length === 1) { return items[0].offsetWidth; }
        return list.clientWidth;
      }
      function update() {
        var overflow = list.scrollWidth - list.clientWidth > 1;
        if (arrows) { arrows.hidden = !overflow; }
        if (prev) { prev.disabled = list.scrollLeft <= 1; }
        if (next) { next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1; }
      }
      if (!el.__carouselBound) {
        el.__carouselBound = true;
        if (prev) { prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); }); }
        if (next) { next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); }); }
        list.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
      }
      update();
    }

    // Handles of every product currently in the cart, read from the rendered
    // lines. Neither engine knows the cart: Shopify's recommendations API is
    // stateless and a Constructor pod only takes the one seed, so a product the
    // shopper already holds came back in the carousel and, once added, popped
    // straight back the next time the pod ignored the seed (#19928873, item 2).
    // Both fetch paths drop these before rendering, and over-ask by the same
    // count so the carousel still fills to its limit.
    function cartHandles() {
      var handles = [];
      document.querySelectorAll('[data-cart-line][data-product-handle]').forEach(function (line) {
        var h = line.getAttribute('data-product-handle');
        if (h && handles.indexOf(h) === -1) { handles.push(h); }
      });
      return handles;
    }

    // Drops rendered cards for products that are in the cart, then trims the
    // over-ask back to the configured limit. Cards carry data-rec-handle.
    function pruneRecCards(list, inCart, limit) {
      Array.prototype.slice.call(list.querySelectorAll('.cart-rec')).forEach(function (card) {
        var h = card.getAttribute('data-rec-handle');
        if (h && inCart.indexOf(h) !== -1) { card.remove(); }
      });
      while (list.children.length > limit) { list.removeChild(list.lastElementChild); }
    }

    // Constructor path. The feed carries no member pricing, stock or variant
    // data, so rather than degrade the card we let Constructor choose the
    // products and Liquid render them: one /products/<handle>?section_id= request
    // per card, in parallel, the same pattern the Recently viewed carousel uses.
    // The cards are then identical to the Shopify ones, quick-add included.
    function fetchConstructorRecs(el, handle, sku) {
      var pod = el.getAttribute('data-recs-pod');
      var limit = parseInt(el.getAttribute('data-limit'), 10) || 6;
      var list = el.querySelector('[data-cart-recs-list]');
      if (!pod || !list || !window.esrConstructor) { el.hidden = true; return; }
      var inCart = cartHandles();
      /* Cleared up front, not on each failure path: this runs again on every cart
         change, and the old response's result id must not outlive it. */
      window.esrConstructor.untagRecommendations(list);
      recsProductId = handle;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      window.esrConstructor.load()
        .then(function (client) {
          if (!client) { return null; }
          // Over-ask by the cart size: anything already in the cart is dropped
          // below, and the carousel should still reach its limit.
          var params = { numResults: limit + inCart.length, section: 'Products' };
          /* Complementary and similar-item pods need something to work from, and
             "Pairs perfectly with" is about the most recent line, so that's the seed.

             Seeded with the SKU, not the handle: Constructor's catalogue is keyed on
             variant SKU, so a handle here matched no item and those strategies had
             nothing to work from. The handle is still what excludes the seeded product
             from the results below, because that comparison is against the cards. */
          if (sku) { params.itemIds = [sku]; }
          return client.recommendations.getRecommendations(pod, params);
        })
        .then(function (res) {
          var results = (res && res.response && res.response.results) || [];
          var handles = [];
          // Strategy id is per item, and the cards come back from Liquid, which cannot
          // know it - so it is kept here and stamped on after each card is parsed.
          var strategies = {};
          results.forEach(function (item) {
            /* The handle comes from the indexed url, not data.id: the index is keyed on
               variant SKU, so using the id here asked Shopify for /products/<sku> and
               every card 404'd, which emptied the list and hid the whole carousel. */
            var id = window.esrConstructor.productHandle(item);
            // Never recommend the product the pod was seeded with, nor anything
            // else already in the cart, and stop once the limit is met.
            if (id && id !== handle && inCart.indexOf(id) === -1 && handles.indexOf(id) === -1 && handles.length < limit) {
              handles.push(id);
              strategies[id] = (item.strategy && item.strategy.id) || '';
            }
          });
          if (!handles.length) { el.hidden = true; return null; }

          return Promise.all(handles.map(function (h) {
            return fetch(root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?section_id=cart-recommendation-card', {
              headers: { Accept: 'text/html' }
            })
              .then(function (r) { return r.ok ? r.text() : ''; })
              .catch(function () { return ''; });
          })).then(function (chunks) {
            list.innerHTML = '';
            // Index-aligned with handles: a failed fetch drops its card without
            // shifting the rest, so strategies still line up.
            chunks.forEach(function (html, i) {
              var trimmed = (html || '').trim();
              if (!trimmed) { return; }
              var frag = parseHtml(trimmed);
              var wrapper = frag.querySelector('.shopify-section');
              var card = (wrapper || frag).querySelector('.cart-rec');
              if (!card) { return; }
              var strategy = strategies[handles[i]];
              if (strategy) { card.setAttribute('data-cnstrc-strategy-id', strategy); }
              list.appendChild(card);
            });
            if (!list.children.length) { el.hidden = true; return; }
            /* Tagged only now, with cards actually in the list: the Shopify source
               fills the same list and must not be reported as a pod result. Seeded with
               the most recent cart line, which is what the request used. */
            window.esrConstructor.tagRecommendations(list, {
              podId: pod,
              resultId: res.result_id,
              numResults: res.response && res.response.total_num_results,
              // The item_ids actually sent, so the SKU rather than the handle.
              seedItems: sku || null
            });
            el.hidden = false;
            setupRecsCarousel(el);
          });
        })
        .catch(function () { el.hidden = true; });
    }

    function fetchRecs(el, productId, handle, sku) {
      if (el.getAttribute('data-recs-engine') === 'constructor') {
        fetchConstructorRecs(
          el,
          handle || el.getAttribute('data-product-handle'),
          sku || el.getAttribute('data-product-sku')
        );
        return;
      }
      var recsUrl = el.getAttribute('data-recs-url');
      var limit = parseInt(el.getAttribute('data-limit'), 10) || 6;
      var list = el.querySelector('[data-cart-recs-list]');
      if (!recsUrl || !productId || !list) { el.hidden = true; return; }
      recsProductId = productId;
      var inCart = cartHandles();
      // Over-ask by the cart size so the carousel still fills after in-cart
      // products are pruned; the recommendations API serves at most 10.
      var ask = Math.min(10, limit + inCart.length);
      fetch(recsUrl + '?section_id=cart-recommendations&product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(ask) + '&intent=related', {
        headers: { Accept: 'text/html' }
      })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var trimmed = (html || '').trim();
          if (!trimmed) { el.hidden = true; return; }
          // Unwrap the Section Rendering API's shopify-section wrapper so the
          // .cart-rec cards are direct children of the track (the flex / mobile
          // rules target them).
          var frag = parseHtml(trimmed);
          var section = frag.querySelector('.shopify-section');
          list.innerHTML = section ? section.innerHTML.trim() : trimmed;
          pruneRecCards(list, inCart, limit);
          if (!list.children.length) { el.hidden = true; return; }
          el.hidden = false;
          setupRecsCarousel(el);
        })
        .catch(function () { el.hidden = true; });
    }

    function initCartRecs() {
      var el = document.querySelector('[data-cart-recs]');
      if (!el || el.__recsInit) { return; }
      el.__recsInit = true;
      fetchRecs(el, el.getAttribute('data-product-id'), el.getAttribute('data-product-handle'));
    }

    // Re-fetch for the most recent line (last in the DOM). Pass force=true to
    // refetch even if the last product is unchanged (used after a rec is added).
    function refreshRecs(force) {
      var el = document.querySelector('[data-cart-recs]');
      if (!el) { return; }
      var lines = document.querySelectorAll('[data-cart-line]');
      if (!lines.length) { return; }
      var last = lines[lines.length - 1];
      var lastId = last.getAttribute('data-product-id');
      var lastHandle = last.getAttribute('data-product-handle');
      // The pod is seeded with this line's SKU, which is what the index is keyed on.
      var lastSku = last.getAttribute('data-product-sku');
      // The Constructor path is keyed on the handle, the Shopify one on the id,
      // so compare against whichever fetchRecs stored.
      var key = lastId;
      if (el.getAttribute('data-recs-engine') === 'constructor') { key = lastHandle; }
      if (key && (force || key !== recsProductId)) {
        var list = el.querySelector('[data-cart-recs-list]');
        if (list) { list.innerHTML = ''; }
        el.hidden = true;
        fetchRecs(el, lastId, lastHandle, lastSku);
      }
    }

    function initCartItems(root) {
      if (root.__cartBound) { return; }
      root.__cartBound = true;

      var sectionId = root.getAttribute('data-section-id');
      var changeUrl = root.getAttribute('data-cart-change-url');
      var addUrl = root.getAttribute('data-cart-add-url');

      // Set while this section is the one making the change, so the
      // cart:updated listener below ignores its own notification rather than
      // refetching a section it has just rendered. Dispatch is synchronous, so
      // clearing it straight after is enough to cover the whole handler.
      var selfUpdating = false;

      function notify() {
        selfUpdating = true;
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { open: false } }));
        selfUpdating = false;
      }

      function syncCompact(doc) {
        // The rows are re-rendered by swapping this element's innerHTML, so the
        // element's OWN attributes are never refreshed. data-compact is computed
        // from the line count - precisely what a quantity change or a removal
        // alters - so without this it would keep whatever the page was first
        // loaded with and the layout would not follow the cart across the
        // threshold. Read from the same fresh section markup as the rows.
        var fresh = doc.querySelector('[data-cart-items]');
        if (!fresh) { return; }
        var value = fresh.getAttribute('data-compact');
        if (value === null) { root.removeAttribute('data-compact'); }
        else { root.setAttribute('data-compact', value); }
      }

      function syncShipment(doc) {
        // The shipment header sits outside [data-cart-items], so the line
        // re-render above does not touch it: swap the server-rendered item count
        // from the fresh section, then recalculate the timings for the new set
        // of lines (quantity changes can remove the slowest item entirely).
        var scope = root.closest('.shopify-section') || document;
        initShipment();
      }

      function syncTotals(doc) {
        // Scope to THIS section: the cart drawer (globally present, earlier in
        // the DOM) carries the same data-cart-total / data-cart-discount-row
        // hooks, so an unscoped document.querySelector wrote the fresh values
        // into the drawer's summary and left the page's summary stale.
        var scope = root.closest('.shopify-section') || document;
        // [data-cart-discounts] holds the itemised applied-discount rows -
        // swapping its innerHTML replaces the whole set (rows appear and
        // disappear as offers apply), no hidden toggling needed.
        ['[data-cart-subtotal]', '[data-cart-total]', '[data-cart-discounts]', '[data-cart-estimate-note]', '[data-cart-status-note]'].forEach(function (sel) {
          var src = doc.querySelector(sel);
          var dst = scope.querySelector(sel);
          if (src && dst) { dst.innerHTML = src.innerHTML; }
        });

        /* Home Club message (#19500422). Whether it applies depends on the cart,
           so it has to follow every change rather than only a full page load.
           Only the hidden state is copied, never the markup: the non-member copy
           hosts the Shopify Forms embed, and replacing that node would destroy
           the app's listeners (see placeHcForm, which MOVES the node for exactly
           that reason). The server render stays the source of truth for the
           decision. */
        var freshHc = doc.querySelectorAll('[data-hc]');
        var liveHc = scope.querySelectorAll('[data-hc]');
        if (freshHc.length === liveHc.length) {
          for (var h = 0; h < liveHc.length; h++) {
            liveHc[h].hidden = freshHc[h].hidden;
          }
        }
      }

      /* Tighten the stepper to what Shopify actually allowed, so the shopper
         cannot walk straight back into the same refusal. The number comes from
         Shopify's own message ("Only 210 items were added to your cart due to
         availability") because there is nothing else that reports it: the
         metafield composite the max is rendered from can be higher than what the
         cart will sell, and no Liquid field exposes the real ceiling. If the
         message carries no number the max is left as it was rather than guessed
         at. Lives only until the next page load, which re-renders from Liquid. */
      function tightenLineMax(key, message) {
        var found = String(message || '').match(/(\d[\d,]*)/);
        if (!found) { return; }
        var allowed = parseInt(found[1].replace(/,/g, ''), 10);
        if (isNaN(allowed) || allowed < 0) { return; }
        var line = root.querySelector('[data-cart-line][data-key="' + key + '"]');
        var input = line && line.querySelector('[data-quantity-input]');
        if (!input) { return; }
        var stepper = input.closest('[data-quantity]');
        input.max = allowed;
        if (parseInt(input.value, 10) > allowed) { input.value = allowed; }
        /* Disable the stepper buttons here rather than calling the quantity
           snippet's own esQuantitySync. That is declared in a DIFFERENT
           compiled javascript block, and whether one block can see another's
           top-level functions depends on how Shopify concatenates the bundle -
           the typeof guard this used to carry meant a silent no-op when it could
           not, which is why the + stayed enabled. Doing it inline is a few lines
           and cannot fail that way. Not dispatching 'change' either: that would
           re-enter the cart's own handler and post the value straight back. */
        var val = parseInt(input.value, 10) || 0;
        var min = input.min !== '' ? parseInt(input.min, 10) : null;
        var dec = stepper && stepper.querySelector('[data-quantity-decrease]');
        var inc = stepper && stepper.querySelector('[data-quantity-increase]');
        if (inc) { inc.disabled = val >= allowed; }
        if (dec && min !== null) { dec.disabled = val <= min; }
      }

      /* Show why a quantity was refused, on the line it belongs to, and clear any
         message on every other line so a stale one cannot linger. */
      function showLineRefusal(key, message) {
        root.querySelectorAll('[data-cart-line]').forEach(function (line) {
          var el = line.querySelector('[data-cart-line-error]');
          if (!el) { return; }
          if (line.getAttribute('data-key') === key && message) {
            el.textContent = message;
            el.hidden = false;
          } else {
            el.textContent = '';
            el.hidden = true;
          }
        });
      }

      function change(key, quantity, groupKeys) {
        root.classList.add('is-updating');
        var refusal = '';
        /* groupKeys = a Mix & Match group (#741): every line key in ONE
           /cart/update.js call so the group moves atomically. `key` stays the
           first line's key for refusal targeting. */
        var url = changeUrl;
        var body;
        if (groupKeys && groupKeys.length) {
          var updates = {};
          groupKeys.forEach(function (k) { if (k) { updates[k] = quantity; } });
          url = root.getAttribute('data-cart-update-url') || changeUrl.replace('/change', '/update');
          body = { updates: updates, sections: sectionId, sections_url: window.location.pathname };
        } else {
          body = { id: key, quantity: quantity, sections: sectionId, sections_url: window.location.pathname };
        }
        return postJSON(url, body, function (message) { refusal = message; }).then(function (cart) {
          if (!cart) {
            /* Refused (or the request failed). Re-render from the server so the
               stepper snaps back to the quantity the cart actually holds - the
               typed value stays on screen otherwise - then say why. The refusal
               is written AFTER the re-render, since that replaces the line and
               would wipe a message written before it. */
            root.classList.remove('is-updating');
            /* Re-render whether or not a reason came back. The page must never be
               left showing a quantity the cart does not hold, and relying on a
               message being present is exactly what failed before. */
            return refreshFromServer().then(function () {
              /* After the re-render, so neither is wiped by it. */
              tightenLineMax(key, refusal);
              showLineRefusal(key, refusal);
              return null;
            });
          }
          showLineRefusal(key, '');
          if (cart.item_count === 0) { window.location.reload(); return cart; }
          var html = cart.sections && cart.sections[sectionId];
          if (html) {
            var doc = parseHtml(html);
            // Re-render the lines (not just the totals) so a Function discount
            // kicking in or out shows immediately on the line - struck price,
            // applied badge, discount label - matching the drawer's full
            // refresh. Handlers are delegated on this element, so they survive.
            var fresh = doc.querySelector('[data-cart-items]');
            if (fresh) { syncCompact(doc); root.innerHTML = fresh.innerHTML; }
            syncTotals(doc);
            syncShipment(doc);
          }
          notify();
          root.classList.remove('is-updating');
          return cart;
        }).catch(function () {
          root.classList.remove('is-updating');
        });
      }

      function remove(lineEl) {
        // Each line is followed by its own divider <hr>; drop both together.
        // A Mix & Match group card removes every line of the group at once.
        var hr = lineEl.nextElementSibling;
        var mmKeys = lineEl.hasAttribute('data-mm-keys') ? lineEl.getAttribute('data-mm-keys').split('||') : null;
        change(lineEl.getAttribute('data-key'), 0, mmKeys).then(function (cart) {
          if (cart && cart.item_count > 0) {
            lineEl.remove();
            if (hr && hr.classList.contains('cart-line__divider')) { hr.remove(); }
          }
          refreshRecs();
        });
      }

      // Save for later: open theWishlist's list-selection modal, and only remove
      // the line once the item is confirmed in a list. The app fires no "added"
      // event, so poll checkVariantInWishlist; if the modal is dismissed without
      // adding, it never confirms and the item stays in the cart.
      function saveForLater(lineEl) {
        var wl = lineEl.querySelector('.button-collection-wishlist');
        if (!wl) { return; }
        var variantId = lineEl.getAttribute('data-variant-id');
        if (inWishlist(variantId)) { remove(lineEl); return; }
        // (Re)open the app's list-selection modal on every click. The Save button
        // is never disabled, so it can be clicked again after a dismissal.
        wl.click();
        // Only one poll per line; a re-click just re-opens the modal above.
        if (lineEl.__savePolling) { return; }
        lineEl.__savePolling = true;
        var start = Date.now();
        var poll = window.setInterval(function () {
          if (inWishlist(variantId)) {
            window.clearInterval(poll);
            lineEl.__savePolling = false;
            remove(lineEl);
          } else if (Date.now() - start > 120000) {
            window.clearInterval(poll);
            lineEl.__savePolling = false;
          }
        }, 400);
      }

      root.addEventListener('change', function (e) {
        var input = e.target.closest('[data-quantity-input]');
        if (!input) { return; }
        var lineEl = input.closest('[data-cart-line]');
        if (!lineEl) { return; }
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) { qty = 0; }
        // Quantity 0 removes the line (and its divider) rather than setting it to 1.
        if (qty <= 0) { remove(lineEl); }
        else if (lineEl.hasAttribute('data-mm-keys')) {
          change(lineEl.getAttribute('data-key'), qty, lineEl.getAttribute('data-mm-keys').split('||'));
        }
        else { change(lineEl.getAttribute('data-key'), qty); }
      });

      root.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) {
          var rl = removeBtn.closest('[data-cart-line]');
          /* Ask first (#19643715). esCartConfirm resolves false on Escape, the
             cancel button and the backdrop, so anything other than the confirm
             button leaves the line alone. */
          if (rl) {
            window.esCartConfirm().then(function (ok) { if (ok) remove(rl); });
          }
          return;
        }
        var saveBtn = e.target.closest('[data-cart-save]');
        if (saveBtn) {
          var sl = saveBtn.closest('[data-cart-line]');
          if (sl) { saveForLater(sl); }
          return;
        }
      });

      /* Re-render from the server after a cart change made ANYWHERE ELSE.
         Until now this section only re-rendered when its own controls ran, so a
         change from the cart drawer (or add-to-cart on a product page, with the
         cart page open in another tab) left it showing the old cart until a
         manual refresh: removed lines still listed, stale shipment groups, and a
         delivery estimate for an item no longer in the basket (#19500395).

         Deliberately POSTs nothing. It re-fetches this section and re-syncs, so
         it cannot dispatch cart:updated itself - which is what would otherwise
         make this and the drawer's own listener trigger each other endlessly.

         An empty cart reloads instead: the section renders a different branch
         with no [data-cart-items] at all, so there is nothing to swap into. */
      function refreshFromServer() {
        return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId),
          { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) { return; }
            var doc = parseHtml(html);
            if (!doc.querySelector('[data-cart-line]')) { window.location.reload(); return; }
            var fresh = doc.querySelector('[data-cart-items]');
            if (fresh) { syncCompact(doc); root.innerHTML = fresh.innerHTML; }
            syncTotals(doc);
            syncShipment(doc);
            refreshRecs();
          })
          .catch(function () {});
      }

      document.addEventListener('cart:updated', function () {
        if (selfUpdating) { return; }
        refreshFromServer();
      });

      // The recommendation "Add" buttons live in <cart-recs>, a SIBLING of this
      // <cart-items> element, so their clicks never bubble through it - listen on
      // the document. Adding re-renders the line items (Cart Sections API) so the
      // new line appears without a page refresh, then updates the totals + recs.
      document.addEventListener('click', function (e) {
        var addBtn = e.target.closest('[data-cart-rec-add]');
        if (!addBtn) { return; }
        var vid = addBtn.getAttribute('data-variant-id');
        if (!vid) { return; }
        addBtn.disabled = true;
        root.classList.add('is-updating');
        // Bulky goods (#901): carry the private _bulky line property through so
        // the checkout can show the two-person lift message on lines added from
        // here, exactly as it does for a PDP or quick add.
        var recLine = { id: vid, quantity: 1 };
        if (addBtn.getAttribute('data-bulky') === 'true') {
          recLine.properties = { _bulky: 'true' };
        }
        postJSON(addUrl, {
          items: [recLine],
          sections: sectionId,
          sections_url: window.location.pathname
        }).then(function (res) {
          addBtn.disabled = false;
          root.classList.remove('is-updating');
          if (!res) { return; }
          var html = res.sections && res.sections[sectionId];
          if (html) {
            var doc = parseHtml(html);
            var fresh = doc.querySelector('[data-cart-items]');
            if (fresh) { syncCompact(doc); root.innerHTML = fresh.innerHTML; }
            syncTotals(doc);
            syncShipment(doc);
            // The added item is now the most recent; refresh the carousel to it.
            refreshRecs(true);
          }
          notify();
        }).catch(function () {
          addBtn.disabled = false;
          root.classList.remove('is-updating');
        });
      });
    }

    // The Home Club form (Shopify Forms app block) can only render once, so it
    // lives in one embed and is moved into whichever Home Club copy is visible:
    // the mobile-top copy below 1104px, the summary copy on desktop. Moving the
    // node preserves the app's listeners.
    var hcFormMql = null;
    function placeHcForm() {
      var mobileEmbed = document.querySelector('.cart-hc--top [data-hc-embed]');
      var desktopEmbed = document.querySelector('.cart__summary [data-hc-embed]');
      if (!mobileEmbed || !desktopEmbed) { return; }
      var mobile = window.matchMedia('(max-width: 1103px)').matches;
      var from = mobile ? desktopEmbed : mobileEmbed;
      var to = mobile ? mobileEmbed : desktopEmbed;
      if (from === to || !from.firstChild) { return; }
      while (from.firstChild) { to.appendChild(from.firstChild); }
    }
    function initHcFormPlacement() {
      placeHcForm();
      if (!hcFormMql && window.matchMedia) {
        hcFormMql = window.matchMedia('(max-width: 1103px)');
        if (hcFormMql.addEventListener) { hcFormMql.addEventListener('change', placeHcForm); }
        else if (hcFormMql.addListener) { hcFormMql.addListener(placeHcForm); }
      }
    }

    // Lazily load the Google Maps JS (Places library) once per page, reusing an
    // in-flight or already-loaded instance (e.g. from the store locator) so the
    // API script is never injected twice.
    function ensureMaps(key, cb) {
      if (window.google && window.google.maps && window.google.maps.places) { cb(); return; }
      (window.__esMapsWaiters = window.__esMapsWaiters || []).push(cb);
      if (window.__esMapsLoading) { return; }
      window.__esMapsLoading = true;
      function flush() {
        var w = window.__esMapsWaiters || [];
        window.__esMapsWaiters = [];
        w.forEach(function (f) { f(); });
      }
      if (document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) {
        var poll = window.setInterval(function () {
          if (window.google && window.google.maps && window.google.maps.places) { window.clearInterval(poll); flush(); }
        }, 100);
        return;
      }
      window.__esMapsReady = flush;
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&callback=__esMapsReady';
      s.async = true;
      document.head.appendChild(s);
    }

    function cartPostcodeFromComponents(components) {
      if (!components) { return ''; }
      for (var i = 0; i < components.length; i++) {
        var types = components[i].types || [];
        if (types.indexOf('postal_code') !== -1) { return components[i].longText || components[i].long_name || ''; }
      }
      return '';
    }

    /* Suburb from geocoder address components, for the geolocation path where
       there is no prediction to read a name from. Prefers a locality and falls
       back to a sublocality, which is what carries NZ suburbs. */
    function cartLocalityFromComponents(components) {
      if (!components) { return ''; }
      var fallback = '';
      for (var i = 0; i < components.length; i++) {
        var types = components[i].types || [];
        if (types.indexOf('locality') !== -1) { return components[i].long_name || components[i].longText || ''; }
        if (!fallback && (types.indexOf('sublocality') !== -1 || types.indexOf('sublocality_level_1') !== -1)) {
          fallback = components[i].long_name || components[i].longText || '';
        }
      }
      return fallback;
    }

    // Persisted location, shared with the PDP store locator + store locator page
    // (localStorage 'es:store-locator'). The resolved postcode is the canonical
    // value we store and display everywhere. Reading it here lets a location the
    // customer set on any of those surfaces carry into the cart, and writing it back
    // means a location set in the cart carries the other way too. Only the postcode
    // is touched - the chosen store (index/name) is left intact.
    var LOCATION_KEY = 'es:store-locator';
    function loadLocation() {
      try { return JSON.parse(window.localStorage.getItem(LOCATION_KEY)) || {}; }
      catch (e) { return {}; }
    }
    function saveLocation(st) {
      try { window.localStorage.setItem(LOCATION_KEY, JSON.stringify(st)); } catch (e) {}
    }
    /* 'display' is the suburb shown in messages on the other surfaces, most
       visibly the PDP "Delivery to ..." row (#19498861). This used to delete it
       outright, so setting a location here made that row fall back to showing a
       postcode while setting the same location on the PDP showed a suburb. It
       is written through now so the wording holds whichever surface was used. */
    function writeLocation(pc, display) {
      var st = loadLocation();
      if (pc) { st.postcode = pc; } else { delete st.postcode; }
      if (display) { st.label = display; } else { delete st.label; }
      saveLocation(st);
    }

    /* Suburb name from a Places prediction - see the fuller note on
       suburbFromPrediction in blocks/product-store-locator.liquid. For a suburb
       it is the main text; for a postcode the main text IS the postcode and the
       suburb sits at the front of the secondary text. */
    function cartSuburbFromPrediction(pred) {
      if (!pred) { return ''; }
      var main = pred.mainText && pred.mainText.text ? pred.mainText.text : '';
      var secondary = pred.secondaryText && pred.secondaryText.text ? pred.secondaryText.text : '';
      var name = main;
      if (/^\d+$/.test(main.replace(/\s/g, ''))) { name = secondary; }
      name = name.split(',')[0];
      return name.replace(/\s+(VIC|NSW|QLD|SA|WA|TAS|ACT|NT)$/i, '').trim();
    }
    function clearLocation() {
      var st = loadLocation();
      delete st.postcode;
      delete st.label;
      saveLocation(st);
    }

    // Postcode field: Google Places autocomplete. Type a suburb / postcode, pick a
    // suggestion, and the resolved postal code fills the field. Only active when a
    // Maps key is configured (the markup adds data-maps-key + the suggestions list).
    function initPostcodeAutocomplete() {
      var input = document.querySelector('[data-cart-postcode]');
      if (!input || input.__acInit) { return; }

      // Pre-fill from any location persisted by the PDP store locator / store
      // locator page so the customer never has to re-enter it here.
      var saved = loadLocation();
      if (saved.postcode && !input.value) {
        input.value = saved.postcode;
        input.setAttribute('data-postcode', saved.postcode);
      }

      var wrap = input.closest('.cart-summary__postcode');
      var key = wrap ? wrap.getAttribute('data-maps-key') : '';
      var listbox = wrap ? wrap.querySelector('[data-cart-postcode-suggestions]') : null;
      if (!key || !listbox) { return; }
      input.__acInit = true;

      var places = null, token = null, debounce = null;
      var suggestions = [], activeIndex = -1;
      /* Country restriction from the "Limit address results to countries"
         theme setting. Blank means no restriction (worldwide results). */
      var regions = (wrap.getAttribute('data-maps-regions') || '')
        .split(',')
        .map(function (c) { return c.trim().toLowerCase(); })
        .filter(function (c) { return c.length === 2; })
        .slice(0, 15);

      function closeList() {
        listbox.hidden = true;
        listbox.innerHTML = '';
        suggestions = [];
        activeIndex = -1;
        input.setAttribute('aria-expanded', 'false');
      }
      function highlight() {
        var items = listbox.children;
        for (var i = 0; i < items.length; i++) { items[i].classList.toggle('is-active', i === activeIndex); }
      }
      function choose(sugg) {
        var pred = sugg && sugg.placePrediction;
        if (!pred) { return; }
        var label = pred.text ? pred.text.text : '';
        var place = pred.toPlace();
        place.fetchFields({ fields: ['addressComponents'] }).then(function () {
          var pc = cartPostcodeFromComponents(place.addressComponents);
          // Show the resolved postcode (this field IS the postcode); only fall back
          // to the suburb text when the place has no postal code to resolve.
          if (pc) {
            input.value = pc;
            input.setAttribute('data-postcode', pc);
          } else {
            if (label) { input.value = label; }
            input.removeAttribute('data-postcode');
          }
          // Persist to the shared location so PDP / store locator stay in sync,
          // including the suburb the other surfaces show in their messages.
          writeLocation(pc, cartSuburbFromPrediction(pred) || label);
          token = null;
          closeList();
          input.dispatchEvent(new CustomEvent('cart:postcode-change', { bubbles: true, detail: { postcode: pc, label: label } }));
        }).catch(function () {});
      }
      function renderSuggestions(res) {
        suggestions = res || [];
        activeIndex = -1;
        listbox.innerHTML = '';
        suggestions.forEach(function (sugg) {
          var pred = sugg.placePrediction;
          if (!pred) { return; }
          var li = document.createElement('li');
          li.className = 'cart-summary__postcode-item';
          li.setAttribute('role', 'option');
          li.textContent = pred.text ? pred.text.text : '';
          li.addEventListener('mousedown', function (ev) { ev.preventDefault(); choose(sugg); });
          listbox.appendChild(li);
        });
        var has = listbox.children.length > 0;
        listbox.hidden = !has;
        input.setAttribute('aria-expanded', has ? 'true' : 'false');
      }
      function showSkeleton() {
        listbox.innerHTML = '';
        for (var i = 0; i < 4; i++) {
          var li = document.createElement('li');
          li.className = 'cart-summary__postcode-item cart-summary__postcode-item--skeleton';
          li.setAttribute('aria-hidden', 'true');
          var bar = document.createElement('span');
          bar.className = 'cart-summary__postcode-skeleton';
          li.appendChild(bar);
          listbox.appendChild(li);
        }
        listbox.hidden = false;
      }
      function fetchSuggestions(value) {
        if (!places) { return; }
        if (!token) { token = new places.AutocompleteSessionToken(); }
        showSkeleton();
        // Results are limited to the countries set in theme settings; blank
        // returns all locations. Non-deliverable addresses within those
        // countries are validated/messaged separately.
        /* Postcode, suburb and state - see the note in sections/store-locator.liquid.
           sublocality is what carries NZ suburbs; without it they return nothing.
           Kept in step with the other two searches even though this field is
           currently parked (snippets/cart-summary-delivery.liquid), so it is
           already correct whenever that snippet is rendered again. */
        var req = { input: value, sessionToken: token, includedPrimaryTypes: ['postal_code', 'locality', 'sublocality', 'administrative_area_level_1'] };
        if (regions.length) { req.includedRegionCodes = regions; }
        places.AutocompleteSuggestion.fetchAutocompleteSuggestions(req).then(function (res) {
          renderSuggestions(res && res.suggestions ? res.suggestions : []);
        }).catch(function () { closeList(); });
      }
      function ready() {
        places = window.google.maps.places;
        if (!places || !places.AutocompleteSuggestion || !places.AutocompleteSessionToken) { places = null; return; }
        var pending = input.value.trim();
        if (pending.length >= 3) { fetchSuggestions(pending); }
      }

      input.addEventListener('focus', function () { ensureMaps(key, ready); }, { once: true });
      input.addEventListener('input', function () {
        // Typing invalidates a previously-resolved postcode.
        input.removeAttribute('data-postcode');
        var value = input.value.trim();
        window.clearTimeout(debounce);
        if (value.length < 3) { closeList(); return; }
        if (!places) { ensureMaps(key, ready); return; }
        debounce = window.setTimeout(function () { fetchSuggestions(value); }, 200);
      });

      var clearBtn = wrap.querySelector('[data-cart-postcode-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          input.removeAttribute('data-postcode');
          clearLocation();
          closeList();
          input.focus();
        });
      }

      /* "Use my current location" - the same control the store locator page and
         the PDP drawer offer, so all three location searches behave alike
         (#19498861).

         Those two can stop at coordinates because they measure distance to a
         store. This field IS the postcode, so the coordinates have to be
         reverse geocoded before there is anything to show or to share with the
         other surfaces. The first result carrying a postal_code component wins;
         the nearest result is sometimes a building with no postcode on it.

         Failures are deliberately silent. A dismissed or denied permission
         prompt is the shopper answering the question, not an error worth
         reporting back at them, and typing a postcode still works either way. */
      var geoBtn = wrap.querySelector('[data-cart-postcode-geo]');
      if (geoBtn) {
        /* The press can sit for several seconds - the browser's own permission
           prompt, then the fix, then the Maps script load and the geocode - with
           nothing on screen to say it landed (#19500365). For that whole wait the
           button swaps its icon for a spinner, matching the two store locator
           location buttons.

           cartGeoDone() is idempotent and runs on EVERY exit: no geocoder, a
           geocode that failed or came back empty, no postcode in the result, the
           confirmation prompt appearing, and a denied or dismissed permission. It
           also runs on a watchdog, because getCurrentPosition has no timeout of
           its own and an unanswered permission prompt would otherwise leave the
           button spinning forever.

           Scoped to this button rather than every cart geo button on the page:
           the cart page and the cart drawer each render their own field, with
           their own lookup, so they are not a shared state the way the product
           page's inline and drawer buttons are. */
        var cartGeoTimer = null;
        var cartGeoDone = function () {
          if (cartGeoTimer) { window.clearTimeout(cartGeoTimer); cartGeoTimer = null; }
          geoBtn.classList.remove('is-loading');
          geoBtn.removeAttribute('aria-busy');
        };
        var cartGeoBusy = function () {
          geoBtn.classList.add('is-loading');
          geoBtn.setAttribute('aria-busy', 'true');
          if (cartGeoTimer) { window.clearTimeout(cartGeoTimer); }
          cartGeoTimer = window.setTimeout(cartGeoDone, 20000);
        };
        geoBtn.addEventListener('click', function () {
          if (!navigator.geolocation) { return; }
          /* Already pending: ignore the repeat press rather than starting a
             second lookup behind the first. */
          if (geoBtn.classList.contains('is-loading')) { return; }
          cartGeoBusy();
          navigator.geolocation.getCurrentPosition(function (pos) {
            ensureMaps(key, function () {
              if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
                cartGeoDone();
                if (window.esLocationPrompt) { window.esLocationPrompt.notify('failed'); }
                return;
              }
              var at = { lat: pos.coords.latitude, lng: pos.coords.longitude };
              new window.google.maps.Geocoder().geocode({ location: at }, function (results, status) {
                if (status !== 'OK' || !results || !results.length) {
                  cartGeoDone();
                  if (window.esLocationPrompt) { window.esLocationPrompt.notify('failed'); }
                  return;
                }
                var pc = '', suburb = '';
                for (var i = 0; i < results.length && !pc; i++) {
                  pc = cartPostcodeFromComponents(results[i].address_components);
                }
                for (var j = 0; j < results.length && !suburb; j++) {
                  suburb = cartLocalityFromComponents(results[j].address_components);
                }
                if (!pc) {
                  cartGeoDone();
                  if (window.esLocationPrompt) { window.esLocationPrompt.notify('failed'); }
                  return;
                }
                /* Confirm before applying, the same as the store locators
                   (#19498854). The prompt is merchant content and can be absent
                   from a store, so a missing one applies the location directly
                   rather than doing nothing at all. */
                var apply = function () {
                  input.value = pc;
                  input.setAttribute('data-postcode', pc);
                  writeLocation(pc, suburb);
                  closeList();
                  input.dispatchEvent(new CustomEvent('cart:postcode-change', {
                    bubbles: true,
                    detail: { postcode: pc, label: suburb || pc }
                  }));
                };
                if (!window.esLocationPrompt) { cartGeoDone(); apply(); return; }
                /* Cleared as the prompt opens, NOT when it is answered - the wait
                   is over the moment there is something to look at. */
                cartGeoDone();
                window.esLocationPrompt
                  .confirm({ suburb: suburb, postcode: pc })
                  .then(function (ok) { if (ok) { apply(); } });
              });
            });
          }, function () {
            // Blocked, dismissed, or timed out.
            cartGeoDone();
            if (window.esLocationPrompt) { window.esLocationPrompt.notify('denied'); }
          });
        });
      }
      input.addEventListener('keydown', function (e) {
        if (listbox.hidden || !listbox.children.length) { return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); activeIndex = Math.min(activeIndex + 1, listbox.children.length - 1); highlight(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); activeIndex = Math.max(activeIndex - 1, 0); highlight(); }
        else if (e.key === 'Enter') { if (activeIndex >= 0 && suggestions[activeIndex]) { e.preventDefault(); choose(suggestions[activeIndex]); } }
        else if (e.key === 'Escape') { closeList(); }
      });
      input.addEventListener('blur', function () { window.setTimeout(closeList, 150); });
    }

    // ----- Shipment header + delivery estimate -----
    // The calculation, the wording and the honest limitations all live in
    // assets/cart-shipment.js, shared with the cart drawer so the two surfaces
    // can never quote different dates for the same cart. Everything is scoped
    // to this section's root: the drawer is globally present and carries the
    // same [data-cart-line] hook, so an unscoped query would count every line
    // twice and could read the drawer's copies.
    function initShipment() {
      var root = document.querySelector('.cart[data-cart-eta]');
      if (!root) { return; }
      // cart-shipment.js is deferred and this section's script can run first,
      // so wait for it rather than giving up (guaranteed by window load).
      if (!window.ESCartShipment) {
        if (!initShipment.waiting) {
          initShipment.waiting = true;
          window.addEventListener('load', function () { initShipment.waiting = false; initShipment(); }, { once: true });
        }
        return;
      }
      window.ESCartShipment.render(root, '[cart]');
    }

    function init() {
      document.querySelectorAll('[data-hc]').forEach(initHomeClub);
      var bar = document.querySelector('[data-cart-sticky]');
      if (bar) { initStickyCta(bar); }
      var items = document.querySelector('[data-cart-items]');
      if (items) { initCartItems(items); }
      initCartRecs();
      initHcFormPlacement();
      initPostcodeAutocomplete();
      initShipment();
    }

    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-toggle"] && !Shopify.designMode) return;
  try {
    
  // Category Toggle: hovering/focusing a category activates it (label colour +
  // arrow) and crossfades the matching media slide. Links navigate natively on
  // click, so this is pure enhancement; with JS off the first slide shows via
  // CSS and every link still works. Activation is sticky - the last activated
  // category stays until another is hovered/focused.
  (function () {
    // Videos render without an autoplay attribute; JS starts them only when their slide is
    // active AND the visitor has not asked for reduced motion (WCAG 2.2.2 /
    // 2.3.1). Reduced-motion visitors get the still first frame, never playback.
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(section) {
      var links = section.querySelectorAll('.category-toggle__link[data-index]');
      var slides = section.querySelectorAll('.category-toggle__slide[data-index]');
      if (!links.length || !slides.length) return;

      function activate(index) {
        links.forEach(function (link) {
          var on = link.getAttribute('data-index') === index;
          if (on) {
            link.setAttribute('data-active', '');
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('data-active');
            link.removeAttribute('aria-current');
          }
        });
        slides.forEach(function (slide) {
          var on = slide.getAttribute('data-index') === index;
          if (on) slide.setAttribute('data-active', '');
          else slide.removeAttribute('data-active');
          // A slide can hold a desktop and a mobile video; only play the one
          // visible at the current breakpoint, in the active slide, and only
          // when motion is allowed.
          slide.querySelectorAll('video').forEach(function (video) {
            if (on && video.offsetParent !== null && !reduceMotion.matches) {
              var playing = video.play();
              if (playing && playing.catch) playing.catch(function () {});
            } else {
              video.pause();
            }
          });
        });
      }

      links.forEach(function (link) {
        var index = link.getAttribute('data-index');
        link.addEventListener('mouseenter', function () { activate(index); });
        link.addEventListener('focus', function () { activate(index); });
      });

      // Start on the first active slide (set in Liquid) - play its video, pause
      // the rest.
      var active = section.querySelector('.category-toggle__slide[data-active]');
      activate(active ? active.getAttribute('data-index') : '0');
    }

    document.querySelectorAll('[data-category-toggle]').forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var BREAKPOINT = 1104;
    // Shopper display preferences (styled, desktop density, mobile columns),
    // shared by every collection rather than keyed per collection: choose the
    // 6-up view once and the next collection opens the same way.
    var PREFS_KEY = 'es:collection-prefs';

    function ready() {
      if (customElements.get('collection-grid')) return;

      customElements.define(
        'collection-grid',
        class extends HTMLElement {
          connectedCallback() {
            if (this.__init) return;
            this.__init = true;

            this.sectionId = this.getAttribute('data-section-id');
            this.baseUrl = this.getAttribute('data-base-url') || window.location.pathname;
            this.total = parseInt(this.getAttribute('data-total'), 10) || 0;
            this.showingTemplate = this.getAttribute('data-showing-template') || '';
            this.countTemplate = this.getAttribute('data-count-template') || '';
            this.defaultDensity = this.getAttribute('data-default-density') || '4';
            this.defaultMobileCols = this.getAttribute('data-default-mobile-cols') || '2';
            // Lights On mode: when the collection metafield enables it, the
            // styled toggle also dims the whole page via .lights-on on <html>.
            this.lightsMode = this.getAttribute('data-lights-mode') === 'true';
            // Styled view starts on for this collection unless the shopper has
            // explicitly turned it off before (see restoreState).
            this.styledDefault = this.getAttribute('data-styled-default') === 'true';

            this.grid = this.querySelector('[data-collection-grid]');
            /* Crawl links out of the layout now that this section is running.
               cnstrcFinish puts them back if Constructor never delivers. */
            this.syncCrawlNav(true);
            // Both bars (inline + floating) carry the same controls; treat them
            // collectively so either copy drives the same state.
            this.styledInputs = this.querySelectorAll('.collection__styled input');
            this.densityButtons = this.querySelectorAll('[data-density-set]');
            this.mobileColsButtons = this.querySelectorAll('[data-mobile-cols-set]');
            this.topBar = this.querySelector('.collection__bar--inline');
            this.floatingBar = this.querySelector('.collection__bar--floating');
            this.loadedPages = 1;

            // Constructor browse. When on, the grid arrives empty and every cell
            // in it is built here; when off, nothing below runs and the section
            // behaves exactly as it did before.
            this.cnstrc = this.getAttribute('data-cnstrc-engine') === 'constructor';
            this.cnstrcGroupId = this.getAttribute('data-cnstrc-group-id') || '';
            this.cnstrcPrune = this.hasAttribute('data-cnstrc-prune');
            this.perPage = parseInt(this.getAttribute('data-per-page'), 10) || 32;
            this.featuredHandles = this.getAttribute('data-featured-handles') || '';
            this.cnstrcPage = 0;
            this.cnstrcCount = 0;
            this.cnstrcReceived = 0;
            /* Whether the cells on screen are Constructor's or the server's.
               The grid boots server-rendered in BOTH modes (#18842099), and only a
               Constructor rebuild - a filter or sort change - hands it over. Paging
               has to follow whoever owns the cells: Shopify's paginate URLs for a
               server grid, Constructor's pages for a rebuilt one. Branching on
               `cnstrc` alone asked Constructor for page 1 while the server's page 1
               was still on screen, appending a duplicate of every result the two
               pages shared. */
            this.cnstrcOwnsGrid = false;
            /* Set by boot() below, once the shared facet module is available. */
            this.facets = null;

            this.desktop = window.matchMedia('(min-width: ' + BREAKPOINT + 'px)');

            this.bindDensity();
            this.bindMobileCols();
            this.bindStyled();
            this.bindLoadMore();
            this.bindBackNav();
            this.setupStickyBar();

            if (this.cnstrc) {
              this.cnstrcBoot();
              return;
            }

            this.restoreState();
          }

          /* The shared facet module arrives in the snippet bundle, which executes AFTER
             the section bundle this code lives in - so it cannot be reached at execute
             time. Deferred scripts all run before DOMContentLoaded, so it is guaranteed
             to exist by then. Filters and sort read from the URL inside create(), which
             is why the first request has to happen after this. */
          cnstrcBoot() {
            var self = this;
            var start = function () {
              if (window.esrFacets) {
                self.facets = window.esrFacets.create({
                  syncUrl: true,
                  onChange: function () { self.cnstrcRefilter(); }
                });
              }
              self.restoreState();
            };
            if (window.esrFacets) start();
            else document.addEventListener('DOMContentLoaded', start);
          }

          /* A filter or sort change replaces the result set rather than extending it, so
             the grid is emptied and paging starts again from one. */
          cnstrcRefilter() {
            /* The grid is NOT emptied here, which is the whole of #1185. It used to
               be - `textContent = ''` on the way in - so a sort or filter click
               blanked the grid to a spinner and held it blank until the last of ~32
               per-card renders arrived. The outgoing cells now stay where they are,
               dimmed, and are cleared at the last possible moment: when the first
               cell of the new set is ready to take their place (see cnstrcRender).
               A response that never arrives therefore leaves the shopper with the
               grid they had rather than an empty page. */
            /* The grid is about to be refilled by Constructor, so the server's
               counts stop being true for the duration. cnstrcFinish sets this back
               either way once the response lands. */
            var pagerBlock = this.querySelector('[data-collection-pagination]');
            if (pagerBlock) pagerBlock.hidden = true;
            this.cnstrcPage = 0;
            this.cnstrcCount = 0;
            this.cnstrcReceived = 0;
            /* From here the cells are Constructor's, so paging is too. */
            this.cnstrcOwnsGrid = true;
            /* Rebuild ticket. A shopper clicking through filters can have more than
               one browse request in flight, and only the newest may touch the grid -
               otherwise a slow earlier response lands on top of a later one. Same
               guard as the native facet controller in `shopify-facets`. */
            this.cnstrcSeq = (this.cnstrcSeq || 0) + 1;
            /* Callout templates are marked used so paging cannot insert them twice.
               Clearing the marks is what lets them come back into a rebuilt grid -
               without this the promo cards vanish on the first filter. */
            this.querySelectorAll('[data-cnstrc-callout]').forEach(function (tpl) {
              tpl.__used = false;
            });
            /* The loaded depth belonged to the previous result set. */
            this.writeParam('loaded', null);
            this.saveState();
            /* Dimmed, not hidden. `is-loading` takes the cells to zero opacity
               behind a spinner - what boot used to do until #20015335 took it out,
               and what would reproduce the blank grid here for the same reason.
               The outgoing cells stay legible instead. */
            this.grid.classList.add('is-rebuilding');
            this.cnstrcLoad();
          }

          /* ---- Constructor browse, on boot (Productive #18842099, #20015335) --
             The grid is SERVER RENDERED from collection.products. The sync worker is
             meant to write Constructor's order into the Shopify collection as MANUAL
             sort on a 6h cron, so that the Liquid order already is Constructor's
             order and this only had to correct the drift inside that window.

             This asked Constructor for the current order and moved the cells already
             on the page to match. It never built a card: only moved nodes. It does
             not move them any more - see below.

             Shopify membership wins, per the ticket's "managed at source":
             products Constructor ranks that are not in the collection are
             ignored, and rendered products Constructor does not rank keep their
             relative order at the tail.

             It no longer REORDERS on first load, and no longer gates the paint
             (#20015335). Both went together: the reorder was only tolerable because
             nothing was visible while it ran, and hiding the grid to run it cost
             ~3.5s of blank behind a spinner - the defect the client reported - plus
             LCP, since the first card's image was inside the hidden subtree.

             Dropping the gate without dropping the reorder would have been worse,
             not better. The sync's production cron went live 9 Sept 2026, but for
             NZ only and only across the 39 handles in SYNC_HANDLE_ALLOWLIST; on
             everything else - the rest of NZ, all of AU, staging on dry-run - the
             correction still moves 20-32 of 24-32 cells, so it would have traded a
             blank grid for the whole grid reshuffling under the shopper. On the
             handles the sync does cover it moves nothing at all, which is this job
             being done at the source, where it belongs.

             So on first load the server order stands. This still runs, for the two
             things it does that are not reordering: it fills the filter drawer from
             the browse response, and it stamps the result id the beacon needs on a
             server-rendered grid (#19361137) - the majority of traffic. Constructor
             owns the order from the first filter or sort on, where the grid is
             rebuilt wholesale anyway.

             Pruning is untouched: "Show only products Constructor returns" is an
             explicit opt-in to Constructor owning the visible set, and it is the one
             case where a DOM change on first load is unavoidable. When it drops
             cells the full sort still applies, callout anchoring included (#1197).
             Weigh what removing the gate does to it before switching it on: that
             change now lands AFTER paint, so the shopper watches the grid shrink
             and re-sort rather than never seeing it happen. It is off on all three
             stores today (settings.constructor_prune_unranked, default false).

             `done()` is kept as a defensive clear rather than removed: nothing on
             this path sets `is-loading` any more, but the rebuild paths still do. */
          cnstrcOrder() {
            var self = this;
            var done = function () {
              if (self.grid) self.grid.classList.remove('is-loading');
            };
            if (!this.grid || !window.esrConstructor || !this.cnstrcGroupId) return done();

            var cells = [].slice.call(this.grid.querySelectorAll('.collection__cell[data-handle]'));
            if (cells.length < 2) return done();

            /* Ask for the page actually on screen, at Shopify's page size, so
               Constructor's page N lines up with Shopify's page N. Asking for page
               1 from every page meant a paginated grid was ranked against results
               it does not contain: every cell scored Infinity, so the drift
               correction silently did nothing beyond page 1, the result id
               belonged to a different page's response, and with pruning on the
               whole page was dropped as unranked (#19361137).

               Beyond Constructor's result count the response is legitimately
               empty and the results check below exits without touching the grid.
               Facets and sort options come back on every page regardless, so the
               filter drawer is unaffected. */
            var serverPage = parseInt(this.grid.getAttribute('data-cnstrc-result-page'), 10) || 1;

            var timeout = setTimeout(done, 4000);
            window.esrConstructor
              .load()
              .then(function (client) {
                if (!client) return null;
                return client.browse.getBrowseResults('group_id', self.cnstrcGroupId, {
                  page: serverPage,
                  resultsPerPage: self.perPage
                });
              })
              .then(function (res) {
                clearTimeout(timeout);
                var body = (res && res.response) || null;

                /* The filter drawer is filled from this same browse response.
                   cnstrcRender used to do it on page 1, and that no longer runs on
                   boot - so without this the drawer opens empty. Rendered before the
                   results check, because a group with no results still has facets. */
                if (body && self.facets) self.facets.render(body);

                var results = (body && body.results) || [];
                if (!results.length) return done();

                /* Tie this grid to the browse response that validated its order,
                   the same way cnstrcRender does for a JS-built grid. Without it
                   the beacon fires click and conversion events with no result set
                   behind them, and on a server-rendered collection that is the
                   FIRST load - the majority of the traffic (#19361137). Only set
                   once Constructor has actually returned results: with none, the
                   grid is purely Shopify's and belongs to no result set. */
                if (res.result_id && self.grid.hasAttribute('data-cnstrc-browse')) {
                  self.grid.setAttribute('data-cnstrc-result-id', res.result_id);
                }

                // Constructor's order, as handles, deduped.
                var rank = {}, n = 0;
                results.forEach(function (item) {
                  var handle = window.esrConstructor.productHandle(item);
                  if (handle && !(handle in rank)) rank[handle] = n++;
                });

                // Stable sort: ranked first in Constructor's order, unranked after
                // in their existing order.
                var decorated = cells.map(function (cell, i) {
                  var h = cell.getAttribute('data-handle');
                  var r = (h in rank) ? rank[h] : Infinity;
                  return { cell: cell, rank: r, i: i };
                });
                var sorted = decorated.slice().sort(function (a, b) {
                  return a.rank - b.rank || a.i - b.i;
                });

                /* Theme setting "Show only products Constructor returns": drop the
                   cells Constructor did not rank, so shoppers see Constructor's
                   selection while the server response keeps the full Shopify
                   collection for crawlers. Off (default), they stay at the tail. */
                var dropped = [];
                if (self.cnstrcPrune) {
                  dropped = sorted.filter(function (d) { return d.rank === Infinity; });
                  sorted = sorted.filter(function (d) { return d.rank !== Infinity; });
                }

                /* Reorder ONLY when pruning has already forced the grid to change
                   (#20015335). Without pruning the server order is left exactly as
                   it painted - no reshuffle, and nothing for the shopper to see.
                   `sorted.some(...)`, which used to also trigger on a pure order
                   difference, is deliberately gone: that difference is the norm, not
                   the exception, while the order sync is off. */
                if (dropped.length) {
                  dropped.forEach(function (d) { d.cell.remove(); });
                  /* Callout cells are merchant content anchored to a product
                     ordinal, and they are NOT in `cells` - that query asks for
                     [data-handle], which only product cells carry. Appending the
                     sorted product cells therefore moved every product PAST the
                     callouts and left them stranded at the front of the grid, so a
                     callout configured for "after the 4th product" appeared in the
                     first cell on every device (#1197). Nothing about the merchant's
                     settings was wrong; the reorder simply did not carry them.

                     The anchor is read from the grid as the server rendered it,
                     because that Liquid order already places each callout at its
                     configured ordinal - so "how many product cells precede this
                     callout" IS the merchant's intent, per device, with no need to
                     re-read the settings here. Reapplied after the sort. */
                  var callouts = [];
                  var beforeCount = 0;
                  [].slice.call(self.grid.children).forEach(function (node) {
                    if (node.hasAttribute('data-handle')) { beforeCount += 1; return; }
                    if (node.classList.contains('collection__cell--callout')) {
                      callouts.push({ el: node, after: beforeCount });
                    }
                  });
                  var frag = document.createDocumentFragment();
                  var ci = 0;
                  var placed = 0;
                  /* Anchored before the first product (position 0). */
                  while (ci < callouts.length && callouts[ci].after <= placed) {
                    frag.appendChild(callouts[ci++].el);
                  }
                  sorted.forEach(function (d) {
                    frag.appendChild(d.cell);
                    placed += 1;
                    while (ci < callouts.length && callouts[ci].after <= placed) {
                      frag.appendChild(callouts[ci++].el);
                    }
                  });
                  /* Pruning can leave fewer products than a callout was anchored
                     after. Rather than drop it, it goes to the tail - the same
                     place the Liquid would have left it had the page been that
                     short to begin with. */
                  while (ci < callouts.length) { frag.appendChild(callouts[ci++].el); }
                  self.grid.appendChild(frag);
                  self.applyStyled();
                  self.updateShowing();
                  /* Pruning leaves only what Constructor ranked, so the grid no
                     longer holds the Shopify count the section rendered with.
                     updateShowing owns the on-page counters, not the beacon's, so
                     correct the reported figure here too. (Unconditional now that
                     pruning is the only way into this block - it used to be guarded
                     because a pure reorder reached here too.) */
                  if (self.grid.hasAttribute('data-cnstrc-num-results')) {
                    self.grid.setAttribute('data-cnstrc-num-results', sorted.length);
                  }
                }
                done();
              })
              .catch(function () { clearTimeout(timeout); done(); });
          }

          // ---- Constructor browse -----------------------------------------
          // One page of results, appended. Only ever reached from a rebuild now
          // (#20015335): page 1 clears the dim the outgoing cells were holding and
          // swaps them for the new set in one go, so shoppers never see an empty
          // grid settle into a full one.
          cnstrcLoad() {
            var self = this;
            if (!this.grid || !window.esrConstructor || !this.cnstrcGroupId) {
              this.cnstrcFinish(true);
              return;
            }
            /* One request per rebuild, not one request at a time (#1172). The old
               guard was `if (this.cnstrcBusy) return`, which dropped a filter tap
               made while the previous tap's request was still in flight - on a
               slow connection, every second tap. cnstrcRefilter had already
               bumped the ticket and written the new filter into the URL, so the
               shopper saw the combined filter in the drawer and the URL, while the
               grid and its count came from the earlier request alone. Load more
               then paged the COMBINED filter onto that grid, and the two figures
               parted for good ("64 of 43").

               So a request is only refused while one for the SAME ticket is out;
               a newer ticket always gets its request, and the older response is
               dropped on arrival (see `stale` below) rather than rendered. */
            var seq = this.cnstrcSeq || 0;
            if (this.cnstrcBusy && this.cnstrcBusySeq === seq) return;
            this.cnstrcBusy = true;
            this.cnstrcBusySeq = seq;
            var page = this.cnstrcPage + 1;
            /* A response for a ticket that has since been superseded. Nothing it
               carries is true of the grid any more: not the page, the total, or
               the cells - and the busy flag now belongs to the newer request. */
            var stale = function () { return seq !== (self.cnstrcSeq || 0); };

            /* A browse request that never settles used to leave the grid stuck
               mid-rebuild for good: `cnstrcBusy` stayed true so no later click
               could start another, and nothing reached cnstrcFinish to give the
               cells back or restore the pager. A REJECTED request was handled; a
               hanging one was not, and it is the case actually seen against a
               Constructor endpoint that stops answering.

               So the request gets the same deadline the rest of this file already
               gives Constructor - cnstrcOrder's guard, and the give-up in loadNext
               and cnstrcReplay - after which the response is abandoned and the
               server's grid stands. `settled` makes the two paths exclusive, so a
               late arrival cannot land on a grid that has already moved on. */
            var settled = false;
            var giveUp = setTimeout(function () {
              if (settled) return;
              settled = true;
              if (stale()) return;
              self.cnstrcBusy = false;
              self.cnstrcFinish(true);
            }, 10000);

            window.esrConstructor
              .load()
              .then(function (client) {
                if (!client) return null;
                var params = { page: page, resultsPerPage: self.perPage };
                if (self.facets) params = self.facets.applyTo(params);
                return client.browse.getBrowseResults('group_id', self.cnstrcGroupId, params);
              })
              .then(function (res) {
                if (settled) return;
                settled = true;
                clearTimeout(giveUp);
                if (stale()) return;
                self.cnstrcBusy = false;
                var body = (res && res.response) || null;
                if (!body) {
                  self.cnstrcFinish(true);
                  return;
                }
                self.cnstrcPage = page;
                /* result_id sits at the TOP level of the response, not inside
                   `response` - which is why the browse container was reporting
                   without one: cnstrcRender only ever receives `res.response`, so the
                   level carrying it was dropped. Set here, where the whole response is
                   still in scope, mirroring the search grid.

                   Overwritten per page, like num-results and result-page in
                   cnstrcRender: load-more appends into this same grid, and the event
                   should tie back to the request that produced the newest cells.

                   Guarded on the browse marker so it is only set on a container
                   Constructor is actually tracking. */
                if (res.result_id && self.grid.hasAttribute('data-cnstrc-browse')) {
                  self.grid.setAttribute('data-cnstrc-result-id', res.result_id);
                }
                self.cnstrcRender(body, seq);
              })
              .catch(function () {
                /* Deliberately NOT gated on `settled`. This catches two different
                   things: a browse request that rejected, and an error thrown while
                   rendering the response it returned - and the second happens after
                   `settled` is set. Skipping it there left the grid dimmed and the
                   pager hidden with no way back, which is exactly what a stale
                   `constructor-client` produced in testing. Finishing twice is
                   harmless (it only clears classes and sets flags); not finishing at
                   all is not. */
                if (!settled) {
                  settled = true;
                  clearTimeout(giveUp);
                }
                if (stale()) return;
                self.cnstrcBusy = false;
                self.cnstrcFinish(true);
              });
          }

          cnstrcRender(body, seq) {
            var self = this;
            var results = body.results || [];
            var total = body.total_num_results || 0;
            /* The rebuild this response belongs to: the ticket the REQUEST was
               made under, passed in by cnstrcLoad. It used to be read from
               this.cnstrcSeq here, at response time - by which point a later
               filter tap had already advanced it, so the check could never
               fail and a stale response rendered as though it were the newest
               (#1172). Anything landing after a newer click is ignored, not
               merged. */
            if (seq == null) seq = this.cnstrcSeq || 0;

            /* Two passes (#1185). Cards are still the theme's standard product card
               rendered by Liquid, one request per result - but the cells no longer
               wait for them.

               Pass 1 builds every cell up front, in Constructor's order, from the
               browse response alone. That is what makes appending as each card
               resolves safe: the order, the featured spans and the callout ordinals
               are all fixed before the first request goes out, so completion order
               decides nothing. Pass 2 swaps the real card into its own cell as it
               lands. */
            this.cnstrcReceived += results.length;

            /* Page 1 replaces the result set; a Load more extends it. */
            var replacing = this.cnstrcPage === 1;
            var cleared = false;
            var clearOutgoing = function () {
              if (cleared || !replacing) return;
              cleared = true;
              self.grid.textContent = '';
              self.grid.classList.remove('is-rebuilding');
              self.grid.classList.remove('is-loading');
            };

            window.esrConstructor.hydrateProgressive(results, {
              section: 'Products',

              onPlaceholder: function (item, handle) {
                if (seq !== self.cnstrcSeq) return null;
                /* The outgoing grid goes only now, with its replacement in hand. */
                clearOutgoing();
                var cell = self.cnstrcCell(item, handle);
                // Callouts sit at a product ordinal, and position 0 means before the
                // first product - so insert those before appending the first cell.
                if (self.cnstrcCount === 0) self.cnstrcCallouts(0);
                self.grid.appendChild(cell);
                self.cnstrcCount += 1;
                self.cnstrcCallouts(self.cnstrcCount);
                return cell;
              },

              onFill: function (row) {
                if (seq !== self.cnstrcSeq || !row.placeholder) return;
                if (!row.el) {
                  /* The product no longer renders. Drop the cell rather than leave a
                     skeleton standing - hydrateAll drops the same case by filtering
                     it out of its resolved rows. */
                  row.placeholder.remove();
                  self.cnstrcCount -= 1;
                  return;
                }
                var pending = row.placeholder.querySelector('.product-card');
                if (pending) pending.replaceWith(row.el);
                else row.placeholder.appendChild(row.el);
                row.placeholder.classList.remove('collection__cell--pending');
                self.cnstrcAfterFill();
              }
            }).then(function () {
              if (seq !== self.cnstrcSeq) return;
              /* A zero-result response still has to clear the outgoing cells, which
                 no placeholder pass will have done. */
              clearOutgoing();
              window.esrConstructor.initInjectedCards();
              self.updateShowing();
              self.applyStyled();
              /* Paging leaves the facets and sort options unchanged, and rebuilding
                 mid-interaction would drop the shopper's open group and scroll
                 position. */
              if (self.cnstrcPage === 1 && self.facets) self.facets.render(body);
              self.cnstrcFinish(false);
            });

            this.total = total;
            this.setAttribute('data-total', total);
            // Both filter bars carry the count, and it was rendered with Shopify's
            // figure - which is not the number of products now in the grid.
            if (this.countTemplate) {
              var countEls = this.querySelectorAll('[data-collection-count]');
              var self = this;
              countEls.forEach(function (node) {
                node.textContent = self.countTemplate.replace('XCOUNTX', total);
              });
            }
            var progress = this.querySelector('[data-collection-progress]');
            if (progress) progress.setAttribute('aria-valuemax', total);
            // Report Constructor's own figures on the browse container, not the
            // Shopify counts the section rendered with.
            if (this.grid.hasAttribute('data-cnstrc-num-results')) {
              this.grid.setAttribute('data-cnstrc-num-results', total);
            }
            if (this.grid.hasAttribute('data-cnstrc-result-page')) {
              this.grid.setAttribute('data-cnstrc-result-page', this.cnstrcPage);
            }
          }

          /* One phase-1 cell: the real card markup cloned from the Liquid skeleton,
             carrying whatever this result actually came with.

             Every field is presence-checked rather than assumed. The browse response
             returns a different set per index and per environment - production
             currently returns seven fields where development returns ten - and which
             ones are visible is changed in the Constructor admin, not here. So this
             renders what is present and lets the phase-2 fill supply the rest;
             making a field visible improves the first paint on its own, with no
             change to this file. */
          cnstrcCell(item, handle) {
            var data = (item && item.data) || {};
            var cell = document.createElement('li');
            var cls = 'collection__cell collection__cell--pending';
            /* Featured comes from the collection metafield, matched on the handle
               from the indexed url (not data.id: the index is keyed on variant SKU,
               so matching the id against the handle list never hit and the featured
               cells silently stopped appearing). */
            if (handle && this.featuredHandles.indexOf(',' + handle + ',') !== -1) cls += ' collection__cell--featured';
            if (this.cnstrcCount === 0) cls += ' collection__cell--first';
            cell.className = cls;
            /* The server-rendered cells carry this and several things key off it -
               featured matching, the order check, de-duping - but the JS-built cells
               never set it, so all of those saw only half a mixed grid. */
            if (handle) cell.setAttribute('data-handle', handle);

            var tpl = this.querySelector('[data-cnstrc-card-skeleton]');
            if (!tpl || !tpl.content.firstElementChild) return cell;
            var card = tpl.content.firstElementChild.cloneNode(true);

            /* productPath falls back to '#' for a result with no indexed url, which
               is not a link worth giving a shopper - leave the anchor href-less so
               it is inert until the real card arrives with the right one. */
            var url = window.esrConstructor.productPath(item);
            if (url === '#') url = '';
            /* Constructor names the item on the result itself; `data.title` is the
               dev-index spelling of the same thing. */
            var title = (item && item.value) || data.title || '';

            var link = card.querySelector('[data-slot="link"]');
            if (link && url) link.setAttribute('href', url);

            var titleLink = card.querySelector('[data-slot="title"]');
            if (titleLink) {
              if (url) titleLink.setAttribute('href', url);
              titleLink.textContent = title;
            }

            var img = card.querySelector('[data-slot="image"]');
            if (img) {
              if (data.image_url) {
                img.setAttribute('src', this.cnstrcCardImage(data.image_url));
                img.setAttribute('alt', title);
              } else {
                /* No indexed image: drop the element rather than leave a src-less
                   <img>. The media box keeps its aspect ratio and background either
                   way, so the cell holds its place and does not jump when the real
                   card lands. */
                img.remove();
              }
            }

            cell.appendChild(card);
            return cell;
          }

          /* The indexed image url is whatever size the feed happens to carry, which
             is usually the full-resolution original. The card renders a 700px wide
             image, so ask the CDN for that instead of downloading a 2000px one that
             is about to be replaced anyway. Left alone if it is not a url the CDN
             sizes, so an unexpected host cannot break the src. */
          cnstrcCardImage(src) {
            try {
              var url = new URL(src, window.location.origin);
              if (url.hostname.indexOf('cdn.shopify.com') === -1) return src;
              url.searchParams.set('width', '700');
              return url.toString();
            } catch (e) {
              return src;
            }
          }

          /* Run after a card fills its cell. Both of these walk the whole grid, and
             fills land in bursts, so they are coalesced to one pass per frame - the
             same treatment the badge painter gives its own mutation storm. */
          cnstrcAfterFill() {
            var self = this;
            if (this.__fillQueued) return;
            this.__fillQueued = true;
            window.requestAnimationFrame(function () {
              self.__fillQueued = false;
              self.applyStyled();
              /* theWishlist leaves injected hearts inert until told, so the hearts
                 on filled cards go live with the cards rather than at the end. */
              window.esrConstructor.initInjectedCards();
            });
          }

          // Splices in any callout templates anchored to this product ordinal.
          cnstrcCallouts(index) {
            var tpls = this.querySelectorAll('[data-cnstrc-callout][data-index="' + index + '"]');
            var self = this;
            tpls.forEach(function (tpl) {
              if (tpl.__used) return;
              tpl.__used = true;
              self.grid.appendChild(tpl.content.cloneNode(true));
            });
          }

          /* The crawlable page links from snippets/pagination-nav.liquid. Hidden
             the moment this section boots, since shoppers page with Load more -
             but this section is the one that has to decide, because on the
             Constructor path the pager below is held hidden until cnstrcFinish
             and a Constructor that never answers would otherwise leave the
             collection with no way at all to reach page 2. */
          syncCrawlNav(handled) {
            var nav = this.querySelector('[data-pagination-nav]');
            if (nav) nav.hidden = handled;
          }

          // Reveals the grid and the pagination block, and shows Load more only
          // while pages remain.
          cnstrcFinish(failed) {
            this.grid.classList.remove('is-loading');
            /* Every terminal state clears the rebuild dim, the failure one most of
               all: a browse request that errors or comes back empty-handed never
               reaches the placeholder pass, so the outgoing cells are still on
               screen and have to be given back at full opacity. The server's order
               then simply stands, which is the behaviour a Constructor outage - or a
               group_id that does not resolve on this store - should have. */
            this.grid.classList.remove('is-rebuilding');

            /* An ABANDONED rebuild - one that errored or ran out its deadline -
               leaves the outgoing cells on screen, which is the whole point of no
               longer blanking the grid. But cnstrcRefilter zeroed the counters on
               the way in, so they now describe a result set that never arrived. Left
               to report from those, this told a shopper looking at 64 products that
               there were none, and hid the pager under them. Before the no-blanking
               change the counters and the grid agreed because the grid really was
               empty; now they can disagree, so the DOM is the honest source here. */
            var onScreen = this.grid.querySelectorAll('.collection__cell:not(.collection__cell--callout)').length;
            var abandoned = failed && onScreen > 0;

            var wrap = this.querySelector('[data-load-more-wrap]');
            /* Judged on what Constructor has RETURNED, not on the cells rendered: a
               product it returned that Shopify can no longer render would otherwise
               keep the count short of the total forever, leaving the button offering a
               page that does not exist. An abandoned rebuild has returned nothing, so
               it asks the grid instead. */
            var more;
            if (abandoned) more = onScreen < this.total;
            else more = this.cnstrcCount > 0 && this.cnstrcReceived < this.total;
            if (wrap) wrap.hidden = !more;
            var empty = this.querySelector('[data-collection-empty]');
            if (empty) empty.hidden = abandoned || this.cnstrcCount > 0;
            /* The section renders this hidden on the Constructor path and this is the
               only thing that reveals it, so every terminal state is decided here -
               including the failure case, which lands with cnstrcCount at zero.
               Stays hidden with nothing to report, and again once there is nothing
               left to page through: `more` is exactly that test, so reuse it rather
               than restate it. Authoritative because it runs after updateShowing. */
            var pagination = this.querySelector('[data-collection-pagination]');
            if (pagination) pagination.hidden = !more;
            /* Constructor returning nothing while Shopify server-rendered more
               than one page means it did not take over, so hand paging back to
               the crawl links rather than leaving the shopper on a dead end.
               The nav only exists when paginate.pages > 1, so a genuinely empty
               collection cannot reach this - there is nothing to put back. */
            /* Hand paging back to the crawl links only when Constructor did not
               answer. A filter that answers with zero results is a real result -
               the links point at the UNFILTERED pages, so showing them under an
               empty filtered grid offered products the shopper had just filtered
               out (#1172). `failed` is exactly "did not answer". */
            this.syncCrawlNav(!failed);
          }

          // ---- Density ----------------------------------------------------
          bindDensity() {
            var self = this;
            this.densityButtons.forEach(function (btn) {
              btn.addEventListener('click', function () {
                self.setDensity(btn.getAttribute('data-density-set'), true);
              });
            });
            // Re-evaluate styled imagery when crossing the desktop breakpoint
            // (dense mode is desktop-only).
            this.desktop.addEventListener('change', function () {
              self.applyStyled();
            });
          }

          setDensity(value, persist) {
            this.setAttribute('data-density', value);
            this.densityButtons.forEach(function (btn) {
              btn.setAttribute(
                'aria-pressed',
                btn.getAttribute('data-density-set') === value ? 'true' : 'false'
              );
            });
            this.applyStyled();
            if (persist) {
              this.writeParam('view', value === this.defaultDensity ? null : value);
              this.writePref('view', value, this.defaultDensity);
            }
          }

          isDense() {
            return this.getAttribute('data-density') === '6' && this.desktop.matches;
          }

          // ---- Mobile columns (2 / 1) ------------------------------------
          bindMobileCols() {
            var self = this;
            this.mobileColsButtons.forEach(function (btn) {
              btn.addEventListener('click', function () {
                self.setMobileCols(btn.getAttribute('data-mobile-cols-set'), true);
              });
            });
          }

          setMobileCols(value, persist) {
            this.setAttribute('data-mobile-cols', value);
            this.mobileColsButtons.forEach(function (btn) {
              btn.setAttribute(
                'aria-pressed',
                btn.getAttribute('data-mobile-cols-set') === value ? 'true' : 'false'
              );
            });
            if (persist) {
              this.writeParam('cols', value === this.defaultMobileCols ? null : value);
              this.writePref('cols', value, this.defaultMobileCols);
            }
          }

          // ---- Styled imagery --------------------------------------------
          bindStyled() {
            if (!this.styledInputs.length) return;
            var self = this;
            this.styledInputs.forEach(function (input) {
              input.addEventListener('change', function () {
                // Keep both bars' toggles in sync, then apply + persist.
                self.styledInputs.forEach(function (other) {
                  other.checked = input.checked;
                });
                self.applyStyled();
                self.writeParam('styled', input.checked ? '1' : null);
                // `null` as the default so BOTH true and false are stored -
                // passing `false` here would delete the key on switch-off, and
                // an absent key is what lets a styled-on-by-default collection
                // turn styled on. Without this, opting out would not survive a
                // page load on those collections.
                self.writePref('styled', input.checked, null);
              });
            });
          }

          isStyledOn() {
            return this.styledInputs.length > 0 && this.styledInputs[0].checked;
          }

          applyStyled() {
            var on = this.isStyledOn() && !this.isDense();
            this.setAttribute('data-styled', on ? 'true' : 'false');
            // Dim the whole page (sand -> mist) only when this collection opted
            // into Lights On mode; the class on <html> drives the header, line
            // breaks and every sand-background section.
            if (this.lightsMode) {
              document.documentElement.classList.toggle('lights-on', on);
            }
            var cards = this.querySelectorAll('.product-card[data-styled-image]');
            cards.forEach(function (card) {
              var img = card.querySelector('.product-card__image--primary');
              if (!img) return;
              if (!img.dataset.standardSrc) {
                img.dataset.standardSrc = img.getAttribute('src') || '';
                img.dataset.standardSrcset = img.getAttribute('srcset') || '';
              }
              if (on) {
                img.setAttribute('src', card.getAttribute('data-styled-image'));
                var ss = card.getAttribute('data-styled-srcset');
                if (ss) img.setAttribute('srcset', ss);
              } else {
                img.setAttribute('src', img.dataset.standardSrc);
                if (img.dataset.standardSrcset) {
                  img.setAttribute('srcset', img.dataset.standardSrcset);
                }
              }
            });
          }

          // ---- Load more (Section Rendering API) -------------------------
          bindLoadMore() {
            var self = this;
            this.addEventListener('click', function (event) {
              var btn = event.target.closest('[data-collection-load-more]');
              if (!btn) return;
              event.preventDefault();
              self.loadNext(btn);
            });
          }

          buildUrl(nextUrl) {
            var url = new URL(nextUrl, window.location.origin);
            url.searchParams.set('section_id', this.sectionId);
            return url.toString();
          }

          loadNext(btn) {
            var self = this;
            if (btn.getAttribute('aria-busy') === 'true') return;

            // Constructor pages through the API rather than through Shopify's
            // paginate URLs, appending into this same grid - but only once it owns
            // the cells. A server-rendered grid pages through Shopify below, whether
            // Constructor is enabled or not.
            if (this.cnstrcOwnsGrid) {
              btn.setAttribute('aria-busy', 'true');
              btn.disabled = true;
              var done = function () {
                btn.removeAttribute('aria-busy');
                btn.disabled = false;
                self.writeParam('loaded', self.cnstrcPage > 1 ? String(self.cnstrcPage) : null);
                self.saveState();
              };
              var pageBefore = this.cnstrcPage;
              this.cnstrcLoad();
              // cnstrcLoad resolves asynchronously; poll for the page to advance
              // rather than thread a promise through, which keeps the two pagers
              // from having to share a return contract.
              var waited = 0;
              var tick = setInterval(function () {
                waited += 100;
                if (self.cnstrcPage !== pageBefore || waited > 10000) {
                  clearInterval(tick);
                  done();
                }
              }, 100);
              return;
            }

            var nextUrl = btn.getAttribute('data-next-url');
            if (!nextUrl) return;
            btn.setAttribute('aria-busy', 'true');
            btn.disabled = true;

            /* The grid this page was asked for. A filter or sort tap while the
               fetch is in flight hands the grid to Constructor and rebuilds it
               (cnstrcRefilter), and Shopify's page then landed on top of that
               rebuilt grid: Constructor's 32 plus Shopify's 32, under Constructor's
               total - "64 of 43", with a dozen products shown twice (#1172). The
               page belongs to the grid that no longer exists, so it is dropped. */
            var seq = this.cnstrcSeq || 0;
            var superseded = function () {
              return self.cnstrcOwnsGrid || (self.cnstrcSeq || 0) !== seq;
            };

            return fetch(this.buildUrl(nextUrl))
              .then(function (r) {
                return r.text();
              })
              .then(function (html) {
                if (superseded()) {
                  btn.removeAttribute('aria-busy');
                  btn.disabled = false;
                  return;
                }
                var doc = new DOMParser().parseFromString(html, 'text/html');
                self.appendFrom(doc);
                var pageMatch = nextUrl.match(/[?&]page=(\d+)/);
                if (pageMatch) self.loadedPages = parseInt(pageMatch[1], 10);
                // Reflect the loaded depth in the URL so it survives a share /
                // bookmark / refresh. A custom `loaded` param, NOT Shopify's
                // reserved `page` (which would server-render only that page).
                self.writeParam('loaded', self.loadedPages > 1 ? String(self.loadedPages) : null);
                self.saveState();
              })
              .catch(function () {
                btn.removeAttribute('aria-busy');
                btn.disabled = false;
              });
          }

          // Append the incoming page's cells and refresh the pagination block.
          appendFrom(doc) {
            var incomingGrid = doc.querySelector('[data-collection-grid]');
            if (incomingGrid && this.grid) {
              var cells = incomingGrid.querySelectorAll('.collection__cell');
              cells.forEach(function (cell) {
                this.grid.appendChild(cell);
              }, this);

              /* Constructor: the grid now holds more than the page it was rendered
                 for, so advance result-page to the page just appended. Taken from the
                 incoming grid's own attribute rather than counting, so it stays right
                 if a shopper deep-links into a later page. Absent when Constructor is
                 off, in which case there is nothing to carry over. */
              var incomingPage = incomingGrid.getAttribute('data-cnstrc-result-page');
              if (incomingPage && this.grid.hasAttribute('data-cnstrc-result-page')) {
                this.grid.setAttribute('data-cnstrc-result-page', incomingPage);
              }
            }

            // Re-apply styled imagery to the freshly added cards.
            this.applyStyled();

            var pagination = this.querySelector('[data-collection-pagination]');
            var incomingPagination = doc.querySelector('[data-collection-pagination]');
            if (pagination && incomingPagination) {
              pagination.replaceWith(incomingPagination);
            }
            this.updateShowing();
          }

          updateShowing() {
            // Count products only (in-grid callout cells share .collection__cell).
            var count = this.grid
              ? this.grid.querySelectorAll('.collection__cell:not(.collection__cell--callout)').length
              : 0;

            var showing = this.querySelector('[data-collection-showing]');
            if (showing && this.showingTemplate) {
              showing.textContent = this.showingTemplate
                .replace('XCOUNTX', count)
                .replace('XTOTALX', this.total);
            }

            // The pagination block (and its progress bar) was just replaced with
            // the next page's server markup, so re-query and resize the fill to
            // the live shown / total ratio.
            var fill = this.querySelector('[data-collection-progress-fill]');
            if (fill) {
              var pct = this.total > 0 ? Math.min(100, (count / this.total) * 100) : 0;
              fill.style.width = pct + '%';
            }
            var bar = this.querySelector('[data-collection-progress]');
            if (bar) bar.setAttribute('aria-valuenow', count);

            /* Nothing left to page through, so drop the whole block. Only ever set
               here, never cleared - the server markup carries the right state on each
               page. Shopify pagination only: on the Constructor path cnstrcFinish owns
               this outright, and runs immediately after this, so it has the last word.
               It has to: Constructor's index is keyed on variant SKU, so several
               results can carry the same handle and collapse into one card, leaving
               `count` permanently short of `total`. */
            var block = this.querySelector('[data-collection-pagination]');
            if (block && this.total > 0 && count >= this.total) block.hidden = true;
          }

          // ---- URL + scroll state ----------------------------------------
          writeParam(key, value) {
            var url = new URL(window.location.href);
            if (value === null) {
              url.searchParams.delete(key);
            } else {
              url.searchParams.set(key, value);
            }
            window.history.replaceState(window.history.state, '', url.toString());
          }

          // ---- Display preferences ---------------------------------------
          // Stored as one blob so the preferences can't half-apply. A
          // preference at its section default is removed rather than written:
          // absence means "use whatever this collection is set up to do", so
          // switching back off genuinely stops the preference following the
          // shopper around, and a merchant changing the default is not
          // overridden by a stale stored value.
          readPrefs() {
            try {
              return JSON.parse(window.localStorage.getItem(PREFS_KEY) || 'null') || {};
            } catch (e) {
              return {};
            }
          }

          writePref(key, value, defaultValue) {
            var prefs = this.readPrefs();
            if (value === defaultValue) {
              delete prefs[key];
            } else {
              prefs[key] = value;
            }
            try {
              window.localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
            } catch (e) {}
          }

          stateKey() {
            return 'es-collection:' + this.baseUrl;
          }

          saveState() {
            try {
              sessionStorage.setItem(
                this.stateKey(),
                JSON.stringify({ pages: this.loadedPages, y: window.scrollY })
              );
            } catch (e) {}
          }

          readState() {
            try {
              return JSON.parse(sessionStorage.getItem(this.stateKey()) || 'null');
            } catch (e) {
              return null;
            }
          }

          /* The one place the saved offset is applied (#19951923). It used to be
             applied only at the end of the two page replays, so a shopper who had
             not clicked Load more - most of them - came back from a PDP to the top
             of the page: their offset was read out of the session and then never
             used, and bindBackNav had already switched the browser's own restore
             off. Every exit from restoreState now lands here.

             Asserted twice: once now, against the layout that exists, and once on
             the next frame in case the document was still shorter than the offset
             (the first call clamps). The second is skipped if the shopper has
             already moved. */
          restoreScroll(y) {
            if (!y) return;
            window.scrollTo(0, y);
            var settled = window.scrollY;
            window.requestAnimationFrame(function () {
              if (window.scrollY !== settled) return;
              if (settled < y) window.scrollTo(0, y);
            });
          }

          bindBackNav() {
            var self = this;
            // Keep the scroll position fresh so a PDP visit + back lands here.
            window.addEventListener('pagehide', function () {
              self.saveState();
            });
            /* A back/forward-cache restore resumes this document as it was - the
               loaded pages included - without re-running connectedCallback, so
               restoreState never gets a second run. With the browser's own
               restore switched off below, that path had nothing putting the
               offset back either. */
            window.addEventListener('pageshow', function (event) {
              if (!event.persisted) return;
              var saved = self.readState();
              if (saved) self.restoreScroll(saved.y || 0);
            });
            if ('scrollRestoration' in window.history) {
              window.history.scrollRestoration = 'manual';
            }
          }

          // ---- Floating filter bar ---------------------------------------
          // The floating bar rises from the bottom of the viewport once the
          // inline bar has scrolled out the top, and slides back down once the
          // grid's bottom passes above the bottom of the viewport. Measured with
          // a rAF-throttled scroll handler (deterministic at the boundaries,
          // unlike an IntersectionObserver on a zero-height sentinel).
          disconnectedCallback() {
            // The flag lives on <html>, which outlives this element (the theme
            // editor re-renders the section), so clear it on the way out or the
            // launcher stays lifted over a bar that is no longer there.
            document.documentElement.classList.remove('collection-bar-visible');
          }

          setupStickyBar() {
            if (!this.floatingBar || !this.topBar || !this.grid) return;
            var self = this;
            var ticking = false;
            function onScroll() {
              if (ticking) return;
              ticking = true;
              window.requestAnimationFrame(function () {
                self.updateStickyBar();
                ticking = false;
              });
            }
            window.addEventListener('scroll', onScroll, { passive: true });
            window.addEventListener('resize', onScroll);
            this.updateStickyBar();
          }

          updateStickyBar() {
            var vh = window.innerHeight;
            var topRect = this.topBar.getBoundingClientRect();
            var gridRect = this.grid.getBoundingClientRect();
            // Inline bar scrolled above the viewport, AND the grid bottom is
            // still below the viewport bottom.
            var show = topRect.bottom <= 0 && gridRect.bottom > vh;
            this.floatingBar.classList.toggle('is-visible', show);

            // Publish the bar's presence and measured height on <html> so fixed
            // chrome owned by other files can move out of its way - the Zendesk
            // chat launcher sits bottom-right, over the bar's controls (#1018,
            // same contract as the PDP sticky add-to-cart bar in
            // blocks/product-form.liquid). Measured rather than hard-coded: the
            // bar is taller from 1104px up and grows again if its controls wrap.
            var root = document.documentElement;
            if (show) {
              root.style.setProperty('--collection-bar-height', this.floatingBar.offsetHeight + 'px');
            }
            root.classList.toggle('collection-bar-visible', show);
            // Keep the off-screen copy out of the tab order / a11y tree.
            if (show) {
              this.floatingBar.removeAttribute('inert');
              this.floatingBar.removeAttribute('aria-hidden');
            } else {
              this.floatingBar.setAttribute('inert', '');
              this.floatingBar.setAttribute('aria-hidden', 'true');
            }
          }

          // On (re)entry, apply URL params and, on back-navigation, re-load the
          // previously loaded pages and restore the scroll position.
          restoreState() {
            var params = new URL(window.location.href).searchParams;
            // Stored preferences apply first so an explicit URL param always
            // wins: a shared or filtered link renders as sent, whatever the
            // recipient happens to have stored. Neither is written back to the
            // URL, so applying a preference leaves the address bar clean.
            var prefs = this.readPrefs();
            if (prefs.view === '4' || prefs.view === '6') {
              this.setDensity(prefs.view, false);
            }
            var view = params.get('view');
            if (view === '4' || view === '6') {
              this.setDensity(view, false);
            }
            if (prefs.cols === '1' || prefs.cols === '2') {
              this.setMobileCols(prefs.cols, false);
            }
            var cols = params.get('cols');
            if (cols === '1' || cols === '2') {
              this.setMobileCols(cols, false);
            }
            // Styled precedence, most specific first:
            //   1. ?styled= in the URL     - a shared link renders as sent
            //   2. a stored choice          - true OR false, both explicit
            //   3. this collection's default metafield
            //   4. off
            var styledOn = false;
            if (this.styledDefault) {
              styledOn = true;
            }
            if (prefs.styled === true || prefs.styled === false) {
              styledOn = prefs.styled;
            }
            if (params.has('styled')) {
              styledOn = params.get('styled') === '1';
            }
            // Assign rather than only setting `true`: on a styled-on-by-default
            // collection an explicit opt-out has to be able to clear the box.
            this.styledInputs.forEach(function (input) {
              input.checked = styledOn;
            });
            this.applyStyled();

            // Depth comes from the URL (`loaded`, for shares / refresh) or the
            // saved session (back-nav); scroll restore is session-only.
            var saved = this.readState();

            var targetPages = 1;
            var scrollY = 0;
            if (saved && saved.pages) {
              targetPages = saved.pages;
              scrollY = saved.y || 0;
            }
            var urlLoaded = parseInt(params.get('loaded'), 10);
            if (urlLoaded && urlLoaded > targetPages) {
              targetPages = urlLoaded;
            }
            // Constructor has no server-rendered pages to replay, it just asks for
            // them again - including page 1, which is why this sits above the
            // nothing-to-restore return. Driving the first load from here rather
            // than from connectedCallback is what stops page 1 being requested
            // twice when there is also a depth to restore.
            /* Constructor no longer builds or pages the grid - Shopify's server
               render and pagination do both. All it does is confirm the order of
               what is already here (cnstrcOrder), after which depth restore below
               replays Shopify pages exactly as it does with Constructor off. */
            if (this.cnstrc) {
              /* Filters or a sort in the URL - a reload, a shared link, or coming
                 back from a PDP - are Constructor's to apply, and the server
                 render cannot have: it is the unfiltered collection. Confirming
                 its order and replaying Shopify pages kept the filter in the URL
                 and the drawer while the grid showed the whole collection, at the
                 whole collection's count (#1172). Rebuild from Constructor
                 instead, and restore the depth through its own pager. */
              var params = this.facets ? this.facets.applyTo({}) : {};
              if (params.filters || params.sortBy) {
                this.cnstrcRefilter();
                /* Not gated on depth: at a target of 1 the replay requests nothing
                   (cnstrcLoad refuses a second call for the same ticket) and only
                   waits for the rebuild's page 1 to land before restoring the
                   offset - which is the right moment, since the outgoing server
                   cells are the wrong height for a filtered set. */
                this.cnstrcReplay(targetPages, scrollY);
                return;
              }
              /* Order only: the cells are already here at their final height, so
                 the offset can go straight back while the order settles. */
              this.cnstrcOrder();
            }

            if (targetPages <= 1) {
              this.restoreScroll(scrollY);
              return;
            }

            this.replayPages(targetPages, scrollY);
          }

          // Sequentially fetch pages 2..target, append, then restore scroll.
          cnstrcReplay(target, scrollY) {
            var self = this;
            var finish = function () {
              /* cnstrcRefilter drops `loaded` on the way in; put the depth that was
                 actually restored back so a refresh lands on the same page. */
              self.writeParam('loaded', self.cnstrcPage > 1 ? String(self.cnstrcPage) : null);
              self.restoreScroll(scrollY);
            };
            var step = function () {
              if (self.cnstrcPage >= target) return finish();
              // The count guard only means anything once a page has come back:
              // before that, this.total is still Shopify's figure, which is not
              // Constructor's and is zero on any collection Shopify considers
              // empty - and that would skip the first request entirely.
              if (self.cnstrcPage > 0 && self.cnstrcCount >= self.total) return finish();
              var before = self.cnstrcPage;
              self.cnstrcLoad();
              var waited = 0;
              var tick = setInterval(function () {
                waited += 100;
                if (self.cnstrcPage !== before || waited > 10000) {
                  clearInterval(tick);
                  if (self.cnstrcPage === before) return;
                  step();
                }
              }, 100);
            };
            step();
          }

          replayPages(target, scrollY) {
            var self = this;
            var page = 2;
            /* Same guard as loadNext: a filter tap during the replay rebuilds the
               grid from Constructor, and the remaining Shopify pages must not land
               on it (#1172). */
            var seq = this.cnstrcSeq || 0;

            function step() {
              if (page > target) {
                self.restoreScroll(scrollY);
                return;
              }
              if (self.cnstrcOwnsGrid || (self.cnstrcSeq || 0) !== seq) return;
              var url = new URL(self.baseUrl, window.location.origin);
              url.searchParams.set('page', page);
              url.searchParams.set('section_id', self.sectionId);
              fetch(url.toString())
                .then(function (r) {
                  return r.text();
                })
                .then(function (html) {
                  if (self.cnstrcOwnsGrid || (self.cnstrcSeq || 0) !== seq) return;
                  var doc = new DOMParser().parseFromString(html, 'text/html');
                  self.appendFrom(doc);
                  self.loadedPages = page;
                  page += 1;
                  step();
                })
                .catch(function () {});
            }
            step();
          }
        }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ready);
    } else {
      ready();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('collections-grid')) return;

    customElements.define(
      'collections-grid',
      class extends HTMLElement {
        connectedCallback() {
          if (this.__init) return;
          this.__init = true;

          this.sectionId = this.getAttribute('data-section-id');
          this.total = parseInt(this.getAttribute('data-total'), 10) || 0;
          this.showingTemplate = this.getAttribute('data-showing-template') || '';
          this.grid = this.querySelector('[data-cg-grid]');

          var self = this;
          this.addEventListener('click', function (event) {
            var btn = event.target.closest('[data-cg-load-more]');
            if (!btn) return;
            event.preventDefault();
            self.loadNext(btn);
          });
        }

        buildUrl(nextUrl) {
          var url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.sectionId);
          return url.toString();
        }

        loadNext(btn) {
          var self = this;
          var nextUrl = btn.getAttribute('data-cg-next-url');
          if (!nextUrl || btn.getAttribute('aria-busy') === 'true') return;
          btn.setAttribute('aria-busy', 'true');
          btn.disabled = true;

          fetch(this.buildUrl(nextUrl))
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              self.appendFrom(doc);
            })
            .catch(function () {
              btn.removeAttribute('aria-busy');
              btn.disabled = false;
            });
        }

        appendFrom(doc) {
          var incomingGrid = doc.querySelector('[data-cg-grid]');
          if (incomingGrid && this.grid) {
            var cards = incomingGrid.querySelectorAll('.collection-card');
            cards.forEach(function (card) {
              this.grid.appendChild(card);
            }, this);
          }

          var pagination = this.querySelector('[data-cg-pagination]');
          var incomingPagination = doc.querySelector('[data-cg-pagination]');
          if (pagination && incomingPagination) {
            pagination.replaceWith(incomingPagination);
          }

          this.updateShowing();
        }

        updateShowing() {
          var count = this.grid ? this.grid.querySelectorAll('.collection-card').length : 0;

          var showing = this.querySelector('[data-cg-showing]');
          if (showing && this.showingTemplate) {
            showing.textContent = this.showingTemplate
              .replace('XCOUNTX', count)
              .replace('XTOTALX', this.total);
          }

          var fill = this.querySelector('[data-cg-progress-fill]');
          if (fill) {
            var pct = this.total > 0 ? Math.min(100, (count / this.total) * 100) : 0;
            fill.style.width = pct + '%';
          }
          var bar = this.querySelector('[data-cg-progress]');
          if (bar) bar.setAttribute('aria-valuenow', count);

          // Everything is on screen: nothing left to page through and nothing
          // left to report, so drop the whole block.
          var block = this.querySelector('[data-cg-pagination]');
          if (block && this.total > 0 && count >= this.total) block.hidden = true;
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  // "Fill viewport" height: capture the header (and, when enabled, announcement
  // bar) offset once so the section fills the viewport on load and then holds.
  // Without this the min-height tracks the live --header-height, which shrinks as
  // the header collapses on scroll, making the media appear to grow.
  //
  // The media starts hidden (CSS) and is faded in via .section--contact--sized
  // only after the height is frozen, so the image doesn't visibly resize while
  // the script settles the layout on load.
  class ContactSection extends HTMLElement {
    connectedCallback() {
      this.freeze = this.freeze.bind(this);
      this.reveal = this.reveal.bind(this);
      // Defer a frame so the header custom element has upgraded and published
      // --header-height before we read it (avoids a script-order race), then
      // freeze the offset and reveal the media at its final size.
      requestAnimationFrame(this.reveal);
      window.addEventListener('load', this.freeze, { once: true });
      window.addEventListener('resize', this.freeze, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.freeze);
      window.removeEventListener('resize', this.freeze);
    }

    reveal() {
      this.freeze();
      this.classList.add('section--contact--sized');
    }

    freeze() {
      var root = getComputedStyle(document.documentElement);
      var offset = parseInt(root.getPropertyValue('--header-height'), 10) || 0;
      if (this.classList.contains('section--contact--offset-announcement')) {
        offset += parseInt(root.getPropertyValue('--announcement-height'), 10) || 0;
      }
      this.style.setProperty('--contact-fill-offset', offset + 'px');
    }
  }

  if (!customElements.get('contact-section')) {
    customElements.define('contact-section', ContactSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__esFaqAccordion) return;
    window.__esFaqAccordion = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animateOpen(details, panel) {
      details.open = true;
      var targetH = panel.scrollHeight;
      panel.style.height = '0px';
      void panel.offsetHeight;
      panel.style.height = targetH + 'px';
      var onEnd = function () {
        panel.removeEventListener('transitionend', onEnd);
        panel.style.height = '';
      };
      panel.addEventListener('transitionend', onEnd);
    }

    function animateClose(details, panel) {
      panel.style.height = panel.scrollHeight + 'px';
      void panel.offsetHeight;
      panel.style.height = '0px';
      var onEnd = function () {
        panel.removeEventListener('transitionend', onEnd);
        details.open = false;
        panel.style.height = '';
      };
      panel.addEventListener('transitionend', onEnd);
    }

    // When "open one at a time" is on, close any other open items in the list.
    function closeOthers(list, except, instant) {
      var open = list.querySelectorAll('.faq-item[open]');
      for (var i = 0; i < open.length; i++) {
        var d = open[i];
        if (d === except) continue;
        var p = d.querySelector('.faq-item__panel');
        if (instant || !p) {
          d.open = false;
        } else {
          animateClose(d, p);
        }
      }
    }

    // Smooth height animation as a progressive enhancement. With JS off the
    // native <details> toggle handles show/hide instantly.
    function onClick(e) {
      var summary = e.target.closest ? e.target.closest('summary') : null;
      if (!summary) return;
      var details = summary.parentElement;
      if (!details || !details.classList.contains('faq-item')) return;
      var list = details.closest('.faq__list');
      var single = list && list.hasAttribute('data-faq-single');

      if (reduce) {
        // Let the native toggle run; just enforce single-open instantly.
        if (single && !details.open && list) closeOthers(list, details, true);
        return;
      }

      var panel = details.querySelector('.faq-item__panel');
      if (!panel) return;

      e.preventDefault();

      if (details.open) {
        animateClose(details, panel);
      } else {
        if (single && list) closeOthers(list, details, false);
        animateOpen(details, panel);
      }
    }

    document.addEventListener('click', onClick);

    // Theme editor: opening a block's settings reveals that FAQ item.
    document.addEventListener('shopify:block:select', function (e) {
      var details = e.target.closest ? e.target.closest('.faq-item') : null;
      if (details) details.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-category"] && !Shopify.designMode) return;
  try {
    
  // <featured-category>: drives the desktop accordion's active tile (expand /
  // label / zoom / arrow are pure CSS off data-fc-active). The
  // active tile is the first by default and becomes the hovered / focused one on
  // interaction - and STAYS active after the pointer leaves (the most recently
  // hovered tile remains the widest). Its video plays (muted, looping) while
  // every other video is paused. On mobile (no accordion) all videos stay paused.
  (function () {
    if (customElements.get('featured-category')) return;

    var DESKTOP = '(min-width: 1104px)';

    class FeaturedCategory extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-fc-item]'));
        if (!this.items.length) return;
        // Which tile is expanded by default (0-based, from the section setting),
        // clamped to the tiles that actually rendered.
        var def = parseInt(this.getAttribute('data-default-index'), 10);
        if (isNaN(def) || def < 0) def = 0;
        this.defaultIndex = Math.min(def, this.items.length - 1);
        // Accordion off (static mode): the default tile stays active (zoomed +
        // video), and hover is handled purely in CSS - so don't bind the
        // active-tile switching that would move the zoom off the default tile.
        this.accordion = this.getAttribute('data-accordion') !== 'false';
        this.mql = window.matchMedia(DESKTOP);
        // Reduced-motion visitors get the still first frame, never playback
        // (WCAG 2.2.2 / 2.3.1) - same gate as category-toggle.
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._onEnter = this._onEnter.bind(this);
        this._onVideoEnter = this._onVideoEnter.bind(this);
        this._onVideoLeave = this._onVideoLeave.bind(this);
        this._onChange = this._sync.bind(this);

        var self = this;
        if (this.accordion) {
          // Accordion: hover switches the active tile (width + zoom + video).
          this.items.forEach(function (item) {
            item.addEventListener('pointerenter', self._onEnter);
            item.addEventListener('focusin', self._onEnter);
          });
        } else {
          // Static: the layout is fixed, but hovering a tile still plays its
          // video; leaving the row reverts to the tile open on load.
          this.items.forEach(function (item) {
            item.addEventListener('pointerenter', self._onVideoEnter);
            item.addEventListener('focusin', self._onVideoEnter);
          });
          this.addEventListener('pointerleave', self._onVideoLeave);
          this.addEventListener('focusout', self._onVideoLeave);
        }
        if (this.mql.addEventListener) this.mql.addEventListener('change', this._onChange);

        this._sync();
      }

      disconnectedCallback() {
        if (!this.items) return;
        var self = this;
        this.items.forEach(function (item) {
          item.removeEventListener('pointerenter', self._onEnter);
          item.removeEventListener('focusin', self._onEnter);
          item.removeEventListener('pointerenter', self._onVideoEnter);
          item.removeEventListener('focusin', self._onVideoEnter);
        });
        this.removeEventListener('pointerleave', self._onVideoLeave);
        this.removeEventListener('focusout', self._onVideoLeave);
        if (this.mql && this.mql.removeEventListener) this.mql.removeEventListener('change', this._onChange);
      }

      _video(item) {
        return item.querySelector('video');
      }

      _sync() {
        if (this.mql.matches) {
          this._activate(this.items[this.defaultIndex]);
        } else {
          var self = this;
          this.items.forEach(function (item) {
            item.removeAttribute('data-fc-active');
            var v = self._video(item);
            if (v) { try { v.pause(); } catch (e) {} }
          });
        }
      }

      _activate(target) {
        if (!this.mql.matches) return;
        var self = this;
        this.items.forEach(function (item) {
          var v = self._video(item);
          if (item === target) {
            item.setAttribute('data-fc-active', '');
            if (v && !self.reduceMotion.matches) {
              v.muted = true;
              var p = v.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else if (v) {
              try { v.pause(); } catch (e) {}
            }
          } else {
            item.removeAttribute('data-fc-active');
            if (v) { try { v.pause(); } catch (e) {} }
          }
        });
      }

      _onEnter(event) {
        this._activate(event.currentTarget);
      }

      // Static mode: play only the given tile's video (muted), pause the rest,
      // without touching data-fc-active (so the layout / baseline zoom stay put).
      _playOnly(target) {
        if (!this.mql.matches) return;
        var self = this;
        this.items.forEach(function (item) {
          var v = self._video(item);
          if (!v) return;
          if (item === target && !self.reduceMotion.matches) {
            v.muted = true;
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            try { v.pause(); } catch (e) {}
          }
        });
      }

      _onVideoEnter(event) {
        this._playOnly(event.currentTarget);
      }

      _onVideoLeave(event) {
        // Ignore focus moving between tiles within the row; only revert when
        // focus/hover actually leaves the component.
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this._playOnly(this.items[this.defaultIndex]);
      }
    }

    customElements.define('featured-category', FeaturedCategory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__esFeaturedProducts) return;
    window.__esFeaturedProducts = true;

    // ---- Recently viewed --------------------------------------------------
    // History of product handles, most-recent-first, stored in the browser. The
    // recently_viewed block hydrates its track from this list via the Section
    // Rendering API (one card per handle, rendered in that product's context).
    var RV_KEY = 'es:recently-viewed';
    var RV_CAP = 20;

    function rvRead() {
      try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
    }
    function rvWrite(list) {
      try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
    }
    function rvCurrentHandle() {
      var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    }
    function rvRecord() {
      var handle = rvCurrentHandle();
      if (!handle) return;
      var list = rvRead().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      rvWrite(list.slice(0, RV_CAP));
    }
    function rvRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    // Reveal a client-hydrated track's section + its tab (shows the skeletons
    // while loading, then the real cards once injected).
    function revealFor(el, track) {
      var section = el.closest('.section--featured-products');
      if (section && section.hasAttribute('data-rv-autohide')) section.removeAttribute('hidden');
      var panel = track.closest('.featured-products__panel');
      if (panel) {
        var tab = el.querySelector('.featured-products__tab[aria-controls="' + panel.id + '"]');
        if (tab) tab.removeAttribute('hidden');
      }
      // Recompute arrows / progress / scrollable / tablist.
      window.dispatchEvent(new Event('resize'));
    }
    // Re-hide a client track that loaded nothing. Skipped in the theme editor by
    // default, so a block that is empty only because the editor cannot supply its
    // data - recently viewed has no browsing history inside the editor iframe,
    // bundle components need a bundle product - keeps its skeletons as a
    // placeholder and stays editable in the preview.
    //
    // `alsoInDesignMode` opts a caller out of that skip. The Constructor pod
    // passes it for its empty-result branches, because an empty pod is a real
    // answer from Constructor about that category rather than a limitation of the
    // editor, and the merchant needs the editor to show what the storefront will
    // do (#1204). The section collapses rather than disappearing from the editor:
    // it stays listed in the sidebar with its settings reachable, and it comes
    // back as soon as the pod returns something, because changing any setting
    // re-renders and re-hydrates the section.
    function hideFor(el, track, alsoInDesignMode) {
      if (window.Shopify && window.Shopify.designMode && !alsoInDesignMode) return;
      clearLoading(track);
      var section = el.closest('.section--featured-products');
      if (section && section.hasAttribute('data-rv-autohide')) section.setAttribute('hidden', '');
      var panel = track.closest('.featured-products__panel');
      if (panel) {
        var tab = el.querySelector('.featured-products__tab[aria-controls="' + panel.id + '"]');
        if (tab) tab.setAttribute('hidden', '');
      }
      window.dispatchEvent(new Event('resize'));
    }
    function slidesFromHtml(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      return Array.prototype.slice.call(tmp.querySelectorAll('.featured-products__slide'));
    }
    // Remove the loading skeletons (and any design-mode placeholder) before real
    // cards are injected.
    function clearLoading(track) {
      var loaders = track.querySelectorAll('.featured-products__slide--skeleton, .featured-products__slide--empty');
      Array.prototype.forEach.call(loaders, function (n) { n.remove(); });
    }
    /* Hydrate EVERY matching track in the section, not just the first.
       #1219: each hydrator below used to open with
       el.querySelector('<hook>') - singular - against the whole section, so a
       section holding several of the same block type only ever hydrated the
       first one. The AU homepage had five Constructor Recommendations blocks
       (one pod, five category filters) and four of them never fired a request:
       they render hidden until they hydrate, so their tabs never appeared and
       it read as "only the first pod works".

       The per-track guards (__rvDone and friends) were already per-track, and
       revealFor derives the panel and tab from the track itself, so nothing
       else had to change - only the lookup was wrong. */
    function eachTrack(el, selector, fn) {
      var tracks = el.querySelectorAll(selector);
      Array.prototype.forEach.call(tracks, fn);
    }
    // Recently viewed: one card per stored handle, rendered in that product's context.
    function rvHydrate(el) {
      eachTrack(el, '[data-recently-viewed]', function (track) { rvHydrateTrack(el, track); });
    }
    function rvHydrateTrack(el, track) {
      if (track.__rvDone) return;
      track.__rvDone = true;
      var current = rvCurrentHandle();
      var limit = parseInt(track.getAttribute('data-rv-limit'), 10) || 12;
      var handles = rvRead().filter(function (h) { return h !== current; }).slice(0, limit);
      if (!handles.length) return; // no history: the section stays hidden (no skeletons on live)
      revealFor(el, track); // show the skeletons while the cards load
      var root = rvRoot();
      Promise.all(handles.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=recently-viewed-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) { return html ? slidesFromHtml(html)[0] || null : null; })
          .catch(function () { return null; });
      })).then(function (slides) {
        var real = slides.filter(Boolean);
        if (!real.length) { hideFor(el, track); return; }
        clearLoading(track);
        real.forEach(function (slide) { track.appendChild(slide); });
        revealFor(el, track);
      });
    }
    // You may also like: Shopify product recommendations for the current product.
    function recsHydrate(el) {
      eachTrack(el, '[data-recommendations]', function (track) { recsHydrateTrack(el, track); });
    }
    function recsHydrateTrack(el, track) {
      if (track.__recsDone) return;
      track.__recsDone = true;
      var pid = track.getAttribute('data-product-id');
      if (!pid) return; // not a product page: the section stays hidden
      revealFor(el, track); // show the skeletons while recommendations load
      var limit = parseInt(track.getAttribute('data-recs-limit'), 10) || 10;
      var intent = track.getAttribute('data-intent') || 'related';
      var url = rvRoot() + 'recommendations/products?section_id=recommendations-results&limit=' +
        limit + '&intent=' + encodeURIComponent(intent) + '&product_id=' + encodeURIComponent(pid);
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var slides = html ? slidesFromHtml(html) : [];
          if (!slides.length) { hideFor(el, track); return; } // no recommendations
          clearLoading(track);
          slides.forEach(function (slide) { track.appendChild(slide); });
          revealFor(el, track);
        })
        .catch(function () { clearLoading(track); hideFor(el, track); });
    }

    // What's included: the components of a native Shopify Bundles product,
    // read LIVE from the Storefront API (ProductVariant.components, API
    // 2024-07+). The Bundles app stays the single source of truth - nothing is
    // mirrored into metafields. Needs the block's per-store Storefront API
    // token, and the bundle + its components published to that app's sales
    // channel. Cards are the theme's standard product card, server-rendered
    // per component product via the Section Rendering API (the same
    // recently-viewed-card section the Recently viewed block uses), so
    // pricing, swatches and badges match the rest of the theme. The track
    // only carries data-bundle-components on products tagged "bundle-product"
    // (the same tag the availability rule keys on), so untagged products
    // never make the API call and the section stays hidden on them; the
    // reveal only happens once the component list comes back non-empty.
    function bundleHydrate(el) {
      eachTrack(el, '[data-bundle-components]', function (track) { bundleHydrateTrack(el, track); });
    }
    function bundleHydrateTrack(el, track) {
      if (track.__bundleDone) return;
      track.__bundleDone = true;
      var handle = track.getAttribute('data-product-handle');
      var token = track.getAttribute('data-sfapi-token');
      if (!handle || !token) { hideFor(el, track); return; }
      var query = 'query BundleComponents($handle: String!) {' +
        ' product(handle: $handle) { variants(first: 1) { nodes {' +
        ' components(first: 30) { nodes { quantity productVariant { product { handle } } } }' +
        ' } } } }';
      fetch(location.origin + '/api/2026-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query, variables: { handle: handle } })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (res) {
          var variant = res && res.data && res.data.product && res.data.product.variants.nodes[0];
          var nodes = (variant && variant.components.nodes) || [];
          var handles = nodes.map(function (n) { return n.productVariant.product.handle; });
          handles = handles.filter(function (h, i) { return handles.indexOf(h) === i; });
          if (!handles.length) { hideFor(el, track); return; }
          revealFor(el, track); // show the skeletons while the cards load
          var root = rvRoot();
          return Promise.all(handles.map(function (h) {
            return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=recently-viewed-card')
              .then(function (r) { return r.ok ? r.text() : ''; })
              .then(function (html) { return html ? slidesFromHtml(html)[0] || null : null; })
              .catch(function () { return null; });
          })).then(function (slides) {
            var real = slides.filter(Boolean);
            if (!real.length) { hideFor(el, track); return; }
            clearLoading(track);
            real.forEach(function (slide) { track.appendChild(slide); });
            revealFor(el, track);
          });
        })
        .catch(function () { hideFor(el, track); });
    }

    rvRecord();

    /* Constructor Recommendations: same hydrate-then-reveal contract as the Shopify
       block above, but the products come from a Constructor recommendations pod and the
       cards are the basic Constructor card. Does nothing unless Constructor is enabled
       and keyed, since window.esrConstructor only exists behind that gate. */
    function cnstrcRecsHydrate(el) {
      eachTrack(el, '[data-cnstrc-recs]', function (track) { cnstrcRecsHydrateTrack(el, track); });
    }
    function cnstrcRecsHydrateTrack(el, track) {
      if (track.__cnstrcDone) return;
      track.__cnstrcDone = true;

      var pod = track.getAttribute('data-cnstrc-pod');
      if (!pod || !window.esrConstructor) { hideFor(el, track); return; }

      revealFor(el, track); // skeletons while the pod loads
      var limit = parseInt(track.getAttribute('data-cnstrc-limit'), 10) || 10;
      var seed = track.getAttribute('data-cnstrc-seed');
      /* Set by Liquid from the block's Category filter setting, or from the
         collection handle where the block asks for that, so the pod is narrowed to
         one category instead of returning the same store-wide list everywhere. */
      var groupId = track.getAttribute('data-cnstrc-group-id');

      window.esrConstructor.load().then(function (client) {
        if (!client) { clearLoading(track); hideFor(el, track); return; }

        var params = { numResults: limit, section: 'Products' };
        /* Pods with a complementary or similar strategy need the product to work from;
           others ignore it harmlessly. */
        if (seed) params.itemIds = [seed];
        /* group_id is the category filter Constructor understands; an id the index
           does not know returns nothing, which hides the block below rather than
           falling back to an unfiltered list - store-wide best sellers under a
           category heading would be worse than no carousel. Which category it is
           was decided in Liquid, from the block's settings. */
        if (groupId) params.filters = { group_id: groupId };

        return client.recommendations.getRecommendations(pod, params).then(function (res) {
          var items = (res && res.response && res.response.results) || [];
          /* Empty pod, in the editor as well as on the storefront: see hideFor. */
          if (!items.length) { clearLoading(track); hideFor(el, track, true); return; }

          /* Cards are the theme's standard product card, rendered by Liquid - one
             request per item, pooled - so the carousel is populated a beat after the
             pod answers and the loading state is cleared when the slides go in, not
             when the response lands.

             Recommendation items, and no item-section: Constructor asks for that only
             where a pod powers zero-state search results, which this is not. */
          return window.esrConstructor
            .hydrateAll(items, { recommendation: true })
            .then(function (rows) {
              clearLoading(track);
              /* Pod answered but nothing could be rendered - same nothing-to-show
                 answer as an empty pod, so it hides in the editor too. */
              if (!rows.length) { hideFor(el, track, true); return; }
              rows.forEach(function (row) {
                var slide = document.createElement('li');
                slide.className = 'featured-products__slide';
                slide.appendChild(row.el);
                track.appendChild(slide);
              });
              window.esrConstructor.initInjectedCards();
              /* Tagged after the pod answered, so the block's Shopify-sourced tabs and
                 a hidden empty pod are never reported as recommendation results. */
              window.esrConstructor.tagRecommendations(track, {
                podId: pod,
                resultId: res.result_id,
                numResults: res.response && res.response.total_num_results,
                seedItems: seed || null
              });
              revealFor(el, track);
            });
        });
      }).catch(function () { clearLoading(track); hideFor(el, track); });
    }

    // Drag-to-scroll for mouse/pen. The viewport is a native overflow scroller,
    // so trackpads and touch already work, but a mouse press-and-drag did
    // nothing and dragging a card image started the browser's native image drag
    // instead. Same pattern as hero.liquid / shop-by-category.liquid.
    var DRAG_THRESHOLD = 5; // px of travel before a press counts as a drag, not a click

    function setupDrag(vp) {
      if (vp.__fpDragInit) return;
      vp.__fpDragInit = true;

      var dragging = false;
      var moved = false;
      var pointerId = null;
      var startX = 0;
      var startLeft = 0;

      function release() {
        if (pointerId == null) return;
        if (vp.releasePointerCapture && vp.hasPointerCapture && vp.hasPointerCapture(pointerId)) {
          try { vp.releasePointerCapture(pointerId); } catch (err) {}
        }
        pointerId = null;
      }

      vp.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // native touch scrolling handles this
        if (e.button !== 0) return;
        if (vp.scrollWidth <= vp.clientWidth) return; // nothing to scroll
        dragging = true;
        moved = false;
        pointerId = e.pointerId;
        startX = e.clientX;
        startLeft = vp.scrollLeft;
        vp.classList.add('is-dragging');
      });

      vp.addEventListener('pointermove', function (e) {
        if (!dragging || e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        if (!moved) {
          if (Math.abs(dx) <= DRAG_THRESHOLD) return;
          moved = true;
          // Captured only once the gesture is genuinely a drag: capturing on
          // pointerdown would retarget an ordinary card click to the viewport
          // and swallow the link.
          if (vp.setPointerCapture) {
            try { vp.setPointerCapture(pointerId); } catch (err) {}
          }
        }
        e.preventDefault();
        vp.scrollLeft = startLeft - dx;
      });

      function end(e) {
        if (!dragging || (e && e.pointerId !== pointerId)) return;
        dragging = false;
        vp.classList.remove('is-dragging');
        release();
      }

      vp.addEventListener('pointerup', end);
      vp.addEventListener('pointercancel', end);

      // A drag must not also follow the card's link. 'moved' is cleared by the
      // next pointerdown, so a drag that ends without a click can't swallow the
      // click after it.
      vp.addEventListener('click', function (e) {
        if (!moved) return;
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }, true);

      // The cards are links wrapping images, so without this the browser starts
      // its own native drag and the viewport never moves.
      vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    function setup(el) {
      if (el.__fpInit) return;
      el.__fpInit = true;

      var tabs = Array.prototype.slice.call(el.querySelectorAll('.featured-products__tab'));
      var panels = Array.prototype.slice.call(el.querySelectorAll('.featured-products__panel'));
      var userPicked = false; // set once the visitor clicks/keys a tab
      var prev = el.querySelector('[data-fp-arrow="prev"]');
      var next = el.querySelector('[data-fp-arrow="next"]');
      var progressFill = el.querySelector('.featured-products__progress-fill');

      function activePanel() {
        for (var i = 0; i < panels.length; i++) {
          if (!panels[i].hasAttribute('hidden')) return panels[i];
        }
        return panels[0];
      }
      function viewportOf(panel) {
        return panel ? panel.querySelector('.featured-products__viewport') : null;
      }

      function syncPanel(panel) {
        if (panel !== activePanel()) return;
        var vp = viewportOf(panel);
        if (!vp) return;
        var max = vp.scrollWidth - vp.clientWidth;
        el.setAttribute('data-scrollable', max > 1 ? 'true' : 'false');
        // A scrollable region needs to be reachable by keyboard (the arrows are
        // an aria-hidden pointer affordance), so the viewport takes a tab stop
        // only while it actually scrolls - no dead tab stop on the mobile grid
        // layout or a tab whose cards fit.
        if (max > 1) {
          vp.setAttribute('tabindex', '0');
        } else {
          vp.removeAttribute('tabindex');
        }
        if (prev) prev.disabled = vp.scrollLeft <= 1;
        if (next) next.disabled = vp.scrollLeft >= max - 1;
        if (progressFill) {
          var progress = max > 0 ? vp.scrollLeft / max : 0;
          progressFill.style.width = (progress * 100) + '%';
        }
      }

      function selectTab(id) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === id;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.classList.toggle('featured-products__tab--active', on);
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p) {
          if (p.getAttribute('data-tab') === id) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });
        hydratePanel(activePanel());
        var vp = viewportOf(activePanel());
        if (vp) vp.scrollLeft = 0;
        syncPanel(activePanel());
      }

      /* Move a deferred tab's cards into the document the first time it opens.
         The cards need no wiring of their own - product-card delegates all of
         its listeners off document - so appending the fragment is enough, and
         syncPanel re-measures the track for the arrows and progress bar. */
      function hydratePanel(panel) {
        if (!panel) return;
        var tpl = panel.querySelector('template[data-fp-deferred]');
        if (!tpl) return;
        var vp = viewportOf(panel);
        if (vp) vp.appendChild(tpl.content.cloneNode(true));
        tpl.parentNode.removeChild(tpl);
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          userPicked = true;
          selectTab(tab.getAttribute('data-tab'));
        });
        tab.addEventListener('keydown', function (e) {
          var dir = 0;
          if (e.key === 'ArrowRight') dir = 1;
          else if (e.key === 'ArrowLeft') dir = -1;
          if (!dir) return;
          e.preventDefault();
          userPicked = true;
          var target = tabs[(index + dir + tabs.length) % tabs.length];
          selectTab(target.getAttribute('data-tab'));
          target.focus();
        });
      });

      function scrollByCard(direction) {
        var vp = viewportOf(activePanel());
        if (!vp) return;
        var card = vp.querySelector('.featured-products__slide');
        var step = card ? card.getBoundingClientRect().width + 8 : vp.clientWidth * 0.8;
        // No explicit behavior: inherit the CSS scroll-behavior so the
        // prefers-reduced-motion override (auto) is respected.
        vp.scrollBy({ left: direction * step });
      }
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });

      panels.forEach(function (panel) {
        var vp = viewportOf(panel);
        if (vp) {
          vp.addEventListener('scroll', function () { syncPanel(panel); }, { passive: true });
          setupDrag(vp);
        }
      });

      // Keep the tab row in sync with how many tabs are actually visible. Client
      // tabs (recently viewed / recommendations) stay hidden until they hydrate,
      // so the effective tab count can change: hide the tablist when only one tab
      // is usable (a single-option tab row is pointless), and ensure the active
      // tab is always a visible one.
      function syncTablist() {
        var tablist = el.querySelector('.featured-products__tabs');
        if (!tablist) return;
        var visible = tabs.filter(function (t) { return !t.hasAttribute('hidden'); });
        if (visible.length <= 1) {
          tablist.setAttribute('hidden', '');
        } else {
          tablist.removeAttribute('hidden');
        }
        if (!visible.length) return;
        // Before any manual pick, keep the FIRST visible tab (DOM order) active, so
        // an async hydration order can't leave a later tab (e.g. recently viewed)
        // active ahead of an earlier one (e.g. recommendations). After a manual
        // pick, keep the chosen tab unless it has become hidden.
        var active = tablist.querySelector('.featured-products__tab[aria-selected="true"]');
        if (!userPicked) {
          if (visible[0].getAttribute('aria-selected') !== 'true') {
            selectTab(visible[0].getAttribute('data-tab'));
          }
        } else if (!active || active.hasAttribute('hidden')) {
          selectTab(visible[0].getAttribute('data-tab'));
        }
      }
      syncTablist();

      panels.forEach(syncPanel);
      window.addEventListener('resize', function () { panels.forEach(syncPanel); syncTablist(); });

      // Theme editor: selecting a tab block activates its tab.
      el.addEventListener('shopify:block:select', function (e) {
        var panel = e.target && e.target.closest ? e.target.closest('.featured-products__panel') : null;
        if (panel) selectTab(panel.getAttribute('data-tab'));
      });

      // Hydrate client-side blocks: recently viewed (browser history) and
      // you-may-also-like (Shopify recommendations).
      rvHydrate(el);
      recsHydrate(el);
      cnstrcRecsHydrate(el);
      bundleHydrate(el);
    }

    function init(root) {
      (root || document).querySelectorAll('.featured-products').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes"] && !Shopify.designMode) return;
  try {
    
  // <finishes-gallery>: clicking a finish card swaps the large feature image to
  // its sibling and moves the selected (underlined) state. Informative only -
  // no navigation. Cards are real <button>s so Enter/Space work for free.
  (function () {
    if (customElements.get('finishes-gallery')) return;

    class FinishesGallery extends HTMLElement {
      connectedCallback() {
        // Theme editor: selecting a finish block should reveal its layer. The
        // block's shopify_attributes live on the card, so the bubbled select
        // event carries the index. Matches <product-specs>.
        this._onBlockSelect = this._onBlockSelect.bind(this);
        this.addEventListener('shopify:block:select', this._onBlockSelect);

        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-finish-card]'));
        this.features = Array.prototype.slice.call(this.querySelectorAll('[data-finish-feature]'));
        if (!this.cards.length) return;
        this._onClick = this._onClick.bind(this);
        var self = this;
        this.cards.forEach(function (card) {
          card.addEventListener('click', self._onClick);
        });

        this._warm();

        // Carousel scroll indicator + arrows: size/slide the progress thumb,
        // flag whether the track overflows (the bar + arrows hide when it
        // doesn't), and wire the prev/next controls.
        this.carousel = this.querySelector('.finishes__cards--carousel');
        this.progressFill = this.querySelector('[data-finish-progress]');
        if (this.carousel && this.progressFill) {
          this._onScroll = this._updateProgress.bind(this);
          this.carousel.addEventListener('scroll', this._onScroll, { passive: true });
          window.addEventListener('resize', this._onScroll);

          this.prevArrow = this.querySelector('[data-finish-arrow="prev"]');
          this.nextArrow = this.querySelector('[data-finish-arrow="next"]');
          var self2 = this;
          if (this.prevArrow) {
            this._onPrev = function () { self2._scrollByCard(-1); };
            this.prevArrow.addEventListener('click', this._onPrev);
          }
          if (this.nextArrow) {
            this._onNext = function () { self2._scrollByCard(1); };
            this.nextArrow.addEventListener('click', this._onNext);
          }

          this._updateProgress();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('shopify:block:select', this._onBlockSelect);
        // The theme editor re-renders the section on every settings change, so
        // an observer left running here would accumulate one per edit. The flag
        // also cancels a queued registration that has not been drained yet.
        this._warmGone = true;
        if (this._warmDispose) this._warmDispose();
        if (this.carousel && this._onScroll) {
          this.carousel.removeEventListener('scroll', this._onScroll);
          window.removeEventListener('resize', this._onScroll);
        }
        if (this.prevArrow && this._onPrev) this.prevArrow.removeEventListener('click', this._onPrev);
        if (this.nextArrow && this._onNext) this.nextArrow.removeEventListener('click', this._onNext);
        if (!this.cards) return;
        var self = this;
        this.cards.forEach(function (card) {
          card.removeEventListener('click', self._onClick);
        });
      }

      _scrollByCard(direction) {
        if (!this.carousel) return;
        var card = this.carousel.querySelector('.finishes__card');
        var step = card ? card.getBoundingClientRect().width + 8 : this.carousel.clientWidth * 0.8;
        this.carousel.scrollBy({ left: direction * step });
      }

      _updateProgress() {
        var track = this.carousel;
        var max = track.scrollWidth - track.clientWidth;
        this.setAttribute('data-scrollable', max > 1 ? 'true' : 'false');
        var progress = max > 0 ? track.scrollLeft / max : 0;
        this.progressFill.style.width = (progress * 100) + '%';
        if (this.prevArrow) this.prevArrow.disabled = track.scrollLeft <= 1;
        if (this.nextArrow) this.nextArrow.disabled = track.scrollLeft >= max - 1;
      }

      _onClick(event) {
        var card = event.currentTarget;
        this.activate(card.getAttribute('data-finish-card'));
        this._scrollCardToStart(card);
        this._revealStage();
      }

      // #1169: a card that is only half on screen when tapped changes the stage
      // but stays half on screen, so the change reads as nothing happening.
      // Bring the clicked card to the start of the carousel - the same position
      // the snap points and the arrows land it on - so its start edge sits at
      // the track's start edge plus the scroll-padding. The horizontal scroll
      // here and the vertical page scroll in _revealStage() move different
      // scrollers, so they run side by side without cancelling each other.
      // Motion follows the track's scroll-behavior (smooth, auto under
      // reduced-motion), exactly as the arrows do.
      _scrollCardToStart(card) {
        var track = this.carousel;
        if (!track || !track.contains(card)) return;
        var pad = parseFloat(window.getComputedStyle(track).scrollPaddingInlineStart) || 0;
        var offset = card.getBoundingClientRect().left - track.getBoundingClientRect().left;
        var max = track.scrollWidth - track.clientWidth;
        var target = Math.min(Math.max(0, track.scrollLeft + offset - pad), max);
        track.scrollTo({ left: Math.round(target) });
      }

      _onBlockSelect(event) {
        var el = event.target.closest ? event.target.closest('[data-finish-card]') : null;
        if (el) this.activate(el.getAttribute('data-finish-card'));
      }

      // hydrate() is a fallback now, not the only path: a layer nobody has
      // hydrated is one the shopper waits on, and that wait was the whole of
      // the complaint. Warm the unseen layers as the section comes near, and
      // warm the one being reached for the moment a card is pointed at.
      //
      // esrWarm* lives in snippets/image-warm.liquid, which Shopify compiles
      // into snippet-scripts.js - a deferred script ordered AFTER the
      // scripts.js this file lands in. By the time connectedCallback runs the
      // helpers do not exist yet, so registration goes on __esWarmQueue and
      // image-warm.liquid drains it when it executes (a section that connects
      // after that point runs straight through). See the note there.
      _warm() {
        var self = this;
        (window.__esWarmQueue = window.__esWarmQueue || []).push(function () {
          if (self._warmGone) return;
          self._warmDispose = window.esrWarmWhenNear(self, function () {
            return self.querySelectorAll('[data-finish-feature] img');
          });
          window.esrWarmOnIntent(self.cards, function (card) {
            var index = card.getAttribute('data-finish-card');
            return self.querySelectorAll('[data-finish-feature="' + index + '"] img');
          });
        });
      }

      // Mobile only (#1020): the cards sit below the stage, so on a phone the
      // image the tap just changed is usually off the top of the screen and the
      // change goes unseen. Bring the stage to just below the sticky header.
      //
      // ONE smooth scroll to a target worked out before it starts. An earlier
      // version scrolled first and corrected afterwards, which measured right but
      // looked wrong - the corrections were visible as the stage jumping after it
      // had already come to rest. A single continuous motion that lands a few
      // pixels off is better than a correct position reached in two visible
      // moves, so there is deliberately no correction pass here.
      //
      // The header's settled height is knowable up front because it depends only
      // on the direction of travel: scrolling DOWN leaves it collapsed, scrolling
      // UP makes the search row peek back over the page. That row is absolutely
      // positioned, so it never appears in the header's own height and has to be
      // added by hand for the upward case.
      //
      // Fired straight after activate() and not awaited on the image: the layer
      // hydrates on select (#19587163) and the stage box is already reserved by
      // its width/height, so the geometry does not move when the file lands.
      _revealStage() {
        if (window.matchMedia('(min-width: 1104px)').matches) return;
        var stage = this.querySelector('.finishes__stage');
        if (!stage) return;

        var header = document.querySelector('.header');
        if (!header) return;
        var row = header.querySelector('.header__search--mobile');
        var rowHeight = row ? row.offsetHeight : 0;
        // The row is in the header's own height only while it is in flow; once
        // the header collapses it becomes an overlay and drops out of it.
        var collapsed = header.offsetHeight;
        if (row && window.getComputedStyle(row).position !== 'absolute') {
          collapsed = collapsed - rowHeight;
        }

        var stageTop = stage.getBoundingClientRect().top + window.scrollY;
        var goingDown = stageTop - collapsed - 16;
        var target = goingDown > window.scrollY
          ? goingDown
          : stageTop - (collapsed + rowHeight) - 16;

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, Math.round(target)), behavior: reduce ? 'auto' : 'smooth' });
      }

      // Give a stage layer its image the first time it is asked for. Every
      // layer but the one rendered active ships with a data-src attribute in
      // place of src, so the browser never fetches a finish nobody has looked
      // at (#19587163). Idempotent: the attribute is removed once used, so
      // switching back and forth, or hammering the cards, re-fetches nothing.
      hydrate(feature) {
        var img = feature.querySelector('img[data-src]');
        if (!img) return;
        // Promote the responsive srcset first (if present), so the browser
        // picks the right candidate against `sizes` when src is set.
        var srcset = img.getAttribute('data-srcset');
        if (srcset) {
          img.setAttribute('srcset', srcset);
          img.removeAttribute('data-srcset');
        }
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      }

      activate(index) {
        var self = this;
        this.cards.forEach(function (card) {
          var on = card.getAttribute('data-finish-card') === index;
          card.classList.toggle('is-active', on);
          card.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.features.forEach(function (feature) {
          var on = feature.getAttribute('data-finish-feature') === index;
          // Hydrate before the class flips, so the fetch is already in flight as
          // the layer starts fading up rather than starting after it.
          if (on) self.hydrate(feature);
          feature.classList.toggle('is-active', on);
        });
        this.setAttribute('data-active', index);
      }
    }

    customElements.define('finishes-gallery', FinishesGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterMenus extends HTMLElement {
    connectedCallback() {
      this.query = window.matchMedia('(min-width: 1104px)');
      this.toggles = Array.from(this.querySelectorAll('[data-footer-menu-toggle]'));
      this.onToggle = this.onToggle.bind(this);
      this.sync = this.sync.bind(this);
      this.toggles.forEach((button) => button.addEventListener('click', this.onToggle));
      this.query.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      if (this.query) this.query.removeEventListener('change', this.sync);
    }

    panelFor(button) {
      return document.getElementById(button.getAttribute('aria-controls'));
    }

    setOpen(button, open) {
      const panel = this.panelFor(button);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    }

    onToggle(event) {
      const button = event.currentTarget;
      this.setOpen(button, button.getAttribute('aria-expanded') !== 'true');
    }

    sync() {
      const desktop = this.query.matches;
      this.toggles.forEach((button) => {
        const panel = this.panelFor(button);
        // Desktop: columns are open and static (CSS shows the body). Below it:
        // closed by default. Clearing the inline max-height lets the CSS state
        // (max-height:none on desktop, 0 below) take over on a breakpoint flip.
        button.setAttribute('aria-expanded', desktop ? 'true' : 'false');
        if (panel) panel.style.maxHeight = '';
      });
    }
  }

  // Region selector: opens the menu of regions upward; each option is a real
  // link, so selecting one navigates to that region's URL. Self-contained so
  // it does not depend on any other section's script being present.
  class FooterRegion extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-region-trigger]');
      this.list = this.querySelector('[data-region-list]');
      if (!this.trigger || !this.list) return;
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.trigger.addEventListener('click', this.toggle.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    get isOpen() {
      return !this.list.hidden;
    }

    open() {
      this.list.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.list.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    toggle(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
        this.trigger.focus();
      }
    }
  }

  if (!customElements.get('footer-menus')) {
    customElements.define('footer-menus', FooterMenus);
  }

  if (!customElements.get('footer-region')) {
    customElements.define('footer-region', FooterRegion);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-back-to-top]');
    if (!trigger) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-media"] && !Shopify.designMode) return;
  try {
    

  // Full-height option: subtract the top chrome (announcement bar + sticky
  // header) from the viewport. Neither exposes a height variable, so measure
  // them and feed the total to the section's calc() via --form-media-offset;
  // keep it current on resize and once fonts settle (the logo can change the
  // header height). A missing/hidden element contributes 0.
  (function () {
    var sections = document.querySelectorAll('.form-media--full-height');
    if (!sections.length) return;
    var els = [
      document.querySelector('.announcement-bar'),
      document.querySelector('[data-header]')
    ];
    function update() {
      var offset = 0;
      els.forEach(function (el) {
        if (el) offset += Math.round(el.getBoundingClientRect().height);
      });
      sections.forEach(function (s) {
        s.style.setProperty('--form-media-offset', offset + 'px');
      });
    }
    update();
    window.addEventListener('resize', update, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geo-popup"]) return;
  try {
    
  class GeoPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-geo-dialog]');
      if (!this.dialog || !window.fetch) return;

      this.currentCountry = (this.getAttribute('data-current-country') || '').toUpperCase();
      this.suppressDays = parseInt(this.getAttribute('data-suppress-days'), 10);
      if (isNaN(this.suppressDays)) this.suppressDays = 0;
      this.cookieName = 'es_geo_dismissed';

      this.markets = this.readMarkets();
      if (!Object.keys(this.markets).length) return;

      this.onDismiss = this.dismiss.bind(this);
      this.dialog.addEventListener('cancel', this.onCancel.bind(this));
      this.dialog.addEventListener('click', this.onDialogClick.bind(this));

      const closeButton = this.querySelector('[data-geo-close]');
      if (closeButton) closeButton.addEventListener('click', this.onDismiss);
      const dismissLink = this.querySelector('[data-geo-dismiss]');
      if (dismissLink) dismissLink.addEventListener('click', this.onDismiss);

      // In the theme editor, show the pop-up + overlay while the merchant is
      // editing this section or one of its blocks (it is hidden otherwise, so
      // it could not be configured). Suppression + IP detection are skipped.
      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      if (this.designMode) {
        this.setupEditorPreview();
        return;
      }

      // QA override: `?geo_country=NZ` stands in for the IP lookup so the
      // pop-up can be tested from anywhere. It also ignores the dismissal
      // cookie, so a tester can re-run it straight away.
      const override = this.readOverride();
      if (override) {
        this.showForCountry(override);
        return;
      }

      if (this.isSuppressed()) return;
      this.detectAndShow();
    }

    disconnectedCallback() {
      if (this.onEditorSelect) {
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:block:select', this.onEditorSelect);
      }
      if (this.onEditorDeselect) {
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
        document.removeEventListener('shopify:block:deselect', this.onEditorDeselect);
      }
    }

    readOverride() {
      if (!window.URLSearchParams) return '';
      const value = new URLSearchParams(window.location.search).get('geo_country');
      return value ? value.trim().toUpperCase() : '';
    }

    setupEditorPreview() {
      this.sectionId = this.getAttribute('data-section-id');

      this.onEditorSelect = (event) => {
        if (!event.detail || event.detail.sectionId !== this.sectionId) return;
        let market = null;
        if (event.detail.blockId) {
          const el = this.marketElForBlockId(event.detail.blockId);
          if (el) market = this.marketFromEl(el);
        }
        if (!market) {
          const first = this.querySelector('[data-geo-market]');
          if (first) market = this.marketFromEl(first);
        }
        if (market) this.openForEditor(market);
      };

      this.onEditorDeselect = (event) => {
        if (event.detail && event.detail.sectionId !== this.sectionId) return;
        if (this.dialog.open) this.dialog.close();
      };

      document.addEventListener('shopify:section:select', this.onEditorSelect);
      document.addEventListener('shopify:block:select', this.onEditorSelect);
      document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
      document.addEventListener('shopify:block:deselect', this.onEditorDeselect);
    }

    marketElForBlockId(blockId) {
      const els = this.querySelectorAll('[data-geo-market]');
      for (let i = 0; i < els.length; i++) {
        const raw = els[i].getAttribute('data-shopify-editor-block');
        if (raw) {
          try {
            if (JSON.parse(raw).id === blockId) return els[i];
          } catch (e) {}
        }
      }
      return null;
    }

    openForEditor(market) {
      this.populate(market);
      if (typeof this.dialog.showModal === 'function' && !this.dialog.open) {
        this.dialog.showModal();
      }
    }

    marketFromEl(el) {
      const code = (el.getAttribute('data-geo-market') || '').toUpperCase();
      if (!code) return null;
      return {
        code: code,
        heading: el.getAttribute('data-heading') || '',
        body: el.getAttribute('data-body') || '',
        ctaLabel: el.getAttribute('data-cta-label') || '',
        ctaUrl: el.getAttribute('data-cta-url') || '',
        dismissLabel: el.getAttribute('data-dismiss-label') || '',
      };
    }

    readMarkets() {
      const map = {};
      this.querySelectorAll('[data-geo-market]').forEach((el) => {
        const market = this.marketFromEl(el);
        if (market) map[market.code] = market;
      });
      return map;
    }

    detectAndShow() {
      fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          if (!data || !data.detected_values || !data.detected_values.country) return;
          this.showForCountry((data.detected_values.country.handle || '').toUpperCase());
        })
        .catch(() => {});
    }

    // Open for a country code, provided it isn't this store's own country and a
    // market block covers it.
    showForCountry(country) {
      if (!country || country === this.currentCountry) return;
      const market = this.markets[country];
      if (!market) return;
      this.populate(market);
      if (typeof this.dialog.showModal === 'function') {
        this.lockScroll();
        this.dialog.showModal();
      }
    }

    populate(market) {
      const heading = this.querySelector('[data-geo-heading]');
      const body = this.querySelector('[data-geo-body]');
      const cta = this.querySelector('[data-geo-cta]');
      const ctaLabel = cta ? cta.querySelector('.button__label') : null;
      const dismiss = this.querySelector('[data-geo-dismiss]');
      const dismissLabel = dismiss ? dismiss.querySelector('.button__label') : null;

      if (heading) heading.textContent = market.heading;
      if (body) body.textContent = market.body;
      if (cta) cta.setAttribute('href', market.ctaUrl);
      if (ctaLabel) ctaLabel.textContent = market.ctaLabel;
      if (dismissLabel) dismissLabel.textContent = market.dismissLabel;
    }

    onCancel(event) {
      event.preventDefault();
      this.dismiss();
    }

    onDialogClick(event) {
      if (event.target === this.dialog) this.dismiss();
    }

    dismiss() {
      if (this.designMode) {
        if (this.dialog.open) this.dialog.close();
        return;
      }
      this.setSuppressed();
      this.unlockScroll();
      if (this.dialog.open) this.dialog.close();
    }

    isSuppressed() {
      return document.cookie.split('; ').indexOf(this.cookieName + '=1') !== -1;
    }

    setSuppressed() {
      let cookie = this.cookieName + '=1; path=/; SameSite=Lax';
      if (this.suppressDays > 0) {
        cookie += '; max-age=' + this.suppressDays * 24 * 60 * 60;
      }
      document.cookie = cookie;
    }

    lockScroll() {
      document.documentElement.style.overflow = 'hidden';
    }

    unlockScroll() {
      document.documentElement.style.overflow = '';
    }
  }

  if (!customElements.get('geo-popup')) {
    customElements.define('geo-popup', GeoPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grouped-accordions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class GroupedAccordions extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;
        this.nav = this.querySelector('.ga__tabs');
        this.tabsHost = this.querySelector('[data-ga-tabs]');
        this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-ga-group]'));
        this.buildTabs();
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-ga-tab]'));
        this.bindTabs();
        this.bindSingleOpen();
        this.setupSpy();
        this.setupEditor();
      }

      /* Open one at a time: when a group has data-single-open, opening an
         accordion closes the others in that group. The _accordion controller
         owns the toggle + animation; we let it run first (next frame), then
         click any other open trigger in the group to close it (its own
         controller animates the close). Guarded by the aria-expanded check so
         the synthetic close clicks don't recurse. */
      bindSingleOpen() {
        var self = this;
        this.addEventListener('click', function (e) {
          var trigger = e.target.closest ? e.target.closest('[data-accordion-trigger]') : null;
          if (!trigger || !self.contains(trigger)) return;
          var group = trigger.closest('[data-ga-group]');
          if (!group || !group.hasAttribute('data-single-open')) return;
          requestAnimationFrame(function () {
            if (trigger.getAttribute('aria-expanded') !== 'true') return;
            var open = group.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]');
            for (var i = 0; i < open.length; i++) {
              if (open[i] !== trigger) open[i].click();
            }
          });
        });
      }

      /* File-based theme blocks hide their settings from the parent section, so
         the tab labels are read here from each rendered group's data-tab-label. */
      buildTabs() {
        if (!this.tabsHost) return;
        var self = this;
        if (!this.groups.length) return;
        this.groups.forEach(function (group) {
          var id = group.id;
          var label = group.getAttribute('data-tab-label') || '';
          if (!id || !label) return;
          var a = document.createElement('a');
          a.className = 'ga__tab';
          a.href = '#' + id;
          a.setAttribute('data-ga-tab', id);
          a.textContent = label;
          self.tabsHost.appendChild(a);
        });
        if (this.nav && this.tabsHost.children.length) this.nav.hidden = false;
      }

      bindTabs() {
        var self = this;
        this.tabs.forEach(function (tab) {
          tab.addEventListener('click', function (e) {
            var id = tab.getAttribute('data-ga-tab');
            var target = document.getElementById(id);
            if (!target) return;
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            self.setActive(id);
          });
        });
      }

      setActive(id) {
        this.tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-ga-tab') === id;
          tab.classList.toggle('is-active', on);
          if (on) {
            tab.setAttribute('aria-current', 'true');
          } else {
            tab.removeAttribute('aria-current');
          }
        });
      }

      setupSpy() {
        if (!('IntersectionObserver' in window) || !this.groups.length) return;
        var self = this;
        /* Activate the tab for the group whose top sits in the upper band of the
           viewport (below the sticky header). */
        this.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) self.setActive(entry.target.id);
            });
          },
          { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
        );
        this.groups.forEach(function (g) {
          self.observer.observe(g);
        });
        if (this.tabs[0]) this.setActive(this.tabs[0].getAttribute('data-ga-tab'));
      }

      setupEditor() {
        if (!window.Shopify || !window.Shopify.designMode) return;
        var self = this;
        document.addEventListener('shopify:block:select', function (e) {
          var group = e.target.closest ? e.target.closest('[data-ga-group]') : null;
          if (group && self.contains(group)) {
            group.scrollIntoView({ behavior: 'smooth', block: 'start' });
            self.setActive(group.id);
          }
        });
      }
    }

    if (!window.customElements.get('grouped-accordions')) {
      window.customElements.define('grouped-accordions', GroupedAccordions);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.threshold = 80;
      this.delta = 5;
      this.lastY = Math.max(0, window.scrollY);
      this.ticking = false;
      // How the nav row is currently revealed while collapsed: 'scroll' (the
      // shopper scrolled up - it stays until they scroll down again) or 'hover'
      // (it hides again when the pointer leaves the header).
      this.peekSource = null;
      this.onScroll = this.onScroll.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);
      this.desktopMql = window.matchMedia('(min-width: 1104px)');
      window.addEventListener('scroll', this.onScroll, { passive: true });
      // mousemove rather than mouseenter: the pointer can already be over the
      // header when the nav collapses (scrolling down with the cursor up there),
      // and moving it again has to bring the nav back.
      this.addEventListener('mousemove', this.onPointerMove, { passive: true });
      this.addEventListener('mouseleave', this.onPointerLeave);

      // Publish the live header height to :root so sticky page elements (e.g. the
      // PDP info column) can offset beneath the header. A ResizeObserver tracks
      // the nav-collapse transition frame by frame, so dependents follow smoothly.
      this.publishHeight = this.publishHeight.bind(this);
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.publishHeight);
        this.ro.observe(this);
      } else {
        window.addEventListener('resize', this.publishHeight, { passive: true });
      }
      this.publishHeight();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('mousemove', this.onPointerMove);
      this.removeEventListener('mouseleave', this.onPointerLeave);
      window.clearTimeout(this.peekTimer);
      if (this.ro) this.ro.disconnect();
      else window.removeEventListener('resize', this.publishHeight);
    }

    publishHeight() {
      var root = document.documentElement.style;
      root.setProperty('--header-height', this.offsetHeight + 'px');
      // The collapsing row becomes an absolute overlay (so it is not in
      // offsetHeight), so publish its height too - sticky content that must
      // clear it while it peeks back (e.g. the cart summary) adds this during
      // header--peek. The row is the nav on desktop and the search row on
      // mobile; below 1104px .header__nav is the drawer list, whose height is
      // the whole drawer and would push those sticky elements far too low.
      var overlay = this.desktopMql.matches
        ? this.querySelector('.header__nav')
        : this.querySelector('.header__search--mobile');
      root.setProperty('--header-nav-height', (overlay ? overlay.offsetHeight : 0) + 'px');
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        // The desktop nav hides/shows as an absolute overlay (transform), so the
        // page never reflows and there is no scroll-feedback loop - plain
        // direction tracking is safe.
        const y = Math.max(0, window.scrollY);
        if (y <= this.threshold) {
          // At the top: full header, nav back in flow.
          this.classList.remove('header--collapsed');
          this.hidePeek();
        } else if (y > this.lastY + this.delta) {
          // Scrolling down: collapse and slide the nav overlay away.
          this.classList.add('header--collapsed');
          this.hidePeek();
        } else if (y < this.lastY - this.delta) {
          // Scrolling up: slide the collapsed row back down as an overlay - the
          // nav on desktop, the search row on mobile - and keep it there until
          // the next scroll down. Both are out of flow while collapsed, so
          // revealing them is a transform and the page never shifts. Mobile used
          // to un-collapse instead, which put its search row back IN FLOW and
          // reflowed the document mid-scroll (footer UAT #965).
          this.showPeek('scroll');
        }
        this.lastY = y;
        this.ticking = false;
      });
    }

    // Reveal the nav by sliding the overlay down (header--peek). The overlay
    // doesn't change the header's height, so the menu reappears without
    // shifting the page.
    showPeek(source) {
      if (!this.classList.contains('header--collapsed')) return;
      this.classList.add('header--peek');
      // A scroll-up reveal outranks a hover one, so moving the pointer away
      // doesn't undo it.
      if (source === 'scroll' || !this.peekSource) this.peekSource = source;
    }

    hidePeek() {
      this.classList.remove('header--peek');
      this.peekSource = null;
    }

    onPointerMove() {
      // Hovering the pinned bar reveals the nav (desktop only - the collapsed
      // nav is a desktop overlay). Cheap to leave on mousemove: once the nav is
      // revealed every further move returns on the first check.
      if (this.classList.contains('header--peek')) return;
      if (!this.desktopMql.matches) return;
      window.clearTimeout(this.peekTimer);
      this.showPeek('hover');
    }

    onPointerLeave() {
      // Only ever take back a hover reveal; a scroll-up reveal stays put.
      if (this.peekSource !== 'hover') return;
      // A mega panel is still open (it closes on its own hover grace), so wait
      // for it rather than sliding the nav out from under an open panel.
      if (this.querySelector('mega-menu[open]')) {
        window.clearTimeout(this.peekTimer);
        this.peekTimer = window.setTimeout(() => {
          if (this.peekSource !== 'hover') return;
          if (this.matches(':hover') || this.querySelector('mega-menu[open]')) return;
          this.hidePeek();
        }, 600);
        return;
      }
      this.hidePeek();
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Mobile menu drawer: full-screen panel below the header (< 1104px). The
  // hamburger toggles it; tapping a category with a sub-menu pushes its panel;
  // back / Escape pop; a leaf link, the close glyph, the scrim, or crossing to
  // >= 1104px close it. L1 slides from the left, sub-panels from the right; on
  // close the whole drawer (current panel included) slides back out to the left.
  class MenuDrawer extends HTMLElement {
    connectedCallback() {
      this.toggle =
        document.querySelector('[data-menu-toggle][aria-controls="' + this.id + '"]') ||
        document.querySelector('[data-menu-toggle]');
      this.header = this.closest('.header');
      this.scrim = this.header ? this.header.querySelector('.header__overlay') : null;
      this.mql = window.matchMedia('(min-width: 1104px)');
      this.stack = [];
      // Accessible-name pair for the toggle: "Menu" when closed, "Close menu"
      // when open (the visible glyph swaps menu <-> X).
      if (this.toggle) {
        this.openLabel = this.toggle.getAttribute('aria-label');
        this.closeLabel = this.toggle.getAttribute('data-close-label') || this.openLabel;
      }

      // Focus is only moved programmatically for keyboard interaction. On a tap
      // or a click the browser would paint a focus ring on whatever we focused
      // (a blue box around the first row / the hamburger on iOS), even though
      // the shopper never asked for it.
      this.viaKeyboard = false;

      this.onToggleClick = this.onToggleClick.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);
      this.onScrimClick = this.onScrimClick.bind(this);

      if (this.toggle) this.toggle.addEventListener('click', this.onToggleClick);
      this.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown);
      if (this.scrim) this.scrim.addEventListener('click', this.onScrimClick);
      if (this.mql.addEventListener) this.mql.addEventListener('change', this.onMediaChange);
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.onToggleClick);
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.scrim) this.scrim.removeEventListener('click', this.onScrimClick);
      if (this.mql.removeEventListener) this.mql.removeEventListener('change', this.onMediaChange);
      this.clearReset();
      this.unlockScroll();
    }

    get isOpen() {
      return this.hasAttribute('open');
    }

    escapeId(id) {
      if (window.CSS && CSS.escape) return CSS.escape(id);
      return id;
    }

    // Keyboard-only focus move (see `viaKeyboard` above).
    focusIfKeyboard(el) {
      if (el && this.viaKeyboard) el.focus();
    }

    setDrawerTop() {
      if (!this.header) return;
      // Anchor to the bar bottom, not the whole header: the mobile search row
      // collapses while the drawer is open, so measuring the full header would
      // leave a gap once the search animates away.
      var bar = this.header.querySelector('.header__bar') || this.header;
      var bottom = bar.getBoundingClientRect().bottom;
      this.style.setProperty('--drawer-top', Math.max(0, bottom) + 'px');
    }

    lockScroll() {
      document.documentElement.style.overflow = 'hidden';
    }

    unlockScroll() {
      document.documentElement.style.overflow = '';
    }

    open() {
      if (this.mql.matches || this.isOpen) return;
      // Cancel any pending post-close reset and snap back to L1 so the drawer
      // always opens on the top level (the reset happens while off-screen).
      this.clearReset();
      this.resetPanels();
      this.setDrawerTop();
      this.setAttribute('open', '');
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'true');
        if (this.closeLabel) this.toggle.setAttribute('aria-label', this.closeLabel);
      }
      this.lockScroll();
      this.focusIfKeyboard(this.querySelector('.header__drawer-row'));
    }

    close() {
      if (!this.isOpen) return;
      // Slide the WHOLE drawer (with the current L2/L3 panel still showing) out
      // to the left as one unit. The panel stack is reset only AFTER the slide
      // finishes, off-screen, so panels don't visibly slide out to the right.
      this.removeAttribute('open');
      this.removeAttribute('aria-modal');
      this.removeAttribute('role');
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'false');
        if (this.openLabel) this.toggle.setAttribute('aria-label', this.openLabel);
        this.focusIfKeyboard(this.toggle);
      }
      this.unlockScroll();
      this.scheduleReset();
    }

    // Reset the panel stack after the slide-out transition (off-screen). Guarded
    // so a quick re-open cancels it (see open()).
    scheduleReset() {
      this.clearReset();
      var self = this;
      this.resetTimer = window.setTimeout(function () {
        self.resetTimer = null;
        if (!self.isOpen) self.resetPanels();
      }, 320);
    }

    clearReset() {
      if (this.resetTimer) {
        window.clearTimeout(this.resetTimer);
        this.resetTimer = null;
      }
    }

    onToggleClick(event) {
      if (this.mql.matches) return;
      event.preventDefault();
      // Enter / Space on a button reports a click with detail 0; a real tap or
      // mouse click reports 1 or more.
      this.viaKeyboard = event.detail === 0;
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    onScrimClick() {
      this.viaKeyboard = false;
      this.close();
    }

    onClick(event) {
      this.viaKeyboard = event.detail === 0;
      var drill = event.target.closest('[data-drawer-drill]');
      if (drill && this.contains(drill)) {
        event.preventDefault();
        this.pushPanel(drill);
        return;
      }
      var back = event.target.closest('[data-drawer-back]');
      if (back && this.contains(back)) {
        event.preventDefault();
        this.popPanel();
        return;
      }
      var closer = event.target.closest('[data-drawer-close]');
      if (closer && this.contains(closer)) {
        event.preventDefault();
        this.close();
        return;
      }
      var link = event.target.closest('a[href]');
      if (link && this.contains(link)) {
        this.close();
      }
    }

    panelFor(id) {
      var panels = this.querySelectorAll('[data-drawer-panel]');
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].id === id) return panels[i];
      }
      return null;
    }

    triggerFor(id) {
      return this.querySelector('[data-drawer-target="' + this.escapeId(id) + '"]');
    }

    // The L1 list and the panels are DOM siblings inside each item, so we cannot
    // inert the whole nav (it would inert the panels too). Inert just the L1
    // rows + secondary block so only the active panel is reachable.
    setRootInert(state) {
      var targets = this.querySelectorAll('.header__drawer-item > .header__drawer-row, .header__drawer-secondary');
      for (var i = 0; i < targets.length; i++) {
        if (state) {
          targets[i].setAttribute('inert', '');
          targets[i].setAttribute('aria-hidden', 'true');
        } else {
          targets[i].removeAttribute('inert');
          targets[i].removeAttribute('aria-hidden');
        }
      }
    }

    pushPanel(trigger) {
      var panel = this.panelFor(trigger.getAttribute('data-drawer-target'));
      if (!panel) return;
      var parent = this.stack.length ? this.stack[this.stack.length - 1] : null;
      if (parent) {
        parent.setAttribute('inert', '');
      } else {
        this.setRootInert(true);
      }
      panel.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
      this.stack.push(panel);
      this.focusIfKeyboard(panel.querySelector('[data-drawer-back]'));
    }

    popPanel() {
      var panel = this.stack.pop();
      if (!panel) return;
      panel.classList.remove('is-active');
      var trigger = this.triggerFor(panel.id);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      var parent = this.stack.length ? this.stack[this.stack.length - 1] : null;
      if (parent) {
        parent.removeAttribute('inert');
        this.focusIfKeyboard(parent.querySelector('[data-drawer-back]'));
      } else {
        this.setRootInert(false);
        this.focusIfKeyboard(trigger);
      }
    }

    resetPanels() {
      // Snap the panels/rows back to their resting state with transitions
      // suppressed: this runs while the drawer is off-screen (after a slide-out,
      // or before a slide-in), and a transition here would slide the panel back
      // into view (it animates to translateX(100%) while the drawer sits at
      // -100%, netting an on-screen position). The forced reflow commits the
      // instant change before transitions are restored.
      this.classList.add('is-resetting');
      while (this.stack.length) {
        var panel = this.stack.pop();
        panel.classList.remove('is-active');
        panel.removeAttribute('inert');
        var trigger = this.triggerFor(panel.id);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
      this.setRootInert(false);
      void this.offsetHeight;
      this.classList.remove('is-resetting');
    }

    activeContainer() {
      if (this.stack.length) return this.stack[this.stack.length - 1];
      return this.querySelector('.header__drawer-inner') || this;
    }

    onKeydown(event) {
      if (!this.isOpen) return;
      this.viaKeyboard = true;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (this.stack.length) {
          this.popPanel();
        } else {
          this.close();
        }
      } else if (event.key === 'Tab') {
        this.trapFocus(event);
      }
    }

    trapFocus(event) {
      var container = this.activeContainer();
      var nodes = container.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var visible = [];
      if (this.toggle) visible.push(this.toggle);
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        // Skip nodes inside a non-active sub-panel: those panels are
        // visibility:hidden but their fixed-positioned children still report a
        // non-null offsetParent, so without this the candidate set balloons and
        // the boundary check never fires - letting Tab escape the modal at L1.
        var panel = node.closest('.header__drawer-panel');
        if (panel && !panel.classList.contains('is-active')) continue;
        if (node.offsetParent !== null || node === document.activeElement) visible.push(node);
      }
      if (!visible.length) return;
      var firstEl = visible[0];
      var lastEl = visible[visible.length - 1];
      if (event.shiftKey && document.activeElement === firstEl) {
        event.preventDefault();
        lastEl.focus();
      } else if (!event.shiftKey && document.activeElement === lastEl) {
        event.preventDefault();
        firstEl.focus();
      }
    }

    onMediaChange(event) {
      if (event.matches && this.isOpen) {
        this.viaKeyboard = false;
        this.close();
      }
    }
  }

  if (!customElements.get('menu-drawer')) {
    customElements.define('menu-drawer', MenuDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__esHeroCarousel) return;
    window.__esHeroCarousel = true;

    function setup(el) {
      if (el.__heroInit) return;
      el.__heroInit = true;

      var track = el.querySelector('.hero__track');
      var slides = Array.prototype.slice.call(el.querySelectorAll('.hero-slide'));
      var allDots = Array.prototype.slice.call(el.querySelectorAll('.hero__indicator'));
      if (slides.length < 2) return;

      var autoplay = el.getAttribute('data-autoplay') !== 'false';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) el.setAttribute('data-reduced', '');
      var current = 0;
      var dragging = false;

      var statusEl = el.querySelector('[data-hero-status]');

      // Each slide carries its own indicator set; the active slide's set is the
      // live one that shows the progress fill and drives advancing.
      function liveDots() {
        return Array.prototype.slice.call(slides[current].querySelectorAll('.hero__indicator'));
      }

      function restartFill(dot) {
        if (!dot) return;
        var fill = dot.querySelector('.hero__indicator-fill');
        if (!fill) return;
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      }

      function show(i) {
        current = (i + slides.length) % slides.length;
        if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
        slides.forEach(function (s, idx) {
          var on = idx === current;
          if (on) {
            s.setAttribute('data-active', '');
            s.removeAttribute('aria-hidden');
          } else {
            s.removeAttribute('data-active');
            s.setAttribute('aria-hidden', 'true');
          }
          // Off-screen slides are non-interactive (keeps them out of the tab order).
          s.inert = !on;
        });
        // Clear every dot, then mark only the live group's current dot active so
        // a single progress fill runs (and triggers a single advance).
        allDots.forEach(function (d) {
          d.classList.remove('is-active');
          d.setAttribute('aria-current', 'false');
        });
        var activeDot = liveDots()[current];
        if (activeDot) {
          activeDot.classList.add('is-active');
          activeDot.setAttribute('aria-current', 'true');
        }
        restartFill(activeDot);
        if (statusEl) statusEl.textContent = 'Slide ' + (current + 1) + ' of ' + slides.length;
      }

      function next() {
        show(current + 1);
      }

      function pause() {
        el.setAttribute('data-paused', '');
      }
      function play() {
        // Never resume mid-drag (a stray boundary event must not un-pause).
        if (dragging) return;
        el.removeAttribute('data-paused');
      }

      // Autoplay advances when the active indicator's fill animation completes.
      el.addEventListener('animationend', function (e) {
        if (e.animationName !== 'hero-fill') return;
        if (autoplay && !reduce && !dragging && !el.hasAttribute('data-paused')) next();
      });

      allDots.forEach(function (d) {
        d.addEventListener('click', function () {
          show(parseInt(d.getAttribute('data-hero-goto'), 10) || 0);
        });
      });

      el.addEventListener('pointerenter', pause);
      el.addEventListener('pointerleave', play);
      el.addEventListener('focusin', pause);
      el.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pause();
        } else {
          play();
        }
      });

      // --- Drag / swipe to navigate ------------------------------------
      // Pointer events cover mouse, touch and pen. The track follows the pointer
      // during a horizontal drag (with resistance at the ends), then on release
      // a drag past the threshold moves one slide and a shorter drag snaps back.
      // Drag does not wrap (autoplay and the dots still do).
      var dragStartX = 0;
      var dragDX = 0;
      var dragWidth = 1;
      var dragMoved = false;
      var DRAG_THRESHOLD = 40;

      function onDragStart(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        // Don't start a drag (and pointer-capture) when the gesture begins on a
        // control. Capturing the pointer on the track redirects the resulting
        // click to the track, which would swallow the indicator/CTA click.
        if (e.target.closest('.hero__indicator, a, button')) return;
        dragging = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragDX = 0;
        dragWidth = el.clientWidth || 1;
        track.classList.add('is-dragging');
        pause();
        if (track.setPointerCapture) {
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }

      function onDragMove(e) {
        if (!dragging) return;
        dragDX = e.clientX - dragStartX;
        if (Math.abs(dragDX) > 5) dragMoved = true;
        var dx = dragDX;
        // Resist dragging past the first / last slide (no wrap on drag).
        if ((current === 0 && dx > 0) || (current === slides.length - 1 && dx < 0)) {
          dx = dx * 0.3;
        }
        var pct = (dx / dragWidth) * 100;
        track.style.transform = 'translateX(' + ((current * -100) + pct) + '%)';
      }

      function onDragEnd(e) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (track.releasePointerCapture && e.pointerId != null) {
          try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        var dx = dragDX;
        dragDX = 0;
        if (dx <= -DRAG_THRESHOLD && current < slides.length - 1) {
          show(current + 1);
        } else if (dx >= DRAG_THRESHOLD && current > 0) {
          show(current - 1);
        } else {
          show(current);
        }
        // Resume is governed by the existing hover/focus logic: a mouse still
        // over the hero stays paused; a touch that has lifted resumes via
        // pointerleave.
      }

      track.addEventListener('pointerdown', onDragStart);
      track.addEventListener('pointermove', onDragMove);
      track.addEventListener('pointerup', onDragEnd);
      track.addEventListener('pointercancel', onDragEnd);
      // A real drag must not also fire the click on a slide link or button.
      track.addEventListener('click', function (e) {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          dragMoved = false;
        }
      }, true);
      // Stop the browser's native image/link drag from hijacking the gesture.
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Theme editor: selecting a slide block activates it.
      el.addEventListener('shopify:block:select', function (e) {
        var s = e.target && e.target.closest ? e.target.closest('.hero-slide') : null;
        if (!s) return;
        var i = slides.indexOf(s);
        if (i >= 0) {
          pause();
          show(i);
        }
      });
      el.addEventListener('shopify:block:deselect', play);

      show(0);
      if (!autoplay || reduce) pause();
    }

    function init(root) {
      (root || document).querySelectorAll('hero-carousel').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && customElements.get('hotspot-section')) return;

    class HotspotSection extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;

        this.media = this.querySelector('[data-hotspot-media]');
        this.markers = Array.prototype.slice.call(this.querySelectorAll('[data-hotspot]'));
        this.overlays = Array.prototype.slice.call(this.querySelectorAll('[data-hotspot-panel]'));

        this.markers.forEach(function (marker) {
          marker.addEventListener('click', this.onMarkerClick.bind(this));
        }, this);

        this.setupPulseSync();

        this.onDocClick = this.onDocClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKeydown);

        // Theme editor: opening a block selects its overlay.
        this.addEventListener('shopify:block:select', function (e) {
          var marker = e.target && e.target.closest ? e.target.closest('[data-hotspot]') : null;
          if (marker) this.open(marker.getAttribute('data-hotspot'));
        }.bind(this));
      }

      // Hovering / focusing / opening a marker settles its pulse (and wave) via
      // `animation: none`, which restarts them from time 0 when released and
      // drifts out of step with the other markers. After the engaged state ends
      // we snap the freshly re-created animations back onto the markers' shared
      // start time so they line up again. (Requires the Web Animations API.)
      setupPulseSync() {
        var self = this;
        this.pulseMarkers = [];
        this.markers.forEach(function (marker) {
          if (!marker.getAnimations) return;
          self.pulseMarkers.push(marker);
          var resync = function () {
            requestAnimationFrame(function () { self.syncMarker(marker); });
          };
          marker.addEventListener('mouseleave', resync);
          marker.addEventListener('blur', resync, true);
        });
      }

      // The marker's dot pulse plus its wave pseudo-element, when present.
      markerAnimations(marker) {
        try { return marker.getAnimations({ subtree: true }); }
        catch (e) { return marker.getAnimations(); }
      }

      pulseOrigin() {
        if (this._pulseOrigin != null) return this._pulseOrigin;
        for (var i = 0; i < this.pulseMarkers.length; i++) {
          var anims = this.markerAnimations(this.pulseMarkers[i]);
          for (var j = 0; j < anims.length; j++) {
            if (anims[j].startTime != null) { this._pulseOrigin = anims[j].startTime; return this._pulseOrigin; }
          }
        }
        return this._pulseOrigin;
      }

      syncMarker(marker) {
        var origin = this.pulseOrigin();
        if (origin == null) return;
        this.markerAnimations(marker).forEach(function (a) {
          try { a.startTime = origin; } catch (e) {}
        });
      }

      syncAllMarkers() {
        var self = this;
        if (!this.pulseMarkers) return;
        requestAnimationFrame(function () {
          self.pulseMarkers.forEach(function (m) { self.syncMarker(m); });
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      overlayFor(id) {
        for (var i = 0; i < this.overlays.length; i++) {
          if (this.overlays[i].getAttribute('data-hotspot-panel') === id) return this.overlays[i];
        }
        return null;
      }

      open(id) {
        this.markers.forEach(function (m) {
          m.setAttribute('aria-expanded', m.getAttribute('data-hotspot') === id ? 'true' : 'false');
        });
        this.overlays.forEach(function (o) {
          o.classList.toggle('is-open', o.getAttribute('data-hotspot-panel') === id);
        });
      }

      close() {
        this.markers.forEach(function (m) { m.setAttribute('aria-expanded', 'false'); });
        this.overlays.forEach(function (o) { o.classList.remove('is-open'); });
        this.syncAllMarkers();
      }

      onMarkerClick(e) {
        var marker = e.currentTarget;
        var id = marker.getAttribute('data-hotspot');
        if (!this.overlayFor(id)) return; // no product, nothing to open
        if (marker.getAttribute('aria-expanded') === 'true') {
          this.close();
        } else {
          this.open(id);
        }
      }

      onDocClick(e) {
        // A marker click is handled by its own listener; an open overlay stays
        // open so its links / add-to-cart are clickable. Any other click --
        // including on the image itself, or outside the section -- clears the
        // active overlay. Scope the guards to THIS instance so another hotspot
        // section's marker/overlay doesn't keep this one open.
        var marker = e.target.closest ? e.target.closest('[data-hotspot]') : null;
        if (marker && this.contains(marker)) return;
        var panel = e.target.closest ? e.target.closest('[data-hotspot-panel]') : null;
        if (panel && this.contains(panel)) return;
        this.close();
      }

      onKeydown(e) {
        if (e.key === 'Escape' || e.key === 'Esc') this.close();
      }
    }

    if (window.customElements && !customElements.get('hotspot-section')) {
      customElements.define('hotspot-section', HotspotSection);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-overlay"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__esImageTextOverlay) return;
    window.__esImageTextOverlay = true;

    // A11y: videos play via JS only when the visitor has not asked to reduce motion.
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(el) {
      if (el.__itoInit) return;
      el.__itoInit = true;

      var section = el.closest('.image-text-overlay');
      if (!section) return;

      // Every video in the section, not just the first. When a product has BOTH
      // a desktop and a mobile video the desktop element comes first in the DOM,
      // so querySelector only ever started that one and the mobile video sat
      // there unplayed - an empty band on phones (Productive #1053).
      var videos = Array.prototype.slice.call(el.querySelectorAll('video'));
      var inView = false;

      // Only the breakpoint's visible asset plays; the other is display:none, so
      // starting it would pull down a second video nobody can see.
      function isShown(v) {
        return v.offsetWidth > 0 || v.offsetHeight > 0;
      }

      function sync() {
        videos.forEach(function (v) {
          if (typeof v.play !== 'function') return;
          if (inView && !reduceMotion.matches && isShown(v)) {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }

      function activate() {
        section.classList.add('is-inview');
        inView = true;
        sync();
      }
      function deactivate() {
        inView = false;
        sync();
      }

      // Rotating a phone or resizing across the breakpoint swaps which asset is
      // visible, so re-evaluate rather than leaving the newly-shown one paused.
      var breakpoint = window.matchMedia('(max-width: 768px)');
      if (breakpoint.addEventListener) {
        breakpoint.addEventListener('change', sync);
      }

      if (!('IntersectionObserver' in window)) {
        activate();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activate();
          } else {
            deactivate();
          }
        });
      }, { threshold: 0.25 });
      io.observe(section);
    }

    function init(root) {
      (root || document).querySelectorAll('image-text-overlay').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });

    // A11y: if the visitor switches on reduce-motion while a video is playing, stop it.
    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function () {
        if (!reduceMotion.matches) return;
        document.querySelectorAll('image-text-overlay video').forEach(function (v) {
          v.pause();
          try { v.currentTime = 0; } catch (e) {}
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-prompt"] && !Shopify.designMode) return;
  try {
    
  class LocationPrompt extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-lp-dialog]');
      if (!this.dialog) return;

      this.headingEl = this.querySelector('[data-lp-heading]');
      this.bodyEl = this.querySelector('[data-lp-body]');
      this.detectedEl = this.querySelector('[data-lp-detected]');
      this.storeEl = this.querySelector('[data-lp-store]');
      this.storeTemplate = this.getAttribute('data-store-line') || '';
      this.confirmBtn = this.querySelector('[data-lp-confirm]');
      this.cancelBtn = this.querySelector('[data-lp-cancel]');
      this.closeBtn = this.querySelector('[data-lp-close]');

      // Merchant copy, kept so the error states can borrow the panel and then
      // hand it back untouched.
      this.copy = {
        heading: this.headingEl ? this.headingEl.textContent : '',
        body: this.bodyEl ? this.bodyEl.textContent : '',
        cancel: this.cancelBtn ? this.cancelLabel() : ''
      };
      this.errorCopy = {
        denied: {
          heading: this.getAttribute('data-denied-heading') || '',
          body: this.getAttribute('data-denied-body') || ''
        },
        failed: {
          heading: this.getAttribute('data-failed-heading') || '',
          body: this.getAttribute('data-failed-body') || ''
        }
      };

      this.pending = null;

      this.dialog.addEventListener('cancel', this.onCancel.bind(this));
      this.dialog.addEventListener('click', this.onDialogClick.bind(this));
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.decline.bind(this));
      if (this.cancelBtn) this.cancelBtn.addEventListener('click', this.decline.bind(this));
      if (this.confirmBtn) this.confirmBtn.addEventListener('click', this.accept.bind(this));

      this.publish();

      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      if (this.designMode) this.setupEditorPreview();
    }

    disconnectedCallback() {
      // Only retract the API if this element is the one that published it, so a
      // section re-render in the editor cannot leave callers pointing at a
      // detached element.
      if (window.esLocationPrompt && window.esLocationPrompt.__owner === this) {
        delete window.esLocationPrompt;
      }
      if (this.onEditorSelect) {
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
      }
      if (this.onEditorDeselect) {
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
      }
    }

    cancelLabel() {
      var label = this.cancelBtn.querySelector('.button__label');
      return label ? label.textContent : this.cancelBtn.textContent;
    }

    setCancelLabel(text) {
      var label = this.cancelBtn ? this.cancelBtn.querySelector('.button__label') : null;
      if (label) { label.textContent = text; }
    }

    publish() {
      var self = this;
      window.esLocationPrompt = {
        __owner: this,
        /* Resolves TRUE only on the confirm button. Escape, close, cancel and a
           backdrop click all resolve false. Never rejects, so a caller can
           write .then(function (ok) { if (ok) ... }) and nothing else. */
        confirm: function (detail) {
          return new Promise(function (resolve) {
            self.showConfirm(detail || {}, resolve);
          });
        },
        /* Something went wrong before there was anything to confirm. 'denied' is
           the shopper refusing the browser permission, 'failed' is the lookup
           itself not returning a usable place. Nothing is resolved because
           nothing was asked. */
        notify: function (kind) {
          self.showError(kind === 'denied' ? 'denied' : 'failed');
        }
      };
    }

    showConfirm(detail, resolve) {
      this.settle(false);
      this.pending = resolve;

      if (this.headingEl) this.headingEl.textContent = this.copy.heading;
      if (this.bodyEl) this.bodyEl.textContent = this.copy.body;
      this.setCancelLabel(this.copy.cancel);

      /* Prefer the suburb. The postcode is the fallback for the rare place that
         resolves a postcode but no locality, so the panel never opens with an
         empty line where the location should be. */
      var name = detail.suburb || detail.postcode || '';
      if (this.detectedEl) {
        this.detectedEl.textContent = name;
        this.detectedEl.hidden = !name;
      }

      /* Naming the store here is what makes setting it fair: the shopper is
         told which one they are getting before they agree, rather than finding
         their store quietly reassigned afterwards. Only the locators pass one. */
      if (this.storeEl) {
        var store = detail.store || '';
        if (store && this.storeTemplate) {
          this.storeEl.textContent = this.storeTemplate.replace('[store]', store);
          this.storeEl.hidden = false;
        } else {
          this.storeEl.textContent = '';
          this.storeEl.hidden = true;
        }
      }

      if (this.confirmBtn) this.confirmBtn.hidden = false;

      this.open();
      if (this.confirmBtn) {
        try { this.confirmBtn.focus(); } catch (e) {}
      }
    }

    showError(kind) {
      this.settle(false);

      var copy = this.errorCopy[kind] || this.errorCopy.failed;
      if (this.headingEl && copy.heading) this.headingEl.textContent = copy.heading;
      if (this.bodyEl && copy.body) this.bodyEl.textContent = copy.body;
      if (this.detectedEl) {
        this.detectedEl.textContent = '';
        this.detectedEl.hidden = true;
      }
      // Nothing to accept, so the only way out is to dismiss.
      if (this.confirmBtn) this.confirmBtn.hidden = true;
      this.setCancelLabel('Close');

      this.open();
    }

    /* Answers the outstanding promise, if there is one, exactly once. Every exit
       from the dialog runs through here so a caller can never be left waiting on
       a promise that resolves twice or not at all. */
    settle(value) {
      var resolve = this.pending;
      this.pending = null;
      if (resolve) { resolve(value); }
    }

    accept() {
      this.settle(true);
      this.close();
    }

    decline() {
      this.settle(false);
      this.close();
    }

    open() {
      /* The other overlay prompts close whatever is open before showing, one at
         a time. This one must not: it is usually asked for BY an open drawer
         (the store locator), and closing that would throw the shopper out of the
         thing they were using to answer the question. showModal() stacks in the
         top layer in call order, so the prompt paints above the drawer and the
         drawer is still there when it closes.

         Other prompts are still cleared, so two modal messages never overlap. */
      var open = document.querySelectorAll('dialog[open]');
      for (var i = 0; i < open.length; i++) {
        var other = open[i];
        if (other === this.dialog) { continue; }
        if (other.hasAttribute('data-drawer') || other.hasAttribute('data-sl-drawer')) { continue; }
        try { other.close(); } catch (e) {}
      }
      if (typeof this.dialog.showModal === 'function' && !this.dialog.open) {
        this.lockScroll();
        this.dialog.showModal();
      }
    }

    onCancel(event) {
      event.preventDefault();
      this.decline();
    }

    onDialogClick(event) {
      if (event.target === this.dialog) this.decline();
    }

    close() {
      this.unlockScroll();
      if (this.dialog.open) this.dialog.close();
    }

    lockScroll() {
      document.documentElement.style.overflow = 'hidden';
    }

    /* Only hand scrolling back if nothing else is still holding it. Closing on
       top of an open drawer would otherwise unlock the page underneath it and
       let the shopper scroll the document behind the drawer they are still in. */
    unlockScroll() {
      var open = document.querySelectorAll('dialog[open]');
      for (var i = 0; i < open.length; i++) {
        if (open[i] !== this.dialog) { return; }
      }
      document.documentElement.style.overflow = '';
    }

    setupEditorPreview() {
      this.sectionId = this.getAttribute('data-section-id');
      var self = this;
      this.onEditorSelect = function (event) {
        if (!event.detail || event.detail.sectionId !== self.sectionId) return;
        // Show it the way a shopper would meet it, with a sample suburb.
        self.showConfirm({ suburb: 'Prahran', store: 'Preston' }, function () {});
      };
      this.onEditorDeselect = function (event) {
        if (event.detail && event.detail.sectionId !== self.sectionId) return;
        self.decline();
      };
      document.addEventListener('shopify:section:select', this.onEditorSelect);
      document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
    }
  }

  if (!customElements.get('location-prompt')) {
    customElements.define('location-prompt', LocationPrompt);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-from-range"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class MoreFromRange extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;
        this.emptyTabs = 0;
        this.totalTabs = this.querySelectorAll('.featured-products__panel').length;

        /* Hydrate the initially-active panel now; the rest on first open. The
           tab switching itself belongs to the shared <featured-products>
           element - this listener only triggers the lazy load. */
        var active = this.querySelector('.featured-products__panel:not([hidden])');
        if (active) this.hydrate(active);

        var self = this;
        this.addEventListener('click', function (e) {
          var tab = e.target.closest('.featured-products__tab');
          if (!tab) return;
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) self.hydrate(panel);
        });
      }

      hydrate(panel) {
        var track = panel.querySelector('[data-range-handles]');
        if (!track || track.__mfrDone) return;
        track.__mfrDone = true;
        var self = this;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var handles = (track.getAttribute('data-range-handles') || '')
          .split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, 24);
        if (!handles.length) { this.finish(panel, track, 0); return; }

        Promise.all(handles.map(function (h) {
          return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=recently-viewed-card')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              if (!html) return null;
              var tmp = document.createElement('div');
              tmp.innerHTML = html;
              return tmp.querySelector('.featured-products__slide');
            })
            .catch(function () { return null; });
        })).then(function (slides) {
          var real = slides.filter(Boolean);
          track.querySelectorAll('.featured-products__slide--skeleton').forEach(function (n) { n.remove(); });
          real.forEach(function (slide) { track.appendChild(slide); });
          self.finish(panel, track, real.length);
        });
      }

      /* An empty tab (all fetches failed / products unpublished) is removed;
         if it was active the first remaining tab is opened, and when every
         tab ends up empty the whole section hides. */
      finish(panel, track, count) {
        window.dispatchEvent(new Event('resize'));
        if (count > 0) return;
        if (window.Shopify && window.Shopify.designMode) return;
        this.emptyTabs += 1;
        var tab = this.querySelector('.featured-products__tab[aria-controls="' + panel.id + '"]');
        var wasActive = !panel.hidden;
        if (tab) tab.setAttribute('hidden', '');
        panel.setAttribute('hidden', '');
        if (this.emptyTabs >= this.totalTabs) {
          var section = this.closest('.section--more-from-range');
          if (section) section.setAttribute('hidden', '');
          return;
        }
        if (wasActive) {
          var nextTab = this.querySelector('.featured-products__tab:not([hidden])');
          if (nextTab) nextTab.click();
        }
        window.dispatchEvent(new Event('resize'));
      }
    }

    if (!customElements.get('more-from-range')) {
      customElements.define('more-from-range', MoreFromRange);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-np-dialog]');
      if (!this.dialog) return;

      this.trigger = this.getAttribute('data-trigger') || 'delay';
      this.delayMs = (parseInt(this.getAttribute('data-delay'), 10) || 0) * 1000;
      this.frequency = this.getAttribute('data-frequency') || 'session';
      this.minPageViews = parseInt(this.getAttribute('data-min-page-views'), 10) || 0;
      this.cookieName = 'es_newsletter_dismissed';
      this.storageKey = 'es:newsletter-popup';
      this.pageViewsKey = 'es:page-views';
      this.canStore = this.localStorageAvailable();

      this.dialog.addEventListener('cancel', this.onCancel.bind(this));
      this.dialog.addEventListener('click', this.onDialogClick.bind(this));
      this.onExitIntent = this.onExitIntent.bind(this);
      const closeButton = this.querySelector('[data-np-close]');
      if (closeButton) closeButton.addEventListener('click', this.close.bind(this));

      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      if (this.designMode) {
        this.setupEditorPreview();
        return;
      }

      // Shared page-view counter - incremented once per page load even if
      // several overlay sections read it.
      if (!window.__esPageViewsIncremented) {
        this.writeViews(this.readViews() + 1);
        window.__esPageViewsIncremented = true;
      }

      if (this.isSuppressed()) return;

      if (this.minPageViews > 0 && this.readViews() < this.minPageViews) return;

      this.arm();
    }

    // Arms whichever triggers the merchant configured. Exit intent needs a real
    // cursor - the signal is the pointer leaving through the top of the window,
    // which a touch device never produces - so on touch an exit-only setting
    // falls back to the delay rather than never showing the pop-up at all.
    arm() {
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var wantsExit = this.trigger === 'exit' || this.trigger === 'both';

      if (wantsExit && fine) {
        document.addEventListener('mouseout', this.onExitIntent);
      }
      if (this.trigger !== 'exit' || !fine) {
        this.timer = window.setTimeout(this.maybeOpen.bind(this), this.delayMs);
      }
    }

    disarm() {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
      document.removeEventListener('mouseout', this.onExitIntent);
    }

    // mouseout on the document with no relatedTarget means the cursor left the
    // window rather than moving between elements. clientY <= 0 narrows that to
    // leaving through the TOP edge (toward the tab bar / address bar / close
    // button) - the side exits are just the cursor parking off-window.
    onExitIntent(event) {
      if (event.relatedTarget) return;
      if (event.clientY > 0) return;
      this.maybeOpen();
    }

    disconnectedCallback() {
      this.disarm();
      this.stopWaitingForSearch();
      if (this.onEditorSelect) {
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:block:select', this.onEditorSelect);
      }
      if (this.onEditorDeselect) {
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
        document.removeEventListener('shopify:block:deselect', this.onEditorDeselect);
      }
    }

    maybeOpen() {
      // Yield to an already-open modal (e.g. the geo prompt). Both early exits
      // leave the triggers armed so a later exit intent can still open it.
      if (document.querySelector('dialog[open]')) return;
      /* And to the search overlay, which is not a <dialog> so the check above
         does not see it. Appearing over an open search interrupts someone who
         is mid-task and fights it for the keyboard. Unlike the geo prompt, this
         one re-tries when the search closes: the delay trigger has already
         fired by then and disarms itself, so without that the pop-up would
         simply never appear for anyone who happened to be searching. */
      var search = document.querySelector('predictive-search[open]');
      if (search) {
        this.waitForSearchClose(search);
        return;
      }
      if (this.isSuppressed()) return;
      this.disarm();
      this.markShown();
      this.lockScroll();
      this.showDialog();
    }

    /* Watches the one attribute that matters rather than polling, and only
       while a pop-up is actually waiting on it. */
    waitForSearchClose(search) {
      if (this.searchWatch) return;
      var self = this;
      this.searchWatch = new MutationObserver(function () {
        if (search.hasAttribute('open')) return;
        self.stopWaitingForSearch();
        self.maybeOpen();
      });
      this.searchWatch.observe(search, { attributes: true, attributeFilter: ['open'] });
    }

    stopWaitingForSearch() {
      if (!this.searchWatch) return;
      this.searchWatch.disconnect();
      this.searchWatch = null;
    }

    showDialog() {
      if (typeof this.dialog.showModal === 'function' && !this.dialog.open) {
        this.dialog.showModal();
        /* showModal() auto-focuses the first focusable element, the close X.
           Move focus to the panel instead; it needs tabindex="-1" or .focus()
           is a silent no-op. */
        var panel = this.dialog.querySelector('.newsletter-popup__panel');
        if (panel && typeof panel.focus === 'function') panel.focus();
      }
    }

    onCancel(event) {
      event.preventDefault();
      this.close();
    }

    onDialogClick(event) {
      if (event.target === this.dialog) this.close();
    }

    close() {
      this.unlockScroll();
      if (this.dialog.open) this.dialog.close();
    }

    // Suppression is stored per browser, not per tab. sessionStorage would let
    // every newly-opened tab re-show the pop-up, since each tab starts with an
    // empty store. So:
    // - the day windows keep a timestamp in localStorage, which is shared
    //   across tabs and is not subject to Safari's 7-day cap on cookies
    //   written from script (that cap silently shortens "once per 30 days"),
    // - "once per session" uses a session cookie, the only store that both
    //   spans tabs and ends when the browser does,
    // - if localStorage is unavailable (private mode, blocked storage) the day
    //   windows fall back to the cookie, capped by the browser or not.
    isSuppressed() {
      if (this.frequency === 'session') return this.hasCookie();

      const days = parseInt(this.frequency, 10) || 0;
      if (days <= 0) return false;
      if (!this.canStore) return this.hasCookie();

      const shownAt = this.readShownAt();
      if (!shownAt) return false;
      return Date.now() - shownAt < days * 24 * 60 * 60 * 1000;
    }

    markShown() {
      if (this.frequency === 'session') {
        this.writeCookie(0);
        return;
      }
      if (this.canStore) {
        this.writeShownAt(Date.now());
        return;
      }
      this.writeCookie(parseInt(this.frequency, 10) || 0);
    }

    hasCookie() {
      return document.cookie.split('; ').indexOf(this.cookieName + '=1') !== -1;
    }

    // days: 0 writes a session cookie - no max-age, so it ends with the browser.
    writeCookie(days) {
      let cookie = this.cookieName + '=1; path=/; SameSite=Lax';
      if (days > 0) cookie += '; max-age=' + days * 24 * 60 * 60;
      document.cookie = cookie;
    }

    // 0 for "never shown", so callers can treat it as falsy.
    readShownAt() {
      try {
        const state = JSON.parse(window.localStorage.getItem(this.storageKey) || 'null');
        if (!state) return 0;
        return parseInt(state.shownAt, 10) || 0;
      } catch (e) {
        return 0;
      }
    }

    writeShownAt(timestamp) {
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify({ shownAt: timestamp }));
      } catch (e) {}
    }

    // Page views count across every tab, so opening products in new tabs adds
    // to the same total. Cumulative across visits too: a visitor who has
    // already browsed past the gate stays past it next time. Falls back to the
    // per-tab sessionStorage counter when localStorage is unavailable.
    readViews() {
      if (this.canStore) {
        try {
          return parseInt(window.localStorage.getItem(this.pageViewsKey), 10) || 0;
        } catch (e) {
          return 0;
        }
      }
      return parseInt(this.readSession(this.pageViewsKey), 10) || 0;
    }

    writeViews(count) {
      if (this.canStore) {
        try {
          window.localStorage.setItem(this.pageViewsKey, String(count));
        } catch (e) {}
        return;
      }
      this.writeSession(this.pageViewsKey, String(count));
    }

    localStorageAvailable() {
      try {
        const probe = this.storageKey + ':probe';
        window.localStorage.setItem(probe, '1');
        window.localStorage.removeItem(probe);
        return true;
      } catch (e) {
        return false;
      }
    }

    readSession(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }

    writeSession(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (e) {}
    }

    lockScroll() {
      document.documentElement.style.overflow = 'hidden';
    }

    unlockScroll() {
      document.documentElement.style.overflow = '';
    }

    setupEditorPreview() {
      this.sectionId = this.getAttribute('data-section-id');

      this.onEditorSelect = (event) => {
        if (!event.detail || event.detail.sectionId !== this.sectionId) return;
        this.showDialog();
      };
      this.onEditorDeselect = (event) => {
        if (event.detail && event.detail.sectionId !== this.sectionId) return;
        if (this.dialog.open) this.dialog.close();
      };

      document.addEventListener('shopify:section:select', this.onEditorSelect);
      document.addEventListener('shopify:block:select', this.onEditorSelect);
      document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
      document.addEventListener('shopify:block:deselect', this.onEditorDeselect);
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-badge"]) return;
  try {
    
  /* Paints the badges the rules match onto every badge container on the page.
     The container carries the product's facts as data attributes, worked out in
     Liquid (see snippets/product-badges.liquid), so this only ever compares
     values - it never decides anything about a product itself.

     Containers are re-painted when the DOM changes, because cards arrive after
     load in several places: colour-swatch fragment swaps, Constructor-rendered
     collection and search results, quick view, and infinite scroll. */
  (function () {
    if (window.__esProductBadges) return;
    window.__esProductBadges = true;

    var config = null;

    function rules() {
      if (config) return config;
      var el = document.querySelector('[data-product-badge-rules]');
      if (!el) return null;
      try {
        config = JSON.parse(el.textContent);
      } catch (err) {
        config = { max: 2, rules: [] };
      }
      return config;
    }

    /* One rule against one product's facts. Tags are compared whole and
       lowercased: a substring test would let a rule for "is_new:true" fire on a
       tag like "is_new:true_pending". */
    function matches(rule, facts) {
      switch (rule.type) {
        case 'tag':
          return !!rule.tag && facts.tags.indexOf(rule.tag) !== -1;
        case 'sale':
          return facts.state.indexOf('sale') !== -1;
        case 'lowstock':
          return facts.state.indexOf('lowstock') !== -1;
        case 'instock':
          return facts.state.indexOf('instock') !== -1;
        case 'oos':
          return facts.state.indexOf('oos') !== -1;
        case 'homeclub':
          return facts.state.indexOf('homeclub') !== -1;
        case 'bundle':
          return facts.state.indexOf('bundle') !== -1;
        default:
          return false;
      }
    }

    /* A Low stock badge already tells the shopper the product is in stock, so
       painting In stock beside it adds nothing and crowds the card (#1048).
       When both apply, only Low stock is painted.

       Keyed on a low-stock rule that WOULD actually paint for this product, not
       merely on the product being low: with Low stock hidden or unchecked by the
       merchant it is absent from the rules altogether, and if its condition does
       not match this product it is not painting either - in both of those cases
       In stock still shows exactly as before. The label test mirrors the paint
       loop, which skips a rule with no label. */
    function lowStockPaints(cfg, facts) {
      for (var i = 0; i < cfg.rules.length; i++) {
        var rule = cfg.rules[i];
        if (rule.type === 'lowstock' && rule.label && matches(rule, facts)) return true;
      }
      return false;
    }

    function readFacts(el) {
      return {
        tags: (el.getAttribute('data-badge-tags') || '').split(',').filter(Boolean),
        state: (el.getAttribute('data-badge-state') || '').split(',').filter(Boolean),
        percent: el.getAttribute('data-badge-percent') || '',
        size: el.getAttribute('data-badge-size') || 'default'
      };
    }

    /* Same markup and class names as snippets/badge.liquid, so the badges are
       styled by the design-system CSS rather than anything defined here. */
    function badgeEl(rule, facts) {
      var span = document.createElement('span');
      span.className = 'badge badge--' + facts.size + ' badge--custom';
      if (rule.bg) span.style.setProperty('--badge-bg', rule.bg);
      if (rule.fg) span.style.setProperty('--badge-fg', rule.fg);
      /* textContent, never innerHTML: the label is merchant free text.
         The token is single-brace, {percent}. A double-brace one is read by
         Shopify as a metafield binding and the theme then refuses to save, so
         that form can never reach us and is not handled. */
      span.textContent = String(rule.label).replace(/\{\s*percent\s*\}/g, facts.percent);
      return span;
    }

    function paint(el) {
      var cfg = rules();
      if (!cfg || el.hasAttribute('data-badges-painted')) return;
      el.setAttribute('data-badges-painted', '');

      /* Cleared first rather than appended to. A colour-swatch swap can move an
         already-painted container into the DOM as part of its fragment, and
         appending would stack a second set of badges on top of the first. */
      el.textContent = '';

      var facts = readFacts(el);
      var max = parseInt(cfg.max, 10) || 2;
      var frag = document.createDocumentFragment();
      var count = 0;
      var skipInStock = lowStockPaints(cfg, facts);

      for (var i = 0; i < cfg.rules.length && count < max; i++) {
        var rule = cfg.rules[i];
        if (!rule.label) continue;
        if (rule.type === 'instock' && skipInStock) continue;
        if (!matches(rule, facts)) continue;
        frag.appendChild(badgeEl(rule, facts));
        count++;
      }
      el.appendChild(frag);
    }

    function paintAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var els = scope.querySelectorAll('[data-product-badges]:not([data-badges-painted])');
      for (var i = 0; i < els.length; i++) paint(els[i]);
    }

    function start() {
      paintAll();
      if (!('MutationObserver' in window)) return;
      /* Coalesced into one pass per frame: a Constructor render or a swatch
         swap fires a burst of mutations. */
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          paintAll();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    /* Theme editor: re-read the rules and repaint when the merchant edits or
       reorders a block, otherwise the preview keeps the badges it loaded with. */
    document.addEventListener('shopify:section:load', function () {
      config = null;
      var painted = document.querySelectorAll('[data-badges-painted]');
      for (var i = 0; i < painted.length; i++) {
        painted[i].removeAttribute('data-badges-painted');
        painted[i].innerHTML = '';
      }
      paintAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  // <product-feature>: one media tile with a bottom accordion. Opens on hover /
  // focus (desktop) and on tap / keyboard via the toggle button; a block's video
  // plays only while the tile is expanded. Collapsed by default with JS on.
  (function () {
    if (customElements.get('product-feature')) return;

    var HOVER = window.matchMedia('(hover: hover)');
    var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

    class ProductFeature extends HTMLElement {
      connectedCallback() {
        this.toggleBtn = this.querySelector('.product-features__toggle');
        this.panel = this.querySelector('.product-features__panel');
        this.video = this.querySelector('video');
        this._open = false;
        // Collapsed: keep the panel copy out of the a11y tree + tab order (JS-on
        // only, so it stays reachable with JS off via the <noscript> style).
        if (this.panel) this.panel.inert = true;

        this._onClick = this._onClick.bind(this);
        this._onEnter = this._onEnter.bind(this);
        this._onLeave = this._onLeave.bind(this);

        // Click / tap anywhere on the tile toggles it - this is the path touch
        // devices use at any width (no hover). The toggle button's click and
        // keyboard Enter/Space bubble up here too.
        this.addEventListener('click', this._onClick);
        // Hover preview, pointer devices only.
        if (HOVER.matches) {
          this.addEventListener('pointerenter', this._onEnter);
          this.addEventListener('pointerleave', this._onLeave);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('pointerenter', this._onEnter);
        this.removeEventListener('pointerleave', this._onLeave);
      }

      _onClick(event) {
        if (event.target.closest('a')) return; // let links in the copy work
        this.setOpen(!this._open);
      }
      _onEnter() { this.setOpen(true); }
      _onLeave() { this.setOpen(false); }

      setOpen(open) {
        if (open === this._open) return;
        // Single-open accordion: opening one tile closes any other open tile in
        // the same row. Matters for tap / keyboard, where - unlike hover - there
        // is no pointerleave to close the previously opened tile.
        if (open) this._closeSiblings();
        this._open = open;
        this.classList.toggle('is-open', open);
        if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (this.panel) {
          this.panel.style.height = open ? this.panel.scrollHeight + 'px' : '0px';
          this.panel.inert = !open;
        }
        if (this.video) {
          // Don't auto-play under prefers-reduced-motion - leave the poster.
          if (open && !REDUCE.matches) {
            var playing = this.video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            this.video.pause();
          }
        }
        // Let the carousel re-measure: opening a tile can widen it past the row
        // (e.g. four tiles that otherwise fit exactly), which needs the arrows.
        this.dispatchEvent(new CustomEvent('pf:toggle', { bubbles: true }));
      }

      // Close every other tile in the same row (its parent grid). Guarded so it
      // only calls tiles that have upgraded to the custom element.
      _closeSiblings() {
        var parent = this.parentNode;
        if (!parent) return;
        var tiles = parent.querySelectorAll('product-feature');
        for (var i = 0; i < tiles.length; i++) {
          if (tiles[i] !== this && typeof tiles[i].setOpen === 'function') {
            tiles[i].setOpen(false);
          }
        }
      }
    }

    customElements.define('product-feature', ProductFeature);
  })();

  // Carousel arrows: shown (via CSS, desktop only) when the grid overflows.
  // Clicking scrolls by one tile + gap; the buttons disable at each end and the
  // head's data-scrollable flag toggles their visibility. The grid is natively
  // swipeable, so the arrows are a pointer-only, aria-hidden enhancement.
  (function () {
    if (window.__esProductFeaturesCarousel) return;
    window.__esProductFeaturesCarousel = true;

    var GAP = 8; // --spacing-8, the grid gap between tiles

    function setup(section) {
      if (section.__pfCarousel) return;
      section.__pfCarousel = true;

      var grid = section.querySelector('.product-features__grid');
      var head = section.querySelector('.product-features__head');
      if (!grid || !head) return;
      var prev = head.querySelector('[data-pf-arrow="prev"]');
      var next = head.querySelector('[data-pf-arrow="next"]');

      function sync() {
        var max = grid.scrollWidth - grid.clientWidth;
        head.setAttribute('data-scrollable', max > 1 ? 'true' : 'false');
        if (prev) prev.disabled = grid.scrollLeft <= 1;
        if (next) next.disabled = grid.scrollLeft >= max - 1;
      }

      function step(direction) {
        var tile = grid.querySelector('.product-features__tile');
        var amount = tile ? tile.getBoundingClientRect().width + GAP : grid.clientWidth * 0.8;
        // No explicit behavior: inherit the CSS scroll-behavior so the
        // prefers-reduced-motion override (auto) is respected.
        grid.scrollBy({ left: direction * amount });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      grid.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      // Re-measure after a tile finishes widening / narrowing (its width
      // transition), so the arrows appear once an expanded tile overflows the row
      // and hide again when it collapses. pf:toggle covers the reduced-motion
      // path, where the width changes instantly with no transition to end.
      grid.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'width') sync();
      });
      grid.addEventListener('pf:toggle', sync);
      sync();
    }

    function init(root) {
      (root || document).querySelectorAll('.section--product-features').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specs"] && !Shopify.designMode) return;
  try {
    
  // <product-specs>: clicking a size thumbnail swaps the active title, dimensions
  // drawing, feature image and Download button by index (pure class toggling, so
  // it works with JS off - the first size renders active). No navigation; the
  // Download buttons are real links that open in a new tab.
  (function () {
    if (customElements.get('product-specs')) return;

    var GROUPS = ['data-spec-thumb', 'data-spec-title', 'data-spec-drawing', 'data-spec-table', 'data-spec-download', 'data-spec-feature'];

    class ProductSpecs extends HTMLElement {
      connectedCallback() {
        // Theme editor: selecting a size block should reveal its content. The
        // block's shopify_attributes live on the thumb (data-spec-thumb), so the
        // bubbled select event carries the index. Bound even with one block/no
        // thumbs so a single-block section still responds.
        this._onBlockSelect = this._onBlockSelect.bind(this);
        this.addEventListener('shopify:block:select', this._onBlockSelect);

        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-spec-thumb]'));
        if (!this.thumbs.length) return;
        this._onClick = this._onClick.bind(this);
        var self = this;
        this.thumbs.forEach(function (thumb) { thumb.addEventListener('click', self._onClick); });

        this._warm();
      }

      // Every size's drawing and lifestyle image is already in the page, but the
      // inactive panels are display:none, and a lazy image with no layout box is
      // one the browser never fetches. So the swap used to start the download at
      // click time and the frame sat empty for a beat. Warm them instead: as the
      // section comes near for the ones nobody has asked for yet, and on reach
      // for the size actually being pointed at.
      //
      // esrWarm* lives in snippets/image-warm.liquid, which Shopify compiles
      // into snippet-scripts.js - a deferred script ordered AFTER the
      // scripts.js this file lands in. By the time connectedCallback runs the
      // helpers do not exist yet, so registration goes on __esWarmQueue and
      // image-warm.liquid drains it when it executes (a section that connects
      // after that point runs straight through). See the note there.
      _warm() {
        var self = this;
        (window.__esWarmQueue = window.__esWarmQueue || []).push(function () {
          if (self._warmGone) return;
          self._warmDispose = window.esrWarmWhenNear(self, function () { return self._warmable(); });
          window.esrWarmOnIntent(self.thumbs, function (thumb) {
            return self._imagesFor(thumb.getAttribute('data-spec-thumb'));
          });
        });
      }

      _imagesFor(index) {
        var self = this;
        var imgs = [];
        this._paintedPrefixes().forEach(function (prefix) {
          var panel = self.querySelector(prefix + index + '"]');
          if (panel) imgs.push.apply(imgs, panel.querySelectorAll('img'));
        });
        return imgs;
      }

      // Which panel groups this breakpoint actually paints. An inactive panel
      // is display:none either way, so the question has to be put to the group's
      // ACTIVE member: if that has no box, the whole column is off at this width
      // (the lifestyle image is desktop-only) and warming its siblings would
      // spend a phone's data on images that size can never show. Asking the
      // element rather than re-stating the media query keeps this right if the
      // breakpoint moves.
      _paintedPrefixes() {
        var self = this;
        var active = this.getAttribute('data-active') || '0';
        return ['[data-spec-drawing="', '[data-spec-feature="'].filter(function (prefix) {
          var el = self.querySelector(prefix + active + '"]');
          return el && el.getClientRects().length > 0;
        });
      }

      // Warming order is click order: the sizes either side of the one on show
      // are the likeliest next tap, so they queue first and the ends queue last.
      _warmable() {
        var self = this;
        var active = parseInt(this.getAttribute('data-active'), 10) || 0;
        var imgs = [];
        for (var step = 1; step < this.thumbs.length; step++) {
          if (active - step >= 0) imgs.push.apply(imgs, this._imagesFor(active - step));
          if (active + step < this.thumbs.length) imgs.push.apply(imgs, this._imagesFor(active + step));
        }
        return imgs;
      }

      disconnectedCallback() {
        this.removeEventListener('shopify:block:select', this._onBlockSelect);
        // The theme editor re-renders the section on every settings change, so
        // an observer left running here would accumulate one per edit. The flag
        // also cancels a queued registration that has not been drained yet.
        this._warmGone = true;
        if (this._warmDispose) this._warmDispose();
        if (!this.thumbs) return;
        var self = this;
        this.thumbs.forEach(function (thumb) { thumb.removeEventListener('click', self._onClick); });
      }

      _onClick(event) {
        this.activate(event.currentTarget.getAttribute('data-spec-thumb'));
      }

      _onBlockSelect(event) {
        var el = event.target.closest ? event.target.closest('[data-spec-thumb]') : null;
        if (el) this.activate(el.getAttribute('data-spec-thumb'));
      }

      activate(index) {
        var self = this;
        GROUPS.forEach(function (attr) {
          var els = self.querySelectorAll('[' + attr + ']');
          Array.prototype.forEach.call(els, function (el) {
            var on = el.getAttribute(attr) === index;
            el.classList.toggle('is-active', on);
            if (attr === 'data-spec-thumb') el.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
        this.setAttribute('data-active', index);
      }
    }

    customElements.define('product-specs', ProductSpecs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    if (window.__esProductSection) return;
    window.__esProductSection = true;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* ---------- Constructor: keep the detail container on the selected variant ----------
       The product-variants block already emits a bubbling variant:change event with
       the id and price, so the beacon's variation id and price follow swatch/option
       changes without re-reading the DOM. No-ops when Constructor is off, because
       the attribute is then absent. */
    document.addEventListener('variant:change', function (event) {
      var detail = event.detail || {};
      var container = document.querySelector('[data-cnstrc-product-detail]');
      if (!container || !detail.variantId) return;
      container.setAttribute('data-cnstrc-item-variation-id', detail.variantId);
      if (typeof detail.price === 'number') {
        container.setAttribute('data-cnstrc-item-price', (detail.price / 100).toString());
      }
    });

    /* ---------- Gallery ---------- */
    function setupGallery(el) {
      if (el.__init) return;
      el.__init = true;

      var grid = el.querySelector('[data-gallery-grid]');
      var dialog = el.querySelector('[data-fullscreen]');
      var stage = el.querySelector('[data-fs-stage]');
      if (!dialog || !stage) return;

      var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-fs-slide]'));
      var thumbs = Array.prototype.slice.call(el.querySelectorAll('[data-thumb-index]'));
      var fsThumbs = Array.prototype.slice.call(dialog.querySelectorAll('[data-fs-thumb]'));
      var index = 0;

      /* ---------- Gallery video playback ("Autoplay gallery videos") ----------
         Every gallery video plays, muted and looping, while its tile is at least
         half on screen, and pauses (rewound to its poster frame) when it leaves.
         Videos run independently: two side by side both play.

         Driven from here rather than by the autoplay attribute because engines
         disagree on whether they gate autoplay on visibility, and because the
         zoom overlay needs everything behind it stopped.

         The same observer covers the desktop grid and the mobile carousel - a
         cell scrolled out of the carousel is clipped out of the viewport too.

         Reduced motion opts out entirely: the tile stays on its poster frame
         behind the play icon, and the zoom is the way to watch it. */
      var gridVideos = grid
        ? Array.prototype.slice.call(grid.querySelectorAll('.product__media-img--video video'))
        : [];
      /* media index -> grid video, so opening the zoom can pick up where the
         tile left off instead of restarting the clip. */
      var gridVideoByIndex = {};
      gridVideos.forEach(function (v) {
        var cell = v.closest('[data-media-index]');
        if (cell) gridVideoByIndex[parseInt(cell.getAttribute('data-media-index'), 10)] = v;
      });

      function markVideoState(v) {
        var wrap = v.closest('.product__media-img--video');
        if (wrap) wrap.classList.toggle('is-playing', !v.paused);
      }

      function stopGridVideo(v, rewind) {
        if (!v.paused && typeof v.pause === 'function') v.pause();
        if (rewind) {
          try { v.currentTime = 0; } catch (err) {}
        }
        markVideoState(v);
      }

      function pauseAllGridVideos() {
        gridVideos.forEach(function (v) { stopGridVideo(v, false); });
      }

      /* Re-entry point for the zoom: assigned below when there is anything to
         drive, so closing the dialog can restart whatever is on screen. */
      var resumeGridVideos = function () {};

      if (gridVideos.length) {
        var onScreen = gridVideos.map(function () { return false; });

        function syncVideos() {
          /* Reduced motion and the open zoom both hold everything. The hold
             pauses without rewinding, so closing the zoom picks the clip up
             where it was rather than snapping back to the poster. */
          var hold = reduceMotion.matches || dialog.open;
          gridVideos.forEach(function (v, i) {
            if (hold) {
              stopGridVideo(v, false);
            } else if (!onScreen[i]) {
              stopGridVideo(v, true);
            } else if (v.paused) {
              v.muted = true;
              var started = v.play();
              if (started && started.catch) started.catch(function () {});
            }
          });
        }

        gridVideos.forEach(function (v) {
          v.addEventListener('play', function () { markVideoState(v); });
          v.addEventListener('pause', function () { markVideoState(v); });
        });

        if ('IntersectionObserver' in window) {
          var videoObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var i = gridVideos.indexOf(entry.target);
              if (i > -1) onScreen[i] = entry.isIntersecting && entry.intersectionRatio >= 0.5;
            });
            syncVideos();
          }, { threshold: [0, 0.5] });
          gridVideos.forEach(function (v) { videoObserver.observe(v); });
        } else {
          /* No observer: play them all rather than leaving every tile frozen. */
          onScreen = gridVideos.map(function () { return true; });
          syncVideos();
        }

        if (reduceMotion.addEventListener) {
          reduceMotion.addEventListener('change', syncVideos);
        }

        resumeGridVideos = syncVideos;
      }

      /* Pause every slide video except the one on screen. The zoom stage keeps
         all slides in the DOM, so a video left playing on slide 1 stays audible
         while the visitor looks at slide 3. */
      function pauseHiddenVideos() {
        slides.forEach(function (s, si) {
          if (si === index) return;
          var v = s.querySelector('video');
          if (v && !v.paused && typeof v.pause === 'function') v.pause();
        });
      }

      /* Landing on a video slide starts it, rather than making the visitor find
         the play button a second time after they have already clicked the tile
         (client feedback, #1051). It picks up from wherever the tile had got to,
         and starts muted so nothing blares out of a click - the controls are
         right there to turn sound on, and an unmute is remembered for the rest
         of the session so navigating away and back does not silence it again.
         Reduced motion opts out: the visitor presses play themselves. */
      function playCurrentSlideVideo() {
        if (!dialog.open || reduceMotion.matches) return;
        var slide = slides[index];
        var v = slide && slide.querySelector('video');
        if (!v || typeof v.play !== 'function') return;

        var source = gridVideoByIndex[index];
        if (source && source.currentTime > 0 && !source.ended) {
          var at = source.currentTime;
          if (v.readyState > 0) {
            try { v.currentTime = at; } catch (err) {}
          } else {
            v.addEventListener('loadedmetadata', function once() {
              v.removeEventListener('loadedmetadata', once);
              try { v.currentTime = at; } catch (err) {}
            });
          }
        }
        if (!v.__esAutoMuted) {
          v.muted = true;
          v.__esAutoMuted = true;
        }
        var started = v.play();
        if (started && started.catch) started.catch(function () {});
      }

      function show(i) {
        if (i < 0) i = slides.length - 1;
        if (i >= slides.length) i = 0;
        index = i;
        var target = slides[i];
        if (target) target.scrollIntoView({ block: 'nearest', inline: 'center' });
        pauseHiddenVideos();
        playCurrentSlideVideo();
        fsThumbs.forEach(function (t, ti) {
          var on = ti === index;
          t.classList.toggle('is-active', on);
          if (on) {
            t.setAttribute('aria-current', 'true');
            t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          } else {
            t.removeAttribute('aria-current');
          }
        });
        resetZoom();
      }

      function openAt(i) {
        /* Nothing should be running behind the overlay. */
        pauseAllGridVideos();
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        /* Lock page scroll while zoom is open (matches the drawer/popup pattern). */
        document.documentElement.style.overflow = 'hidden';
        show(i);
      }

      function close() {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      }

      /* Restore scroll on any close path (button, Escape, backdrop), and stop
         any slide video so it does not keep playing behind the closed dialog. */
      dialog.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
        slides.forEach(function (s) {
          var v = s.querySelector('video');
          if (v && !v.paused && typeof v.pause === 'function') v.pause();
        });
        /* Back to the grid: whatever is on screen picks up again. */
        resumeGridVideos();
      });

      /* Zoom disabled (section setting, e.g. the gift card template): the
         fullscreen dialog stays in the DOM but nothing opens it. */
      if (grid && !el.hasAttribute('data-zoom-disabled')) {
        grid.addEventListener('click', function (e) {
          var cell = e.target.closest('[data-media-index]');
          if (cell) openAt(parseInt(cell.getAttribute('data-media-index'), 10) || 0);
        });
      }

      /* Scroll-indicator mode: light up the dot for the current slide as the
         mobile carousel scrolls (rAF-throttled). Harmless in thumbnail mode -
         the dots are hidden by CSS. */
      var dots = Array.prototype.slice.call(el.querySelectorAll('[data-dot]'));
      var progressFill = el.querySelector('.product__scroll-progress-fill');
      if (grid && (dots.length || progressFill)) {
        var indTicking = false;
        grid.addEventListener('scroll', function () {
          if (indTicking) return;
          indTicking = true;
          requestAnimationFrame(function () {
            var w = grid.clientWidth || 1;
            var active = Math.round(grid.scrollLeft / w);
            dots.forEach(function (d, di) { d.classList.toggle('is-active', di === active); });
            if (progressFill) {
              var max = grid.scrollWidth - grid.clientWidth;
              var p = max > 0 ? grid.scrollLeft / max : 0;
              progressFill.style.width = (p * 100) + '%';
            }
            indTicking = false;
          });
        });
      }

      /* "View all images (X)": two-way toggle for the media beyond the first 6
         (desktop). Expanding swaps the label to "Hide additional images"; clicking
         again collapses back to the first 6. Labels come from the data-label-*
         attributes so the strings stay translatable. */
      var toggle = el.querySelector('[data-gallery-toggle]');
      if (toggle) {
        var toggleLabel = toggle.querySelector('.button__label');
        toggle.addEventListener('click', function () {
          /* Where the button sits on screen right now. Collapsing removes a
             screenful of images from ABOVE it, so with no compensation the
             button - and everything the reader was looking at with it - jumps up
             the page by however tall those images were. Read before the class
             flips, since that is what reflows. */
          var anchorTop = toggle.getBoundingClientRect().top;
          var expanded = el.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          if (toggleLabel) {
            toggleLabel.textContent = expanded
              ? toggle.getAttribute('data-label-hide')
              : toggle.getAttribute('data-label-show');
          }
          /* Hold the button exactly where it was (#19503936). This replaces
             landing it below the header (design QA 5229902), which overshot by
             most of a viewport: the button is at the BOTTOM of the gallery, so
             putting it at the TOP of the screen filled the rest with Product
             Features - the "features are pulled up" the client reported.
             Anchoring removes the choice of landing spot altogether. Wherever
             the reader collapsed from is where they stay, and since the button
             has to be on screen to be clicked, it always is.

             Held over several frames, not one. Layout settles asynchronously:
             the button is absolutely positioned over the LAST VISIBLE image,
             which is a different image once the extras are gone, and measuring
             once left it 44px out when a late reflow landed two frames after
             the correction. Each pass recomputes from the button's current
             position, so it is idempotent - a late shift is simply absorbed by
             the next frame. Bounded, and abandoned the moment the reader scrolls
             for themselves, so it can never fight a real gesture.

             Deliberately instant, never smooth. The correction lands in the same
             frame as the reflow, so nothing appears to scroll at all: the extra
             images vanish and the button does not move. Animating it would do
             the opposite - the button would leap most of a screen away and then
             glide back, which is the jump this exists to prevent. */
          if (!expanded) {
            var framesLeft = 12;
            var abandon = function () { framesLeft = 0; };
            window.addEventListener('wheel', abandon, { passive: true, once: true });
            window.addEventListener('touchstart', abandon, { passive: true, once: true });
            window.addEventListener('keydown', abandon, { once: true });
            (function hold() {
              if (framesLeft-- <= 0) {
                window.removeEventListener('wheel', abandon);
                window.removeEventListener('touchstart', abandon);
                window.removeEventListener('keydown', abandon);
                return;
              }
              var drift = toggle.getBoundingClientRect().top - anchorTop;
              if (Math.abs(drift) > 1) {
                window.scrollTo({ top: window.pageYOffset + drift, behavior: 'auto' });
              }
              requestAnimationFrame(hold);
            })();
          }
        });
      }

      var closeBtn = el.querySelector('[data-fs-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);
      var prevBtn = el.querySelector('[data-fs-prev]');
      if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
      var nextBtn = el.querySelector('[data-fs-next]');
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });

      /* Fullscreen thumbnail rail: click a thumb to jump to that slide. */
      fsThumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          show(parseInt(t.getAttribute('data-fs-thumb'), 10) || 0);
        });
      });

      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(index - 1);
        else if (e.key === 'ArrowRight') show(index + 1);
      });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-thumb-index'), 10) || 0;
          if (grid) {
            var cell = grid.querySelector('[data-media-index="' + i + '"]');
            if (cell) cell.scrollIntoView({ block: 'nearest', inline: 'center' });
          }
          thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
          t.setAttribute('aria-current', 'true');
        });
      });

      /* Mobile pinch state. Declared up here because resetZoom clears it too:
         a zoom belongs to the slide it was made on, so changing slide or closing
         the overlay has to start the next one from scratch. */
      var scale = 1;
      var panX = 0;
      var panY = 0;

      /* Desktop cursor-follow zoom on the active fullscreen image. */
      function resetZoom() {
        slides.forEach(function (s) {
          s.classList.remove('is-zoomed');
          var img = s.querySelector('[data-fs-zoomable]');
          if (img) {
            img.style.transformOrigin = 'center center';
            /* Clears the mobile pinch transform. Desktop's scale lives in CSS on
               .is-zoomed, which the class removal above already handles. */
            img.style.transform = '';
          }
        });
        scale = 1;
        panX = 0;
        panY = 0;
      }

      stage.addEventListener('click', function (e) {
        var img = e.target.closest('[data-fs-zoomable]');
        if (!img) return;
        var slide = img.closest('[data-fs-slide]');
        if (slide) slide.classList.toggle('is-zoomed');
      });

      stage.addEventListener('mousemove', function (e) {
        var img = e.target.closest('[data-fs-zoomable]');
        if (!img) return;
        var slide = img.closest('[data-fs-slide]');
        if (!slide || !slide.classList.contains('is-zoomed')) return;
        var rect = img.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });

      /* Mobile: pinch-to-zoom, pan while zoomed, swipe when not (#19503936).

         The stage has to OWN the gesture. Previously both touch listeners were
         passive, so neither could preventDefault and iOS ran its own pinch on the
         whole document: the close button and the arrows scaled along with the
         image, and the native zoom fought the JS transform - the jutter that was
         reported. touchmove is now non-passive and cancels the default while it
         is driving the image, with touch-action:none on the stage and the WebKit
         gesture events cancelled below.

         Zoom also has to SURVIVE the release. The old handler reset scale to 1 on
         every touchend once the fingers were up, so the zoom was thrown away and
         the next one-finger drag - the reader trying to move around the image -
         passed the scale <= 1 swipe guard and paged to the next image instead.
         Scale and pan now persist until the reader pinches back out, changes
         slide or closes, and a one-finger drag pans while zoomed. */
      var touchStartX = 0;
      var touchStartY = 0;
      var lastDist = 0;
      var panStartX = 0;
      var panStartY = 0;
      var gesture = '';
      var zoomFrame = 0;

      function activeZoomImage() {
        var slide = slides[index];
        return slide ? slide.querySelector('[data-fs-zoomable]') : null;
      }

      function applyZoom(img) {
        if (!img) return;
        img.style.transform = scale > 1
          ? 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')'
          : '';
      }

      /* One write per frame. touchmove fires far faster than the compositor can
         paint, and writing transform on every event is the other half of the
         jutter. */
      function queueZoom(img) {
        if (zoomFrame) return;
        zoomFrame = requestAnimationFrame(function () {
          zoomFrame = 0;
          applyZoom(img);
        });
      }

      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          gesture = 'pinch';
          lastDist = touchDistance(e.touches);
        } else if (e.touches.length === 1) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          panStartX = panX;
          panStartY = panY;
          /* Zoomed in, a drag moves the image; zoomed out, it changes image. */
          gesture = scale > 1 ? 'pan' : 'swipe';
        }
      }, { passive: true });

      stage.addEventListener('touchmove', function (e) {
        var img = activeZoomImage();
        if (!img) return;
        if (e.touches.length === 2) {
          e.preventDefault();
          var dist = touchDistance(e.touches);
          if (lastDist) {
            scale = Math.min(4, Math.max(1, scale * (dist / lastDist)));
            if (scale === 1) {
              panX = 0;
              panY = 0;
            }
            queueZoom(img);
          }
          lastDist = dist;
        } else if (e.touches.length === 1 && gesture === 'pan') {
          e.preventDefault();
          panX = panStartX + (e.touches[0].clientX - touchStartX);
          panY = panStartY + (e.touches[0].clientY - touchStartY);
          queueZoom(img);
        }
      }, { passive: false });

      stage.addEventListener('touchend', function (e) {
        if (gesture === 'swipe' && scale <= 1 && e.changedTouches.length) {
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          /* Horizontal intent only, so a mostly-vertical drag does not page. */
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            show(dx < 0 ? index + 1 : index - 1);
          }
        }
        if (e.touches.length === 0) {
          lastDist = 0;
          gesture = '';
          /* Pinched back to fit - drop the pan so the image re-centres. A zoom
             that is still in is deliberately KEPT across the release. */
          if (scale <= 1) {
            scale = 1;
            panX = 0;
            panY = 0;
            applyZoom(activeZoomImage());
          }
        }
      });

      /* WebKit only. Safari raises its own gesture events for a document pinch
         and will zoom the page even with touch-action set, so these have to be
         cancelled too. Scoped to the dialog, so pinch-zoom on the rest of the
         site is untouched. */
      ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (type) {
        dialog.addEventListener(type, function (e) { e.preventDefault(); });
      });

      function touchDistance(t) {
        var dx = t[0].clientX - t[1].clientX;
        var dy = t[0].clientY - t[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
    }

    /* ---------- Add-to-cart failure messaging (#1110) ---------- */
    /* Shopify's own wording, which names the product, in preference to anything
       we could invent. `description` and `message` carry the same sentence on a
       422; the fallback covers a network error or a non-JSON body, where there
       is nothing to quote. */
    function cartAddMessage(body) {
      if (body && typeof body === 'object') {
        if (body.description) return String(body.description);
        if (body.message) return String(body.message);
      }
      return '';
    }
    var CART_ADD_FALLBACK = 'Sorry, this could not be added to your cart. Please try again.';
    /* Empty text CLEARS and hides - that is the fresh-submit reset. A failure
       never passes empty: the catch passes the fallback, because a network
       error or a non-JSON body has no sentence of Shopify's to quote and
       silence is the bug being fixed. */
    function showCartAddError(form, text) {
      var box = form.querySelector('[data-cart-add-error]');
      if (!box) return;
      box.textContent = text || '';
      box.hidden = !text;
    }

    /* ---------- Product form (ATC + anchor scroll) ---------- */
    /* Colour/size are sibling products (each selection is a link to another
       product page), so there is no in-page variant switching here. */
    function setupForm(el) {
      if (el.__init) return;
      el.__init = true;

      var form = el.querySelector('form');
      if (!form) return;

      /* AJAX add to cart: dispatch cart:updated so the cart drawer opens.

         #1110: a REFUSED add used to be indistinguishable from a successful
         one. Shopify answers 422 with a JSON body that names the product
         ("... is already sold out"), but this read response.json() without
         checking response.ok, so the error parsed cleanly and was dispatched
         on cart:updated as though it were an added line - the drawer re-read
         the cart, found nothing new, and said nothing. Zoey hit it on a Mix &
         Match component; it applies to every add from a product page, a real
         shopper's version being the last unit selling between page load and
         click. The empty .catch() hid the rest. */
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var atc = el.querySelector('[data-atc]');
        if (atc) atc.setAttribute('aria-busy', 'true');
        showCartAddError(form, '');
        fetch(form.action, {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: new FormData(form)
        })
          .then(function (r) {
            return r.json().then(function (body) { return { ok: r.ok, body: body }; });
          })
          .then(function (res) {
            if (!res.ok) {
              showCartAddError(form, cartAddMessage(res.body) || CART_ADD_FALLBACK);
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item: res.body } }));
          })
          .catch(function () { showCartAddError(form, CART_ADD_FALLBACK); })
          .then(function () { if (atc) atc.removeAttribute('aria-busy'); });
      });
    }

    /* ---------- Scroll-to-next-section button ---------- */
    function setupScrollNext(btn) {
      if (btn.__init) return;
      btn.__init = true;

      var section = btn.closest('.shopify-section');
      if (!section) return;

      /* The button exists only to get the reader down to the gallery's editorial
         card, so it is tied to that card rather than to the next section on the
         template (design QA 5229879). The card is desktop-only (display:none
         below 1104px), so an offsetParent check covers "rendered but hidden". */
      var editorial = section.querySelector('.product__editorial');
      if (!editorial || editorial.offsetParent === null ||
          editorial.getBoundingClientRect().height <= 1) {
        btn.hidden = true;
        return;
      }

      /* One-shot: once the reader has either clicked it or reached the card on
         their own, the prompt has done its job and stays gone for the life of
         the page. Only a reload brings it back. */
      var retired = false;
      function retire() {
        if (retired) return;
        retired = true;
        btn.hidden = true;
        if (observer) observer.disconnect();
      }

      /* Any part of the card entering the viewport counts as "arrived", whether
         the reader scrolled there or the button took them. Fires on load too if
         the card already happens to be in view, which is the right outcome -
         there would be nothing to scroll to. */
      var observer = null;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { retire(); return; }
          }
        });
        observer.observe(editorial);
      }

      /* Synchronous first read so the button never paints only to be retired a
         frame later by the observer's initial callback. */
      var box = editorial.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) {
        retire();
        return;
      }

      btn.hidden = false;

      btn.addEventListener('click', function () {
        var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
        var top = editorial.getBoundingClientRect().top + window.pageYOffset - headerH;
        window.scrollTo({ top: top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        /* Retire on click rather than waiting for the observer: with reduced
           motion the jump is instant, and the button should not flicker. */
        retire();
      });
    }

    /* ---------- Editorial "Read more" -> open the Product description drawer ---------- */
    /* Scroll anchoring reads the panel's growth as content shifting and scrolls
       to compensate, which looks like the card opening upwards. Held off across
       the toggle and released once the animation has had time to finish; a
       second click just restarts the timer. */
    var releaseAnchoring;
    function suppressScrollAnchoring() {
      document.body.classList.add('is-editorial-toggling');
      clearTimeout(releaseAnchoring);
      releaseAnchoring = setTimeout(function () {
        document.body.classList.remove('is-editorial-toggling');
      }, 450);
    }

    /* Read more expands the rest of the description in place. It used to click
       the Product description drawer's trigger, but that drawer now renders
       esr.feature_list and is absent whenever a product has no features - the
       description would have lost its Read more along with it. */
    function setupEditorialReadMore(btn) {
      if (btn.__init) return;
      btn.__init = true;

      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) { btn.hidden = true; return; }

      var labelEl = btn.querySelector('.button__label') || btn;
      var labelMore = btn.getAttribute('data-label-more') || 'Read more';
      var labelLess = btn.getAttribute('data-label-less') || 'Read less';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* height: auto once open, so the region keeps up with a variant swap or a
         reflow rather than staying pinned to the height measured on click. */
      function settleOpen() {
        panel.classList.remove('product__editorial-rest--animating');
        panel.style.height = 'auto';
      }

      /* Set by the click handler so the settle can hold the same position. */
      var pinAfterSettle = null;

      btn.addEventListener('click', function () {
        suppressScrollAnchoring();
        /* overflow-anchor tells the browser not to compensate; pinning enforces
           it. The panel must only ever grow downwards, and the reader's
           position must not move under them either way. Restored on the frame
           after the mutation - when any anchoring adjustment lands - and again
           once the animation settles, rather than continuously, so a shopper
           scrolling mid-animation is not fought. */
        var pinnedY = window.scrollY;
        var pin = function () {
          if (Math.abs(window.scrollY - pinnedY) > 1) window.scrollTo(0, pinnedY);
        };
        pinAfterSettle = pin;
        requestAnimationFrame(function () {
          pin();
          requestAnimationFrame(pin);
        });

        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        labelEl.textContent = open ? labelMore : labelLess;

        if (reduce) {
          panel.style.height = open ? '0px' : 'auto';
          return;
        }

        /* Both directions animate from a concrete height: an `auto` start or
           end point has nothing to interpolate against. */
        panel.classList.add('product__editorial-rest--animating');
        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          void panel.offsetHeight;
          panel.style.height = '0px';
        } else {
          panel.style.height = '0px';
          void panel.offsetHeight;
          panel.style.height = panel.scrollHeight + 'px';
          /* transitionend is the normal path to height:auto, but it never
             arrives if the element stops being rendered mid-animation - a
             backgrounded tab pauses the transition outright. Left pinned to the
             height measured on click, the panel would clip its own copy the
             moment anything reflowed it, so a timer settles it either way. */
          var settled = false;
          var finish = function () {
            if (settled) return;
            settled = true;
            panel.removeEventListener('transitionend', onEnd);
            settleOpen();
            if (pinAfterSettle) pinAfterSettle();
          };
          var onEnd = function (e) {
            if (e.propertyName === 'height') finish();
          };
          panel.addEventListener('transitionend', onEnd);
          setTimeout(finish, 400);
        }
      });
    }

    function init(root) {
      (root || document).querySelectorAll('[data-product-gallery]').forEach(setupGallery);
      (root || document).querySelectorAll('[data-product-form]').forEach(setupForm);
      (root || document).querySelectorAll('[data-scroll-next]').forEach(setupScrollNext);
      (root || document).querySelectorAll('[data-editorial-readmore]').forEach(setupEditorialReadMore);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["range-modal"]) return;
  try {
    
  (function () {
    if (window.__esRangeModal) return;
    window.__esRangeModal = true;

    var MODAL_ID = 'range-modal';

    var DRAG_THRESHOLD = 5; // px of travel before a press counts as a drag, not a click

    /* Where a deferred range comes from. A card rendered `slim` (the collection
       grid's Constructor rebuilds - see sections/constructor-card-data.liquid)
       leaves its <template> out, because server-rendering a nested card per
       sibling size was 15% of a whole grid rebuild for a drawer that may never be
       opened. The full card still carries the template, so the range is fetched
       from that rather than from a third render path. */
    var RANGE_SOURCE_SECTION = 'constructor-card';
    var rangeHtml = {};
    /* Which range the modal is currently showing. A shopper can close one and
       open another before a slow fetch returns, and that response must not land
       in someone else's modal. */
    var openToken = 0;

    function fetchRange(handle) {
      if (rangeHtml[handle]) return rangeHtml[handle];
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) +
        '?section_id=' + RANGE_SOURCE_SECTION;
      rangeHtml[handle] = fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .catch(function () { return ''; })
        .then(function (html) {
          /* Only a SUCCESS is worth keeping. Caching the empty string too would
             mean one dropped request left that product's range permanently
             unopenable for the rest of the page's life, with the modal showing an
             empty strip and no way to retry. Forgetting it costs a refetch on the
             next click, which is what the shopper is asking for anyway. */
          if (!html) delete rangeHtml[handle];
          return html;
        });
      return rangeHtml[handle];
    }

    function parts() {
      var modal = document.getElementById(MODAL_ID);
      if (!modal) return null;
      return {
        modal: modal,
        track: modal.querySelector('[data-range-track]'),
        controls: modal.querySelector('[data-range-controls]'),
        progress: modal.querySelector('[data-range-progress]'),
        fill: modal.querySelector('[data-range-fill]'),
        prev: modal.querySelector('[data-range-arrow="prev"]'),
        next: modal.querySelector('[data-range-arrow="next"]'),
        status: modal.querySelector('[data-range-status]')
      };
    }

    function refresh(p) {
      if (!p || !p.track) return;
      var scrollable = p.track.scrollWidth - p.track.clientWidth > 1;
      if (p.controls) p.controls.hidden = !scrollable;
      // A scrollable region needs to be reachable by keyboard, so the track
      // takes a tab stop only while it actually scrolls (no dead tab stop for a
      // range that fits).
      if (scrollable) {
        p.track.setAttribute('tabindex', '0');
      } else {
        p.track.removeAttribute('tabindex');
      }
      updateFill(p);
    }

    function updateFill(p) {
      if (!p || !p.track) return;
      var max = p.track.scrollWidth - p.track.clientWidth;
      if (p.fill) {
        var ratio = max > 0 ? p.track.scrollLeft / max : 0;
        if (ratio < 0) ratio = 0;
        if (ratio > 1) ratio = 1;
        p.fill.style.width = (ratio * 100) + '%';
      }
      if (p.prev) p.prev.disabled = p.track.scrollLeft <= 1;
      if (p.next) p.next.disabled = p.track.scrollLeft >= max - 1;
    }

    // One card + gap per arrow press, matching the featured products carousel.
    function scrollByCard(p, direction) {
      if (!p || !p.track) return;
      var card = p.track.querySelector('.product-card');
      var step = card ? card.getBoundingClientRect().width + 8 : p.track.clientWidth * 0.8;
      // No explicit behavior: inherit the CSS scroll-behavior so the
      // prefers-reduced-motion override (auto) is respected.
      p.track.scrollBy({ left: direction * step });
    }

    // Drag-to-scroll for mouse/pen. The track is a native overflow scroller, so
    // trackpads and touch already work; a mouse press-and-drag did nothing and
    // dragging a card image started the browser's native image drag instead.
    // Same pattern as hero.liquid / shop-by-category.liquid.
    function setupDrag(track) {
      if (track.__esDragInit) return;
      track.__esDragInit = true;

      var dragging = false;
      var moved = false;
      var pointerId = null;
      var startX = 0;
      var startLeft = 0;

      function release() {
        if (pointerId == null) return;
        if (track.releasePointerCapture && track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
          try { track.releasePointerCapture(pointerId); } catch (err) {}
        }
        pointerId = null;
      }

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // native touch scrolling handles this
        if (e.button !== 0) return;
        if (track.scrollWidth <= track.clientWidth) return; // nothing to scroll
        dragging = true;
        moved = false;
        pointerId = e.pointerId;
        startX = e.clientX;
        startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', function (e) {
        if (!dragging || e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        if (!moved) {
          if (Math.abs(dx) <= DRAG_THRESHOLD) return;
          moved = true;
          // Captured only once the gesture is genuinely a drag: capturing on
          // pointerdown would retarget an ordinary card click to the track and
          // swallow the link.
          if (track.setPointerCapture) {
            try { track.setPointerCapture(pointerId); } catch (err) {}
          }
        }
        e.preventDefault();
        track.scrollLeft = startLeft - dx;
      });

      function end(e) {
        if (!dragging || (e && e.pointerId !== pointerId)) return;
        dragging = false;
        track.classList.remove('is-dragging');
        release();
      }

      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);

      // A drag must not also follow the card's link. 'moved' is cleared by the
      // next pointerdown, so a drag that ends without a click can't swallow the
      // click after it.
      track.addEventListener('click', function (e) {
        if (!moved) return;
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }, true);

      // The cards are links wrapping images, so without this the browser starts
      // its own native drag and the track never moves.
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    function setupControls(p) {
      if (!p || !p.track || p.track.__esControlsInit) return;
      p.track.__esControlsInit = true;
      setupDrag(p.track);
      if (p.prev) p.prev.addEventListener('click', function () { scrollByCard(parts(), -1); });
      if (p.next) p.next.addEventListener('click', function () { scrollByCard(parts(), 1); });
    }

    // Everything that can only be done once the dialog is actually open.
    function settleOpen(p) {
      // Back to the first card. Reset only once the modal is open: the track
      // has no layout box while the dialog is closed, so a scrollLeft written
      // then is dropped, and the next range opened after a scrolled one started
      // part-way in (snapped to whichever card was showing). scroll-behavior is
      // suspended over the assignment so the strip does not visibly slide back
      // as the modal appears.
      p.track.style.scrollBehavior = 'auto';
      p.track.scrollLeft = 0;
      p.track.style.scrollBehavior = '';
      // A11y: announce the range size once the dialog is open.
      if (p.status) {
        var count = p.track.querySelectorAll('.product-card').length;
        p.status.textContent = (count === 1 ? 'Showing 1 product' : 'Showing ' + count + ' products') + ' in the range';
      }
      // Recompute once laid out (cloned images/widths settle after open).
      requestAnimationFrame(function () { refresh(p); });
    }

    // Open: clone the triggering card's range template into the shared modal.
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-range-trigger]');
      if (!trigger) return;
      event.preventDefault();

      var card = trigger.closest('.product-card');
      var template = card ? card.querySelector('template[data-range-template]') : null;
      var deferred = card ? card.getAttribute('data-range-deferred') : null;
      var p = parts();
      if (!p || !p.track) return;

      var token = ++openToken;

      if (template) {
        p.track.innerHTML = '';
        p.track.appendChild(template.content.cloneNode(true));
      } else if (deferred) {
        // A slim card carries no range. Open on the click as usual and fill when
        // the fetch lands, rather than holding the modal shut over a round trip -
        // the same trade the grid itself makes.
        p.track.innerHTML = '';
        p.track.setAttribute('aria-busy', 'true');
      }
      setupControls(p);
      refresh(p);

      if (window.esDrawer) {
        window.esDrawer.open(MODAL_ID, trigger);
      }
      settleOpen(p);

      if (!template && deferred) {
        fetchRange(deferred).then(function (html) {
          // Superseded by a later open - the response belongs to a range the
          // shopper has already navigated away from.
          if (token !== openToken) return;
          p.track.removeAttribute('aria-busy');
          if (!html) return;
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var fetched = holder.querySelector('template[data-range-template]');
          if (!fetched) return;
          // Park the template on the card so reopening this range is instant and
          // no longer depends on the network.
          if (card) card.appendChild(fetched);
          p.track.innerHTML = '';
          p.track.appendChild(fetched.content.cloneNode(true));
          setupControls(p);
          refresh(p);
          settleOpen(p);
        });
      }
    });

    // Progress + scrollable state follow the track scroll and viewport resize.
    document.addEventListener('scroll', function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-range-track]')) {
        updateFill(parts());
      }
    }, true);

    window.addEventListener('resize', function () { refresh(parts()); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('reviews-summary')) return;

    var STARS = [5, 4, 3, 2, 1];

    class ReviewsSummary extends HTMLElement {
      connectedCallback() {
        var apiUrl = this.dataset.apiUrl;
        var storeId = this.dataset.storeId;
        if (!apiUrl || !storeId || this._loaded) return;
        this._loaded = true;
        this.load(apiUrl, storeId);
      }

      load(apiUrl, storeId) {
        var self = this;
        // On a product page a SKU is present -> query that product's reviews.
        // Otherwise fall back to the store-level (company) reviews summary.
        // Both run through timeline/data - the endpoint the REVIEWS.io Polaris
        // widget itself calls - with enable_syndication=true HARDCODED, so this
        // summary counts exactly what the widget beside it shows, syndicated
        // reviews included. The old five-call /product/reviews pipeline could
        // not see syndicated reviews (the merchant REST API has no syndication
        // parameter), which is how NZ rendered "0 Reviews" directly above a
        // widget showing six. One request replaces the old five, and it sends
        // no API key - timeline/data is public per store key.
        var sku = this.dataset.sku;
        var root = apiUrl.replace(/\/+$/, '');
        var url = root + '/timeline/data' +
          '?type=' + (sku ? 'product_review' : 'store_review') +
          '&store=' + encodeURIComponent(storeId) +
          (sku ? '&sku=' + encodeURIComponent(sku) : '') +
          '&enable_syndication=true' +
          '&page=1';

        this.classList.add('reviews--loading');

        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            self.classList.remove('reviews--loading');
            var stats = (data && data.stats) || {};
            var buckets = [];
            if (data && data.aggregations && data.aggregations.ratings && data.aggregations.ratings.buckets) {
              buckets = data.aggregations.ratings.buckets;
            }
            // Per-star histogram from the ratings aggregation. A star absent
            // from buckets has no reviews at that rating, so every star is
            // zeroed first.
            var counts = {};
            STARS.forEach(function (star) { counts[star] = 0; });
            var barTotal = 0;
            var weighted = 0;
            buckets.forEach(function (bucket) {
              var star = parseInt(bucket.key, 10);
              var count = parseInt(bucket.doc_count, 10);
              if (isNaN(count) || !Object.prototype.hasOwnProperty.call(counts, star)) return;
              counts[star] = count;
              barTotal += count;
              weighted += star * count;
            });
            // stats.review_count is the authoritative total; the average stays
            // DERIVED from the buckets (not stats.average_rating, a 2-dp
            // string) so the rendered output is arithmetically identical to
            // the old five-call pipeline.
            var total = parseInt(stats.review_count, 10);
            if (isNaN(total)) total = barTotal;
            if (total <= 0) {
              // No reviews from the API. Either hide the whole section (incl.
              // the nested app block) or keep the empty scaffold.
              if (self.dataset.hideWhenEmpty === 'true') self.hideSection();
              return;
            }
            self.render(counts, total, barTotal > 0 ? weighted / barTotal : 0);
          })
          .catch(function () {
            self.classList.remove('reviews--loading');
          });
      }

      render(counts, total, average) {
        var scoreEl = this.querySelector('[data-reviews-score]');
        // Two decimals to match the REVIEWS.io app's displayed average.
        // Matches the Liquid above: two decimals, unless they are both zero.
        var avg2 = Math.round(average * 100) / 100;
        var avgText = avg2 % 1 === 0 ? String(avg2) : avg2.toFixed(2);
        if (scoreEl) scoreEl.textContent = avgText + '/5';

        var countEl = this.querySelector('[data-reviews-count]');
        if (countEl) countEl.textContent = total;

        this.renderStars(average);

        var self = this;
        STARS.forEach(function (star) {
          var count = counts[star] || 0;
          var pct = total > 0 ? (count / total) * 100 : 0;
          var fill = self.querySelector('[data-reviews-fill="' + star + '"]');
          if (fill) fill.style.setProperty('--fill', pct.toFixed(2) + '%');
          var barCount = self.querySelector('[data-reviews-bar-count="' + star + '"]');
          if (barCount) barCount.textContent = count;
        });
      }

      renderStars(average) {
        var fill = this.querySelector('[data-reviews-stars-fill]');
        if (!fill) return;
        var pct = Math.max(0, Math.min(100, (average / 5) * 100));
        fill.style.setProperty('--fill', pct.toFixed(2) + '%');
      }

      hideSection() {
        var section = this.closest('.section--reviews');
        if (section) section.style.display = 'none';
      }
    }

    customElements.define('reviews-summary', ReviewsSummary);
  })();

  /* Our section's "Write a review" button opens the nested REVIEWS.io app
     form rather than navigating. It does this by clicking the app's own
     (hidden) "Write Review" button, so the app runs its normal open/submit
     logic. The button lives in .header__inner, which we hide with CSS -- a
     display:none element still receives a programmatic .click(). Bound once
     at document level so it survives the widget loading in asynchronously. */
  (function () {
    if (window.__esrReviewsWriteBound) return;
    window.__esrReviewsWriteBound = true;

    function findAppWriteButton(widget) {
      var buttons = widget.querySelectorAll('.R-Button');
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].textContent.trim() === 'Write Review') {
          return buttons[i];
        }
      }
      return null;
    }

    function openReviewForm(attempt) {
      attempt = attempt || 0;
      var widget = document.querySelector('.reviews-io-polaris-widget');
      var appButton = widget ? findAppWriteButton(widget) : null;
      if (appButton) {
        appButton.click();
        widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      // The app widget renders asynchronously; retry briefly if it isn't ready.
      if (attempt < 20) {
        setTimeout(function () { openReviewForm(attempt + 1); }, 150);
      }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-reviews-write]');
      if (!trigger) return;
      e.preventDefault();
      openReviewForm(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  /* ---------- Constructor: the product grid only ----------
     Fills the products grid from search.getSearchResults. Everything else on the page
     - the tabs, filter bar, toolbar and the Collections / Pages / Articles panels -
     is Shopify's and is left alone, because Constructor indexes products only.

     Facets and sorting are a separate piece of work (#647); the response carries them
     but nothing here consumes them yet. */
  (function () {
    var root = document.querySelector('.search-results[data-cnstrc-search-engine]');
    if (!root || !window.esrConstructor) return;

    var grid = root.querySelector('[data-cnstrc-grid]');
    if (!grid) return;

    /* The shared filter bar's count carries data-collection-count; the bespoke
       toolbar it replaced carried data-cnstrc-count. Accept either so the engine
       still rewrites the total (design QA #19669138). */
    var countEl = root.querySelector('[data-cnstrc-count], [data-collection-count]');
    var tabCountEl = root.querySelector('[data-cnstrc-tab-count]');

    /* The products tab count ships collapsed (see the pending class) because Constructor
       replaces it. Called ONLY once the grid is filled, and deliberately not on the
       failure paths: with Constructor on, the Shopify products grid is not rendered at
       all, so revealing the Liquid count after a failed request would put Shopify's
       figure above an empty grid. No count is the honest state there. */
    function revealTabCount() {
      if (tabCountEl) tabCountEl.classList.remove('search-results__tab-count--cnstrc-pending');
    }
    var productsTab = root.querySelector('[data-cnstrc-products-tab]');
    var productsPanel = root.querySelector('#panel-products');
    var headingResults = root.querySelector('[data-cnstrc-heading-results]');
    var headingEmpty = root.querySelector('[data-cnstrc-heading-empty]');
    var wrapper = root.closest('.shopify-section');
    var term = root.getAttribute('data-cnstrc-search-term') || '';

    /* Read from the URL so a shared or refreshed link lands on the same page, matching
       how the Shopify path paginates. */
    var page = parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;

    /* Cumulative count of results Constructor has returned across the pages loaded so
       far - what the load-more button is judged on. Kept separate from the number of
       cards in the grid, which can be lower when a returned product no longer renders. */
    var received = 0;

    /* The section starts at zero opacity so the tab reshuffle is not visible. Reveal is
       idempotent and belt-and-braces: called after rendering, on failure, and on a
       timer, because a hidden page is far worse than an unstyled flash. */
    var panels = root.querySelector('.search-results__panels');
    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      /* Removing the pending class rather than adding a ready one: two competing
         opacity rules on the same element proved unreliable here, and the transition
         lives on the base class so it still fades in. */
      if (panels) panels.classList.remove('search-results__panels--cnstrc-pending');
    }

    /* The safety timer was sized for "Constructor never answered". Now that each card is
       a Liquid render of its own, a full page of them regularly outlasts 2.5s - and the
       timer firing mid-hydration revealed the toolbar and an empty grid seconds before
       the products landed. So once a response is in and the cards are being fetched, the
       short net is swapped for a long one: the reveal then belongs to the moment the
       grid is filled (settle), with the toolbar and the products fading in together. */
    var revealTimer = setTimeout(reveal, 2500);
    function holdRevealForCards() {
      clearTimeout(revealTimer);
      revealTimer = setTimeout(reveal, 12000);
    }

    /* Shopify still owns the other three tabs, so the page has results if EITHER
       engine found something. Counting the tabs still standing is the cheapest way
       to know whether Shopify found any non-product results - read at settle time
       rather than once at boot, because Pages and Articles arrive from their own
       per-type fetches and start hidden until those land. */
    function hasShopifyResults() {
      return Array.prototype.slice
        .call(root.querySelectorAll('.search-results__tab'))
        .some(function (tab) { return !tab.hidden && tab !== productsTab; });
    }

    function render(res, append) {
      var body = (res && res.response) || {};
      var results = body.results || [];
      var total = body.total_num_results || 0;

      /* Cards are the theme's standard product card, rendered by Liquid - one request
         per result, pooled by hydrateAll. So the grid fills a beat after the response
         lands, and everything that describes the grid (the count, the progress bar, the
         tab, the active-tab decision, the reveal) runs afterwards in settle() rather
         than against a grid that is still empty. */
      if (!append) received = 0;
      received += results.length;
      /* Cards are on their way: hold the reveal for them rather than the short timer. */
      holdRevealForCards();
      window.esrConstructor
        .hydrateAll(results, { section: 'Products' })
        .then(function (rows) {
          /* Load more appends below rather than replacing, so the shopper keeps their
             place and the products they have already scrolled past. */
          if (!append) grid.innerHTML = '';
          rows.forEach(function (row) {
            var cell = document.createElement('li');
            cell.appendChild(row.el);
            grid.appendChild(cell);
          });
          window.esrConstructor.initInjectedCards();
          settle(res, total);
        });
    }

    /* Everything that reads the filled grid. Split out of render() because the cards
       arrive asynchronously. */
    function settle(res, total) {
      /* Showing X of Y from what is actually on screen, so a product Constructor
         returned but Shopify can no longer render is not counted as shown. */
      var shown = grid.children.length;
      if (showingEl) {
        showingEl.textContent = SHOWING_TPL
          .replace('[count]', shown)
          .replace('[total]', total);
      }
      if (progressEl) {
        progressEl.setAttribute('aria-valuemax', total);
        progressEl.setAttribute('aria-valuenow', shown);
      }
      if (progressFill) {
        progressFill.style.width = (total ? (shown / total) * 100 : 0) + '%';
      }
      /* Hidden with nothing to show, and again once there is nothing left to page
         through - the same test Load more is judged on just below, deliberately.
         Constructor's index is keyed on variant SKU, so several results can carry
         the same product handle and collapse into one card; `shown` then sits
         permanently short of `total` and a `shown >= total` test would never fire,
         leaving a stalled bar and a stale count under a hidden button. */
      if (paginationEl) paginationEl.hidden = !total || received >= total;
      /* Paging is judged on what Constructor has RETURNED, not on what rendered: a
         dropped card would otherwise keep `shown` permanently short of the total and
         leave the button offering a page that does not exist. */
      if (loadMoreWrap) loadMoreWrap.hidden = received >= total;
      if (loadMoreBtn) {
        loadMoreBtn.disabled = false;
        loadMoreBtn.removeAttribute('aria-busy');
      }

      /* With Constructor powering results the beacon can finally have a result id and
         a count that describes what is actually on screen. */
      root.setAttribute('data-cnstrc-num-results', total);
      root.setAttribute('data-cnstrc-result-page', page);
      if (res && res.result_id) root.setAttribute('data-cnstrc-result-id', res.result_id);

      /* Shown only now, with Constructor's own figure and the cards in the grid: the
         tab is visible throughout the load (only the panels fade in), so revealing the
         Liquid-rendered Shopify count first made the tab visibly flip numbers. */
      if (tabCountEl) {
        tabCountEl.textContent = '(' + total + ')';
        revealTabCount();
      }
      if (countEl) countEl.textContent = total === 1 ? '1 Product' : total + ' Products';

      /* No products from Constructor: drop the products tab and panel so the page
         falls back to whichever Shopify tabs did match. */
      var hasProducts = total > 0;
      if (productsTab) productsTab.hidden = !hasProducts;
      if (productsPanel && !hasProducts) productsPanel.hidden = true;

      var anyResults = hasProducts || hasShopifyResults();
      if (headingResults) headingResults.hidden = !anyResults;
      if (headingEmpty) headingEmpty.hidden = anyResults;
      if (wrapper) wrapper.classList.toggle('search-has-results', anyResults);

      /* Shopify may have picked another tab as active, because its own product count
         was zero for this term. Now that Constructor has answered, put the shopper on
         Products - unless the URL names a different tab, which the tab script honours
         on load and a shopper may have shared. */
      var hash = (window.location.hash || '').replace('#', '');
      if (hasProducts && productsTab && productsTab.getAttribute('aria-selected') !== 'true') {
        if (!hash || hash === 'products') productsTab.click();
      }

      /* Conversely, if products was active and Constructor returned nothing, move to
         the first tab still standing. */
      if (!hasProducts && productsTab && productsTab.getAttribute('aria-selected') === 'true') {
        var next = root.querySelector('.search-results__tab:not([hidden])');
        if (next) next.click();
      }

      reveal();
    }

    /* ---------- Facets, sort and chips ----------
       Shared with the collection page - see snippets/constructor-facets.liquid.

       The module arrives in the snippet bundle, which the browser executes AFTER the
       section bundle this code lives in, so it cannot be reached at execute time -
       hence the boot() gate at the bottom. Deferred scripts all run before
       DOMContentLoaded, so the module is guaranteed to exist by then. */
    var facets = null;

    var paginationEl = root.querySelector('[data-cnstrc-pagination]');
    var progressEl = root.querySelector('[data-cnstrc-progress]');
    var progressFill = root.querySelector('[data-cnstrc-progress-fill]');
    var showingEl = root.querySelector('[data-cnstrc-showing]');
    var loadMoreWrap = root.querySelector('[data-cnstrc-load-more-wrap]');
    var loadMoreBtn = root.querySelector('[data-cnstrc-load-more]');
    var SHOWING_TPL = (showingEl && showingEl.getAttribute('data-showing-template')) || '';
    /* Constructor pages at the merchant's setting too, so every tab on the page
       agrees on how many results a page is. */
    var PER_PAGE = parseInt(root.getAttribute('data-per-page'), 10) || 48;



    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        if (loadMoreBtn.getAttribute('aria-busy') === 'true') return;
        loadMoreBtn.setAttribute('aria-busy', 'true');
        loadMoreBtn.disabled = true;
        run(page + 1, true);
      });
    }

    /* ---------- Request ---------- */
    /* Whether a request has already gone out, so a re-query can be told apart from
       first paint. First paint already ships behind the pending class with its own
       short safety net; a re-query has to put it back. */
    var hasRun = false;

    function run(toPage, append) {
      /* Re-query feedback (#19669138). Choosing a sort or a filter re-queries in
         place, and until the new cards land nothing moved - so the choice read as
         doing nothing, on a wait long enough to be noticed. Putting the pending
         class back fades the current results out and shows the same house spinner
         first paint uses, which is what the collection page already does when its
         Constructor grid re-queries. Paging is excluded: appending keeps the
         results you are reading on screen, and the Load more button has its own
         busy state.

         The revealed flag has to be reset or reveal() would no-op and the grid
         would stay faded for good, and the watchdog is re-armed on the long net so a request
         that never answers still clears - every exit path below (render, the
         request catch, the load catch) calls reveal(). */
      var isRequery = hasRun && !append;
      hasRun = true;
      if (isRequery) {
        revealed = false;
        if (panels) panels.classList.add('search-results__panels--cnstrc-pending');
        holdRevealForCards();
      }
      page = toPage || page;
      window.esrConstructor.load().then(function (client) {
        if (!client) {
          reveal();
          return;
        }
        var params = facets.applyTo({ resultsPerPage: PER_PAGE, page: page });
        return client.search
          .getSearchResults(term, params)
          .then(function (res) {
            render(res, append);
            /* Appending must not rebuild the drawer - that would drop the shopper's open
               group and scroll position mid-interaction. The facets and sort options are
               unchanged by paging anyway. */
            if (!append) facets.render(res && res.response);
          })
          .catch(function (error) {
            console.warn('[constructor] Search request failed.', error);
            if (loadMoreBtn) {
              loadMoreBtn.disabled = false;
              loadMoreBtn.removeAttribute('aria-busy');
            }
            reveal();
          });
      }).catch(reveal);
    }

    function boot() {
      facets = window.esrFacets.create({
        /* Filters and sort go into the address alongside ?q=, so a filtered search can be
           shared and reopened - the same behaviour as a collection page. */
        syncUrl: true,
        /* Search has no separate sort control, so the drawer carries it at every
           breakpoint - unlike a collection page, where desktop sort is in the header. */
        sortDesktop: true,
        /* Facets the merchant has chosen to keep off search results (a
           comma-separated list in the section settings). Search-only: the same
           facets still show on collection browse, which has its own controller. */
        hiddenFacets: root.getAttribute('data-hidden-facets'),
        onChange: function () { run(1); }
      });
      run(page);
    }

    if (window.esrFacets) boot();
    else document.addEventListener('DOMContentLoaded', boot);
  })();

  /* ---------------------------------------------------------------------
     Per-tab results (#674-#678 follow-up).

     `search.results` is one query scoped by the URL's `type`, so the server
     render can only be authoritative for a single tab. Every other tab is
     marked data-tab-fetch and re-requests THIS section through the Section
     Rendering API with its own type, which gives it its own page, its own true
     count and its own Load more. Without it the tabs share one page between
     them and a term that fills it with products starves Pages and Articles to
     nothing.

     It re-renders the whole section rather than a lean endpoint section of its
     own so that the merchant's Results per page setting is honoured: a section
     requested standalone by file name gets schema defaults, not the settings
     the merchant saved on this one. The same round trip the collection page
     makes for its own Load more.
     --------------------------------------------------------------------- */
  (function () {
    if (window.__esSearchTabFetch) return;
    window.__esSearchTabFetch = true;


    /* Only a real click counts: reconcile() drives the tab bar with click() too,
       and must not read its own move as the shopper having chosen. */
    var userPicked = false;
    document.addEventListener(
      'click',
      function (event) {
        if (!event.isTrusted) return;
        if (event.target.closest('[data-search-tabs] [role=tab]')) userPicked = true;
      },
      true
    );

    function sectionUrl(root, path, type) {
      var url = new URL(path, window.location.origin);
      if (type) url.searchParams.set('type', type);
      url.searchParams.set('section_id', root.getAttribute('data-section-id'));
      return url.toString();
    }

    function documentFrom(html) {
      return new DOMParser().parseFromString(html, 'text/html');
    }

    /* The incoming document is a full render of this section scoped to one type,
       so that tab's body is complete and its tab button carries the real total. */
    function countIn(doc, name) {
      var el = doc.querySelector('#tab-' + name + ' .search-results__tab-count');
      if (!el) return 0;
      return parseInt(el.textContent.replace(/[^0-9]/g, ''), 10) || 0;
    }

    /* The tab button owns the count and its own visibility: a tab whose type
       turns out to have no results is removed rather than left reading (0). */
    function settleTab(root, name, count) {
      var button = root.querySelector('[role=tab][data-tab="' + name + '"]');
      if (!button) return;
      var countEl = button.querySelector('.search-results__tab-count');
      if (countEl) {
        countEl.textContent = '(' + count + ')';
        countEl.classList.remove('search-results__tab-count--pending');
      }
      if (count > 0) {
        button.hidden = false;
        return;
      }
      var panel = root.querySelector('#panel-' + name);
      if (panel) panel.remove();
      button.remove();
    }

    /* A query can match pages or articles while matching no products at all, in
       which case this render committed to the no-results state before those
       tabs had answered. Flip it the moment one of them reports results: show
       the results heading, drop the empty copy, hide the helper sections that
       follow, and make sure something is selected - the tab that was active may
       have been removed for coming back empty. */
    function reconcile(root) {
      var visibleTabs = Array.prototype.slice
        .call(root.querySelectorAll('[role=tab]'))
        .filter(function (t) { return !t.hidden; });
      var wrapper = root.closest('.shopify-section');
      var resultsHeading = root.querySelector('[data-search-heading-results]');
      var emptyHeading = root.querySelector('[data-search-heading-empty]');
      var subcopy = root.querySelector('[data-search-empty-subcopy]');
      var anyResults = visibleTabs.length > 0;

      if (resultsHeading) resultsHeading.hidden = !anyResults;
      if (emptyHeading) emptyHeading.hidden = anyResults;
      if (subcopy) subcopy.hidden = anyResults;
      if (wrapper) wrapper.classList.toggle('search-has-results', anyResults);

      if (!anyResults) return;
      /* Which tab ends up active must not depend on which fetch happened to
         answer first: until the shopper picks one themselves, keep them on the
         first tab still standing, in the order the tab bar reads. */
      if (userPicked) {
        var stillSelected = visibleTabs.some(function (t) {
          return t.getAttribute('aria-selected') === 'true';
        });
        if (stillSelected) return;
      }
      if (visibleTabs[0].getAttribute('aria-selected') !== 'true') visibleTabs[0].click();
    }

    function loadTab(panel, root) {
      var type = panel.getAttribute('data-tab-fetch');
      var name = panel.id.replace('panel-', '');
      var body = panel.querySelector('[data-tab-body]');
      if (!type || !body) return;

      return fetch(sectionUrl(root, window.location.pathname + window.location.search, type))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = documentFrom(html);
          var incoming = doc.querySelector('[data-tab-body="' + name + '"]');
          if (!incoming) return;
          body.innerHTML = incoming.innerHTML;
          panel.removeAttribute('data-tab-fetch');
          /* The filter bar's count is rendered from the same partition the tab
             was, so it is short for the same reason - and there are two copies,
             the inline bar and the floating one. Take the figure from the
             type-scoped response, which counted the whole set. */
          if (name === 'products') {
            var incomingCount = doc.querySelector('[data-collection-count]');
            if (incomingCount) {
              root.querySelectorAll('[data-collection-count]').forEach(function (el) {
                el.textContent = incomingCount.textContent;
              });
            }
          }
          settleTab(root, name, countIn(doc, name));
          reconcile(root);
        })
        .catch(function (error) {
          console.warn('[search] Tab request failed.', error);
          /* Leave the first paint in place and stop advertising a count that is
             never going to arrive. */
          var countEl = root.querySelector('[role=tab][data-tab="' + name + '"] .search-results__tab-count');
          if (countEl) countEl.classList.remove('search-results__tab-count--pending');
        });
    }

    /* Load more appends the next page below rather than navigating away, the
       same contract the collection page uses. */
    function loadMore(button, root) {
      if (button.getAttribute('aria-busy') === 'true') return;
      var nextUrl = button.getAttribute('data-next-url');
      var panel = button.closest('.search-results__panel');
      var body = panel && panel.querySelector('[data-tab-body]');
      var list = body && body.querySelector('[data-tab-list]');
      if (!nextUrl || !list) return;

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;

      var name = panel.id.replace('panel-', '');
      fetch(sectionUrl(root, nextUrl, null))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var incomingBody = documentFrom(html).querySelector('[data-tab-body="' + name + '"]');
          var incoming = incomingBody && incomingBody.querySelector('[data-tab-list]');
          if (!incoming) return;
          while (incoming.firstElementChild) list.appendChild(incoming.firstElementChild);
          var pagination = body.querySelector('[data-tab-pagination]');
          var incomingPagination = incomingBody.querySelector('[data-tab-pagination]');
          if (pagination && incomingPagination) {
            pagination.replaceWith(incomingPagination);
          } else if (pagination) {
            pagination.remove();
          }
        })
        .catch(function (error) {
          console.warn('[search] Load more failed.', error);
          button.removeAttribute('aria-busy');
          button.disabled = false;
        });
    }

    document.querySelectorAll('.search-results').forEach(function (root) {
      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-tab-load-more]');
        if (!button) return;
        event.preventDefault();
        loadMore(button, root);
      });
      root.querySelectorAll('[data-tab-fetch]').forEach(function (panel) {
        loadTab(panel, root);
      });
    });
  })();

  /* ---------------------------------------------------------------------
     Floating filter bar (design QA #19669138). The inline bar scrolls away with
     the page; the floating copy takes over so Filters and the count stay
     reachable, matching the collection page. Its own small controller rather
     than the collection element's, which is bound to that section's grid,
     density and Constructor pager - none of which exist here.
     --------------------------------------------------------------------- */
  (function () {
    if (window.__esSearchFloatingBar) return;
    window.__esSearchFloatingBar = true;

    document.querySelectorAll('.search-results').forEach(function (root) {
      var inline = root.querySelector('.collection__bar--inline');
      var floating = root.querySelector('.collection__bar--floating');
      if (!inline || !floating || !('IntersectionObserver' in window)) return;

      function show(on) {
        floating.classList.toggle('is-visible', on);
        /* Kept out of the tab order while off-screen: it is a duplicate of
           controls already in the page, so exposing both would double every
           stop. */
        if (on) {
          floating.removeAttribute('inert');
          floating.removeAttribute('aria-hidden');
        } else {
          floating.setAttribute('inert', '');
          floating.setAttribute('aria-hidden', 'true');
        }
      }

      /* Reveal once the inline bar has left through the TOP. Scrolling back up
         past it, or reaching a point where it is on screen again, hides the
         copy rather than stacking two identical bars. */
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var goneUpwards = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          show(goneUpwards);
        });
      }, { threshold: 0 }).observe(inline);
    });
  })();

  (function () {
    if (window.__esSearchTabs) return;
    window.__esSearchTabs = true;

    function panelFor(tablist, name) {
      var root = tablist.closest('.search-results') || tablist.parentElement;
      return root.querySelector('#panel-' + name);
    }

    function activate(tablist, tab) {
      var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role=tab]'));
      tabs.forEach(function (t) {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        if (selected) { t.removeAttribute('tabindex'); } else { t.setAttribute('tabindex', '-1'); }
        var panel = panelFor(tablist, t.getAttribute('data-tab'));
        if (panel) { panel.hidden = !selected; }
      });
    }

    function init(tablist) {
      var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role=tab]'));
      tablist.addEventListener('click', function (e) {
        var tab = e.target.closest('[role=tab]');
        if (!tab) return;
        activate(tablist, tab);
        if (history.replaceState) { history.replaceState(null, '', '#' + tab.getAttribute('data-tab')); }
      });
      tablist.addEventListener('keydown', function (e) {
        var current = tablist.querySelector('[aria-selected=true]');
        var i = tabs.indexOf(current);
        var next = null;
        if (e.key === 'ArrowRight') { next = tabs[i + 1]; }
        else if (e.key === 'ArrowLeft') { next = tabs[i - 1]; }
        else if (e.key === 'Home') { next = tabs[0]; }
        else if (e.key === 'End') { next = tabs[tabs.length - 1]; }
        else { return; }
        if (!next) return;
        e.preventDefault();
        activate(tablist, next);
        next.focus();
      });
      // Honour a #tab hash on load.
      var hash = (window.location.hash || '').replace('#', '');
      if (hash) {
        var target = tablist.querySelector('[data-tab="' + hash + '"]');
        if (target) { activate(tablist, target); }
      }
    }

    document.querySelectorAll('[data-search-tabs]').forEach(init);
  })();

  /* ---------------------------------------------------------------------
     Result count in the page title (#19668963).

     The title ships without a count (see snippets/meta-tags.liquid for why
     Shopify's own number cannot be trusted here) and this puts the real one in,
     as "(N)", matching the tab chips. N is the sum of the visible tabs, so the
     title can only ever agree with what the tabs say - on both engines, since
     it reads the tabs rather than either engine.

     Driven by a MutationObserver on the tab row rather than by calls from the
     two controllers: counts arrive from Constructor, from each native per-type
     fetch, and tabs remove themselves when a fetch comes back empty. Watching
     the row catches all of those without either controller having to remember
     to call us. Nothing here writes inside the observed subtree, so it cannot
     feed itself.
     --------------------------------------------------------------------- */
  (function () {
    if (window.__esSearchTitleCount) return;
    window.__esSearchTitleCount = true;

    var meta = document.querySelector('meta[name="es-search-title-base"]');
    var row = document.querySelector('[data-search-tabs]');
    if (!meta || !row) return;

    var base = meta.getAttribute('content') || '';
    if (!base) return;

    /* Everything the title carries after the base - the suffix, and a page or
       tag part if there is one. Captured ONCE, from the untouched server title,
       so repeated syncs always rebuild from the same two ends and can never
       stack up counts.

       If the base is not actually the start of the rendered title then the two
       have drifted (a different escaping of the term would do it) and anything
       built from them would be wrong. Leave the server title alone rather than
       write a mangled one: the page loses the count, not its title. */
    if (document.title.indexOf(base) !== 0) return;
    var tail = document.title.slice(base.length);

    function sum() {
      var total = 0;
      var tabs = row.querySelectorAll('[role=tab]');
      for (var i = 0; i < tabs.length; i++) {
        /* A tab still waiting on its fetch is carrying a placeholder, and a
           hidden one is not offering its results to anyone - neither belongs in
           a total that claims to describe the page. */
        if (tabs[i].hidden) continue;
        var el = tabs[i].querySelector('.search-results__tab-count');
        if (!el) continue;
        if (el.className.indexOf('pending') !== -1) continue;
        total += parseInt(el.textContent.replace(/[^0-9]/g, ''), 10) || 0;
      }
      return total;
    }

    function sync() {
      var n = sum();
      /* Nothing settled yet: leave the countless title alone rather than
         claiming zero results on a page that is still filling in. */
      document.title = n > 0 ? base + ' (' + n + ')' + tail : base + tail;
    }

    if (window.MutationObserver) {
      new MutationObserver(sync).observe(row, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['hidden', 'class']
      });
    }
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && customElements.get('seo-content')) return;

    class SeoContent extends HTMLElement {
      // Keep a heading with the copy it introduces when the body is in columns.
      // CSS break-after avoidance covers Blink; Safari and Firefox ignore it in
      // multicol, so each heading is paired with the block after it inside a
      // wrapper that will not break. Skips a heading already inside a wrapper so
      // back-to-back headings cannot nest one inside another.
      pairHeadings() {
        var body = this.querySelector('.seo-content__body');
        if (!body) return;
        var heads = body.querySelectorAll('h1, h2, h3, h4, h5, h6');
        for (var i = 0; i < heads.length; i++) {
          var head = heads[i];
          if (head.parentNode.classList.contains('seo-content__keep')) continue;
          var next = head.nextElementSibling;
          if (!next) continue;
          var keep = document.createElement('div');
          keep.className = 'seo-content__keep';
          head.parentNode.insertBefore(keep, head);
          keep.appendChild(head);
          keep.appendChild(next);
        }
      }

      connectedCallback() {
        if (this.__init) return;
        this.__init = true;

        // Runs before the collapse below measures anything, and runs whether or
        // not there is a fold, because the intro is columned too.
        this.pairHeadings();

        this.more = this.querySelector('[data-seo-more]');
        this.toggle = this.querySelector('[data-seo-toggle]');
        // No folded copy => nothing to reveal; leave the full intro visible.
        if (!this.more || !this.toggle) return;
        this.label = this.toggle.querySelector('.button__label') || this.toggle;
        this.expanded = false;

        // JS hides the Read more copy and reveals the control (with JS off both
        // the copy stays visible and the control stays hidden). `inert` keeps the
        // collapsed copy out of the tab order and accessibility tree while still
        // leaving it in the DOM for crawlers; it doesn't block the max-height
        // animation the way `display: none` would.
        this.more.classList.add('is-collapsed');
        this.more.style.opacity = '0'; // collapsed copy starts invisible
        this.more.setAttribute('inert', '');
        this.toggle.hidden = false;
        // Snap (no fade sequencing) when the user prefers reduced motion - the
        // transitions are disabled in CSS, so transitionend never fires and we
        // rely on the timeout fallback firing near-immediately.
        this.reduceMotion =
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.toggle.addEventListener('click', this.onToggle.bind(this));
      }

      setLabel(text) {
        if (this.label) this.label.textContent = text;
      }

      // Run cb once the given property finishes transitioning. Falls back to a
      // timeout so it still fires when transitions are disabled (reduced motion)
      // or the event is missed. Cancels any previously-pending step first so a
      // fast open/close toggle can't leave two sequences fighting.
      afterTransition(prop, ms, cb) {
        this.cancelPending();
        var self = this;
        var done = false;
        function finish(e) {
          if (e && e.propertyName !== prop) return;
          if (done) return;
          done = true;
          self.more.removeEventListener('transitionend', finish);
          if (self._timer) clearTimeout(self._timer);
          self._timer = null;
          self._cancel = null;
          cb();
        }
        this._cancel = function () {
          done = true;
          self.more.removeEventListener('transitionend', finish);
          if (self._timer) clearTimeout(self._timer);
          self._timer = null;
        };
        this.more.addEventListener('transitionend', finish);
        this._timer = setTimeout(finish, this.reduceMotion ? 0 : ms);
      }

      cancelPending() {
        if (this._cancel) this._cancel();
        this._cancel = null;
      }

      onToggle() {
        if (this.expanded) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      // Open: grow the height while the copy stays invisible (so the column
      // reflow isn't seen), then fade the copy in once fully open.
      expand() {
        this.expanded = true;
        this.classList.add('is-expanded');
        this.more.removeAttribute('inert');
        this.more.classList.remove('is-collapsed');
        this.more.style.opacity = '0';
        var end = this.more.scrollHeight;
        this.more.style.maxHeight = '0px';
        void this.more.offsetHeight;
        this.more.style.maxHeight = end + 'px';
        var self = this;
        this.afterTransition('max-height', 350, function () {
          self.more.style.maxHeight = 'none'; // release so columns settle
          void self.more.offsetHeight;
          self.more.style.opacity = '1'; // fade in the settled two-column copy
        });
        this.toggle.setAttribute('aria-expanded', 'true');
        this.setLabel(this.toggle.getAttribute('data-label-less') || 'Read less');
      }

      // Close: fade the copy out first, then collapse the height once it's
      // invisible so the column reflow during the height change isn't seen.
      collapse() {
        this.expanded = false;
        this.classList.remove('is-expanded');
        this.more.style.opacity = '0';
        var self = this;
        this.afterTransition('opacity', 250, function () {
          self.more.style.maxHeight = self.more.scrollHeight + 'px';
          void self.more.offsetHeight;
          self.more.classList.add('is-collapsed');
          self.more.setAttribute('inert', '');
          self.more.style.maxHeight = ''; // animate down to the CSS clamp (0)
        });
        this.toggle.setAttribute('aria-expanded', 'false');
        this.setLabel(this.toggle.getAttribute('data-label-more') || 'Read more');
      }
    }

    if (window.customElements && !customElements.get('seo-content')) {
      customElements.define('seo-content', SeoContent);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  // Drag-to-scroll for the category row (#19450057). The row is a native
  // overflow-x container, so touch and trackpads already scroll it - but a mouse
  // has no gesture for horizontal overflow, and the scrollbar is hidden by
  // design, so press-and-drag did nothing at the narrower desktop widths where
  // the tiles start to overflow. Pointer events drive scrollLeft directly. Touch
  // is left alone so native momentum scrolling is untouched.
  (function () {
    if (window.__esShopByCategoryDrag) return;
    window.__esShopByCategoryDrag = true;

    var THRESHOLD = 5; // px of travel before a press counts as a drag, not a click

    function setup(row) {
      if (row.__esDragInit) return;
      row.__esDragInit = true;

      var dragging = false;
      var moved = false;
      var pointerId = null;
      var startX = 0;
      var startLeft = 0;

      function release() {
        if (pointerId == null) return;
        if (row.releasePointerCapture && row.hasPointerCapture && row.hasPointerCapture(pointerId)) {
          try { row.releasePointerCapture(pointerId); } catch (err) {}
        }
        pointerId = null;
      }

      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // native touch scrolling handles this
        if (e.button !== 0) return;
        if (row.scrollWidth <= row.clientWidth) return; // nothing to scroll
        dragging = true;
        moved = false;
        pointerId = e.pointerId;
        startX = e.clientX;
        startLeft = row.scrollLeft;
        row.classList.add('is-dragging');
      });

      row.addEventListener('pointermove', function (e) {
        if (!dragging || e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        if (!moved) {
          if (Math.abs(dx) <= THRESHOLD) return;
          moved = true;
          // Captured only once the gesture is genuinely a drag: capturing on
          // pointerdown would retarget an ordinary tile click to the row and
          // swallow the link.
          if (row.setPointerCapture) {
            try { row.setPointerCapture(pointerId); } catch (err) {}
          }
        }
        e.preventDefault();
        row.scrollLeft = startLeft - dx;
      });

      function end(e) {
        if (!dragging || (e && e.pointerId !== pointerId)) return;
        dragging = false;
        row.classList.remove('is-dragging');
        release();
      }

      row.addEventListener('pointerup', end);
      row.addEventListener('pointercancel', end);

      // A drag must not also follow the tile's link. 'moved' is cleared by the
      // next pointerdown, so a drag that ends without a click can't swallow the
      // click after it.
      row.addEventListener('click', function (e) {
        if (!moved) return;
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }, true);

      // The tiles are links wrapping images, so without this the browser starts
      // its own native drag and the row never moves.
      row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    // Scroll controls (#19450057): a progress bar with prev/next arrows below the
    // row, so a mouse has a visible affordance rather than only press-and-drag.
    // Rendered only when the merchant has the setting on, and unhidden only when
    // the row genuinely overflows. Mirrors the range modal.
    function controlsFor(container) {
      var controls = container.querySelector('[data-sbc-controls]');
      if (!controls) return null;
      return {
        track: container.querySelector('[data-sbc-track]'),
        controls: controls,
        fill: controls.querySelector('[data-sbc-fill]'),
        prev: controls.querySelector('[data-sbc-arrow="prev"]'),
        next: controls.querySelector('[data-sbc-arrow="next"]')
      };
    }

    function updateFill(p) {
      if (!p || !p.track) return;
      var max = p.track.scrollWidth - p.track.clientWidth;
      if (p.fill) {
        var ratio = max > 0 ? p.track.scrollLeft / max : 0;
        if (ratio < 0) ratio = 0;
        if (ratio > 1) ratio = 1;
        p.fill.style.width = (ratio * 100) + '%';
      }
      if (p.prev) p.prev.disabled = p.track.scrollLeft <= 1;
      if (p.next) p.next.disabled = p.track.scrollLeft >= max - 1;
    }

    function refresh(p) {
      if (!p || !p.track) return;
      var scrollable = p.track.scrollWidth - p.track.clientWidth > 1;
      p.controls.hidden = !scrollable;
      // A scrollable region needs to be reachable by keyboard, so the row takes
      // a tab stop only while it actually scrolls (no dead tab stop for a row
      // that fits).
      if (scrollable) {
        p.track.setAttribute('tabindex', '0');
      } else {
        p.track.removeAttribute('tabindex');
      }
      updateFill(p);
    }

    // One tile + gap per arrow press, matching the range modal.
    function scrollByTile(p, direction) {
      if (!p || !p.track) return;
      var tile = p.track.querySelector('.shop-by-category__item');
      var step = tile ? tile.getBoundingClientRect().width + 8 : p.track.clientWidth * 0.8;
      // No explicit behavior: inherit the CSS scroll-behavior so the
      // prefers-reduced-motion override (auto) is respected.
      p.track.scrollBy({ left: direction * step });
    }

    function setupControls(container) {
      if (container.__esSbcControlsInit) return;
      var p = controlsFor(container);
      if (!p || !p.track) return;
      container.__esSbcControlsInit = true;

      p.track.addEventListener('scroll', function () { updateFill(p); }, { passive: true });
      if (p.prev) p.prev.addEventListener('click', function () { scrollByTile(p, -1); });
      if (p.next) p.next.addEventListener('click', function () { scrollByTile(p, 1); });

      // The tiles are a fixed width, so overflow only changes with the viewport
      // (and once a lazy image settles). ResizeObserver covers both; the resize
      // listener is the fallback where it is missing.
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () { refresh(p); });
        ro.observe(p.track);
      }
      window.addEventListener('resize', function () { refresh(p); });

      refresh(p);
    }

    function init(root) {
      var scope = root || document;
      scope.querySelectorAll('.shop-by-category__row').forEach(setup);
      scope.querySelectorAll('.section--shop-by-category').forEach(setupControls);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // Re-init when the section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements && customElements.get('shop-the-look')) return;

    class ShopTheLook extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;

        this.track = this.querySelector('[data-stl-track]');
        this.viewAll = this.querySelector('[data-stl-view-all]');
        this.markers = Array.prototype.slice.call(this.querySelectorAll('[data-stl-hotspot]'));
        this.prev = this.querySelector('[data-stl-arrow="prev"]');
        this.next = this.querySelector('[data-stl-arrow="next"]');
        this.media = this.querySelector('[data-stl-media]');
        this.pane = this.querySelector('.shop-the-look__pane');
        this.animating = false;

        if (this.viewAll) {
          this.viewAll.addEventListener('click', this.onViewAllClick.bind(this));
        }
        if (this.media) {
          this.media.addEventListener('click', this.onMediaClick.bind(this));
        }
        // A11y: Escape collapses the expanded pane and returns focus to View all.
        this.addEventListener('keydown', this.onKeydown.bind(this));
        if (this.pane) {
          this.pane.addEventListener('click', this.onPaneClick.bind(this));
        }
        this.markers.forEach(function (m) {
          m.addEventListener('click', this.onMarkerClick.bind(this));
        }, this);
        this.setupPulseSync();
        if (this.prev) this.prev.addEventListener('click', this.scrollByCard.bind(this, -1));
        if (this.next) this.next.addEventListener('click', this.scrollByCard.bind(this, 1));

        var form = this.querySelector('[data-stl-add-all]');
        if (form) form.addEventListener('submit', this.onAddAll.bind(this));

        this.progressFill = this.querySelector('[data-stl-progress-fill]');
        if (this.track) {
          this.track.addEventListener('scroll', this.syncProgress.bind(this), { passive: true });
        }
        this.__onResize = this.syncProgress.bind(this);
        window.addEventListener('resize', this.__onResize);
        this.syncProgress();
      }

      disconnectedCallback() {
        if (this.__onResize) window.removeEventListener('resize', this.__onResize);
      }

      // Hovering / focusing a marker settles its pulse (and wave) via
      // `animation: none`, which restarts them from time 0 when released and
      // drifts out of step with the other markers. After the engaged state ends
      // we snap the freshly re-created animations back onto the markers' shared
      // start time so they line up again. (Requires the Web Animations API.)
      setupPulseSync() {
        var self = this;
        this.pulseMarkers = [];
        this.markers.forEach(function (marker) {
          if (!marker.getAnimations) return;
          self.pulseMarkers.push(marker);
          var resync = function () {
            requestAnimationFrame(function () { self.syncMarker(marker); });
          };
          marker.addEventListener('mouseleave', resync);
          marker.addEventListener('blur', resync, true);
        });
      }

      // The marker's dot pulse plus its wave pseudo-element, when present.
      markerAnimations(marker) {
        try { return marker.getAnimations({ subtree: true }); }
        catch (e) { return marker.getAnimations(); }
      }

      pulseOrigin() {
        if (this._pulseOrigin != null) return this._pulseOrigin;
        for (var i = 0; i < this.pulseMarkers.length; i++) {
          var anims = this.markerAnimations(this.pulseMarkers[i]);
          for (var j = 0; j < anims.length; j++) {
            if (anims[j].startTime != null) { this._pulseOrigin = anims[j].startTime; return this._pulseOrigin; }
          }
        }
        return this._pulseOrigin;
      }

      syncMarker(marker) {
        var origin = this.pulseOrigin();
        if (origin == null) return;
        this.markerAnimations(marker).forEach(function (a) {
          try { a.startTime = origin; } catch (e) {}
        });
      }

      isDesktop() {
        return window.matchMedia('(min-width: 1104px)').matches;
      }

      prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      // Sequenced open/close: fade the pane content out, resize the pane (it
      // grows right-to-left because the pane is the right flex child), then fade
      // the content back in. Pure CSS transitions; JS only steps the classes.
      setExpanded(expanded, done) {
        var current = this.classList.contains('is-expanded');
        if (this.animating || expanded === current) {
          if (done) done();
          return;
        }
        if (this.prefersReducedMotion()) {
          this.classList.toggle('is-expanded', expanded);
          if (this.viewAll) this.viewAll.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          this.syncProgress();
          if (done) done();
          return;
        }
        var self = this;
        this.animating = true;
        this.classList.add('is-animating'); // content fades to 0
        setTimeout(function () {
          self.classList.toggle('is-expanded', expanded); // pane resizes (0.4s)
          if (self.viewAll) self.viewAll.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          setTimeout(function () {
            self.classList.remove('is-animating'); // content fades back in
            self.animating = false;
            self.syncProgress(); // overflow changed with the pane width
            if (done) done();
          }, 400);
        }, 200);
      }

      expand() {
        this.setExpanded(true);
      }

      collapse() {
        this.setExpanded(false);
      }

      onMediaClick(e) {
        // Desktop only: clicking the image (but not a hotspot) closes the pane.
        if (!this.isDesktop()) return;
        if (!this.classList.contains('is-expanded')) return;
        if (e.target.closest && e.target.closest('[data-stl-hotspot]')) return;
        this.collapse();
      }

      // Expand, then move focus into the carousel - "View all" hides itself on
      // expand, so without this keyboard focus would be lost to <body>.
      onViewAllClick() {
        var self = this;
        this.setExpanded(true, function () {
          var first = self.track && self.track.querySelector('a, button');
          if (first) first.focus();
        });
      }

      // Escape collapses (desktop) and returns focus to the View all button -
      // the only keyboard route back to the split view.
      onKeydown(e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        if (!this.isDesktop() || !this.classList.contains('is-expanded')) return;
        var self = this;
        this.setExpanded(false, function () {
          if (self.viewAll) self.viewAll.focus();
        });
      }

      onPaneClick(e) {
        // Desktop only: clicking the pane's own surface (heading, padding, gaps)
        // opens the panel - but not clicks on a product card or any control.
        if (!this.isDesktop()) return;
        if (this.classList.contains('is-expanded')) return;
        if (e.target.closest && e.target.closest('.product-card, a, button')) return;
        this.expand();
      }

      // Carousel progress indicator: the fill grows to the scroll progress and
      // the whole bar hides when the track does not overflow.
      syncProgress() {
        if (!this.track) return;
        var max = this.track.scrollWidth - this.track.clientWidth;
        this.setAttribute('data-scrollable', max > 1 ? 'true' : 'false');
        if (this.progressFill) {
          var progress = max > 0 ? this.track.scrollLeft / max : 0;
          this.progressFill.style.width = (progress * 100) + '%';
        }
      }

      slideFor(index) {
        if (!this.track) return null;
        return this.track.querySelector('[data-stl-item="' + index + '"]');
      }

      scrollToItem(index) {
        var slide = this.slideFor(index);
        if (!slide || !this.track) return;
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft });
      }

      onMarkerClick(e) {
        var index = e.currentTarget.getAttribute('data-stl-hotspot');
        var self = this;
        if (this.isDesktop() && !this.classList.contains('is-expanded')) {
          // Expand first, then scroll once the pane has its final width.
          this.setExpanded(true, function () { self.scrollToItem(index); });
        } else {
          this.scrollToItem(index);
        }
      }

      scrollByCard(direction) {
        if (!this.track) return;
        var slide = this.track.querySelector('.shop-the-look__slide');
        var step = slide ? slide.getBoundingClientRect().width + 8 : this.track.clientWidth * 0.8;
        this.track.scrollBy({ left: direction * step });
      }

      // The main-product line on a product page (#1127) carries the variant that
      // was selected when the page was rendered. Products with real Shopify
      // variants have their buy box id input rewritten in place when the shopper
      // picks another one, so copy that value across at click time and keep the
      // rendered id as the fallback. product__form is the buy box form only -
      // the product cards in this carousel use data-quick-add.
      syncMainVariant(form) {
        var main = form.querySelector('[data-stl-main-variant]');
        if (!main) return;
        var live = document.querySelector('form.product__form input[name="id"]');
        if (live && live.value) main.value = live.value;
      }

      showAddError(form, text) {
        var box = form.querySelector('[data-cart-add-error]');
        if (!box) return;
        box.textContent = text || '';
        box.hidden = !text;
      }

      onAddAll(e) {
        e.preventDefault();
        var self = this;
        var form = e.currentTarget;
        this.syncMainVariant(form);
        var btn = form.querySelector('button');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
        // Post the form's indexed items[][id]/[quantity] inputs as FormData -
        // the same mechanism product-card quick-add uses, so the cart drawer's
        // cart:updated listener opens it just like a single add.
        this.showAddError(form, '');
        fetch(form.action, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (body) {
              return { ok: response.ok, body: body };
            });
          })
          .then(function (res) {
            /* #1110: the add-all posts several lines at once, and Shopify
               refuses the WHOLE add if any one line is unavailable - so this
               path failing silently lost the entire look with no explanation.
               The 422 body names the offending product. */
            if (!res.ok) {
              var msg = (res.body && (res.body.description || res.body.message)) ||
                'Sorry, this could not be added to your cart. Please try again.';
              self.showAddError(form, String(msg));
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { items: res.body } }));
          })
          .catch(function () {
            self.showAddError(form, 'Sorry, this could not be added to your cart. Please try again.');
          })
          .finally(function () {
            if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
          });
      }
    }

    if (window.customElements && !customElements.get('shop-the-look')) {
      customElements.define('shop-the-look', ShopTheLook);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-collection-prompt"]) return;
  try {
    
  class StoreCollectionPrompt extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-scp-dialog]');
      if (!this.dialog) return;

      this.dialog.addEventListener('cancel', this.onCancel.bind(this));
      this.dialog.addEventListener('click', this.onDialogClick.bind(this));
      var closeButton = this.querySelector('[data-scp-close]');
      if (closeButton) closeButton.addEventListener('click', this.close.bind(this));

      // Reveal + wire the trigger(s) elsewhere on the page (the locator info
      // icon). They ship hidden; we only show them because this section exists.
      this.wireTriggers();
      this.onSectionLoad = this.wireTriggers.bind(this);
      document.addEventListener('shopify:section:load', this.onSectionLoad);

      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      if (this.designMode) this.setupEditorPreview();
    }

    disconnectedCallback() {
      if (this.onSectionLoad) {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }
      if (this.onEditorSelect) {
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
      }
      if (this.onEditorDeselect) {
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
      }
    }

    wireTriggers() {
      var self = this;
      var triggers = document.querySelectorAll('[data-store-collection-open]');
      for (var i = 0; i < triggers.length; i++) {
        var link = triggers[i];
        if (link.__scpInit) continue;
        link.__scpInit = true;
        link.hidden = false;
        link.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      }
    }

    open() {
      // Close any other overlay dialog that's open first (one at a time).
      var current = document.querySelector('dialog[open]');
      if (current && current !== this.dialog) {
        try { current.close(); } catch (e) {}
      }
      if (typeof this.dialog.showModal === 'function' && !this.dialog.open) {
        this.lockScroll();
        this.dialog.showModal();
      }
    }

    onCancel(event) {
      event.preventDefault();
      this.close();
    }

    onDialogClick(event) {
      if (event.target === this.dialog) this.close();
    }

    close() {
      this.unlockScroll();
      if (this.dialog.open) this.dialog.close();
    }

    lockScroll() {
      document.documentElement.style.overflow = 'hidden';
    }

    unlockScroll() {
      document.documentElement.style.overflow = '';
    }

    setupEditorPreview() {
      this.sectionId = this.getAttribute('data-section-id');
      var self = this;
      this.onEditorSelect = function (event) {
        if (!event.detail || event.detail.sectionId !== self.sectionId) return;
        if (typeof self.dialog.showModal === 'function' && !self.dialog.open) {
          self.dialog.showModal();
        }
      };
      this.onEditorDeselect = function (event) {
        if (event.detail && event.detail.sectionId !== self.sectionId) return;
        if (self.dialog.open) self.dialog.close();
      };
      document.addEventListener('shopify:section:select', this.onEditorSelect);
      document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
    }
  }

  if (!customElements.get('store-collection-prompt')) {
    customElements.define('store-collection-prompt', StoreCollectionPrompt);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MAP_STYLE = [
      { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#e9e9e9' }, { lightness: 17 }] },
      { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 20 }] },
      { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }, { lightness: 17 }] },
      { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }] },
      { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 18 }] },
      { featureType: 'road.local', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 16 }] },
      { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 21 }] },
      { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dedede' }, { lightness: 21 }] },
      { elementType: 'labels.text.stroke', stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }] },
      { elementType: 'labels.text.fill', stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }] },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#f2f2f2' }, { lightness: 19 }] },
      { featureType: 'administrative', elementType: 'geometry.fill', stylers: [{ color: '#fefefe' }, { lightness: 20 }] },
      { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }] }
    ];

    var MARKER_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="48" viewBox="30 96 14.324 17.307" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M37.1614 96C41.1166 96 44.3233 99.2062 44.3235 103.161C44.3235 107.936 37.1614 113.307 37.1614 113.307C37.1135 113.271 30 107.92 30 103.161C30.0002 99.2063 33.2063 96.0002 37.1614 96ZM37.2614 100.741C36.1978 100.741 35.3354 101.603 35.3353 102.666C35.3353 103.73 36.1978 104.592 37.2614 104.592C38.3249 104.592 39.1868 103.73 39.1868 102.666C39.1867 101.603 38.3249 100.741 37.2614 100.741Z" fill="#302520"/><circle cx="37.2614" cy="102.6665" r="1.925" fill="#f5f3eb"/></svg>';

    function buildMap(el) {
      var canvas = el.querySelector('[data-sd-map-canvas]');
      var lat = parseFloat(el.getAttribute('data-lat'));
      var lng = parseFloat(el.getAttribute('data-lng'));
      var zoom = parseInt(el.getAttribute('data-zoom'), 10) || 15;
      if (!canvas || !window.google || !window.google.maps || isNaN(lat) || isNaN(lng)) { return; }
      var pos = { lat: lat, lng: lng };
      var map = new google.maps.Map(canvas, {
        zoom: zoom,
        center: pos,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: MAP_STYLE
      });
      var icon = {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(MARKER_SVG),
        scaledSize: new google.maps.Size(40, 48),
        anchor: new google.maps.Point(20, 48)
      };
      new google.maps.Marker({ position: pos, map: map, icon: icon });
    }

    function loadMaps(el) {
      if (el.__sdMapReq) { return; }
      el.__sdMapReq = true;
      if (window.google && window.google.maps) { buildMap(el); return; }
      var key = el.getAttribute('data-maps-key');
      if (!key) { return; }
      document.addEventListener('es:sd-maps-ready', function handler() {
        document.removeEventListener('es:sd-maps-ready', handler);
        buildMap(el);
      });
      if (window.__esSdMapsLoading) { return; }
      window.__esSdMapsLoading = true;
      window.__esSdMapInit = function () {
        document.dispatchEvent(new CustomEvent('es:sd-maps-ready'));
      };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&callback=__esSdMapInit';
      s.async = true;
      document.head.appendChild(s);
    }

    function init() {
      var maps = document.querySelectorAll('[data-sd-map]');
      for (var i = 0; i < maps.length; i++) {
        (function (el) {
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
              for (var j = 0; j < entries.length; j++) {
                if (entries[j].isIntersecting) { loadMaps(el); io.disconnect(); break; }
              }
            }, { rootMargin: '200px' });
            io.observe(el);
          } else {
            loadMaps(el);
          }
        })(maps[i]);
      }
    }

    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-intro"] && !Shopify.designMode) return;
  try {
    
  /* Re-resolves "Open today" in the store's own timezone. The server renders
     today's hours on the shop clock, which is right for most stores but wrong
     for a store in another timezone, and can be stale if the page was cached
     across midnight. Output format matches the opening-hours-range snippet
     exactly, so correcting the text cannot flicker between two styles. */
  (function () {
    var DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

    function fmtTime(hhmm) {
      var parts = hhmm.split(':');
      var h = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10);
      if (isNaN(h) || isNaN(m)) { return null; }
      var ampm = h < 12 ? 'am' : 'pm';
      var hr = h % 12;
      if (hr === 0) { hr = 12; }
      var mm = m < 10 ? '0' + m : String(m);
      return hr + ':' + mm + ampm;
    }

    function label(raw) {
      var bits = (raw || '').trim().split('-');
      if (bits.length !== 2) { return 'Closed'; }
      var open = fmtTime(bits[0].trim());
      var close = fmtTime(bits[1].trim());
      if (!open || !close) { return 'Closed'; }
      return open + ' - ' + close;
    }

    function dayInTz(tz) {
      try {
        var parts = new Intl.DateTimeFormat('en-AU', { timeZone: tz, weekday: 'short' }).formatToParts(new Date());
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].type === 'weekday') {
            return DAY_KEYS.indexOf(parts[i].value.toLowerCase().slice(0, 3));
          }
        }
      } catch (e) {
        return -1;
      }
      return -1;
    }

    function render(tile) {
      var textEl = tile.querySelector('.text-icon__subcopy');
      if (!textEl) { return; }
      var day = dayInTz(tile.getAttribute('data-tz') || 'Australia/Sydney');
      if (day < 0) { return; }
      textEl.textContent = label(tile.getAttribute('data-hours-' + DAY_KEYS[day]));
    }

    function init() {
      var tiles = document.querySelectorAll('[data-store-intro-hours]');
      for (var i = 0; i < tiles.length; i++) { render(tiles[i]); }
    }

    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-location-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

    function fmtTime(hhmm) {
      var parts = hhmm.split(':');
      var h = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10);
      var ampm = h < 12 ? 'am' : 'pm';
      var hr = h % 12;
      if (hr === 0) { hr = 12; }
      if (m === 0) { return hr + ampm; }
      var mm = m < 10 ? '0' + m : String(m);
      return hr + ':' + mm + ampm;
    }

    function parseRange(raw) {
      if (!raw) { return null; }
      var bits = raw.split('-');
      if (bits.length !== 2) { return null; }
      var o = bits[0].trim().split(':');
      var c = bits[1].trim().split(':');
      if (o.length !== 2 || c.length !== 2) { return null; }
      var openMin = parseInt(o[0], 10) * 60 + parseInt(o[1], 10);
      var closeMin = parseInt(c[0], 10) * 60 + parseInt(c[1], 10);
      if (isNaN(openMin) || isNaN(closeMin)) { return null; }
      return {
        open: openMin,
        close: closeMin,
        label: fmtTime(bits[0].trim()) + '-' + fmtTime(bits[1].trim())
      };
    }

    function nowInTz(tz) {
      try {
        var fmt = new Intl.DateTimeFormat('en-AU', {
          timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
        });
        var parts = fmt.formatToParts(new Date());
        var wd = '', hh = 0, mm = 0;
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].type === 'weekday') { wd = parts[i].value.toLowerCase().slice(0, 3); }
          if (parts[i].type === 'hour') { hh = parseInt(parts[i].value, 10) % 24; }
          if (parts[i].type === 'minute') { mm = parseInt(parts[i].value, 10); }
        }
        return { dayIndex: DAY_KEYS.indexOf(wd), minutes: hh * 60 + mm };
      } catch (e) {
        return null;
      }
    }

    /* True when the store carries opening hours for at least one day. Without
       this the status defaulted to "Currently closed" and then revealed itself, so a
       store whose hours simply are not held read as shut - which is what every AU
       store did, since hours are populated on 0 of 57 there against 57 of 57 on
       staging (#19498863). Same rule as the PDP locator and the store locator
       page: unknown hours show nothing at all rather than asserting a fact.
       The element is rendered hidden, so returning early leaves it hidden. */
    function hasAnyHours(el) {
      for (var i = 0; i < DAY_KEYS.length; i++) {
        if ((el.getAttribute('data-hours-' + DAY_KEYS[i]) || '').trim()) { return true; }
      }
      return false;
    }

    function render(el) {
      var textEl = el.querySelector('[data-slh-status-text]');
      if (!textEl) { return; }
      if (!hasAnyHours(el)) { return; }
      var tz = el.getAttribute('data-tz') || 'Australia/Sydney';
      var now = nowInTz(tz);
      if (!now || now.dayIndex < 0) { return; }

      var todayRaw = el.getAttribute('data-hours-' + DAY_KEYS[now.dayIndex]);
      var today = parseRange(todayRaw);
      var isOpen = false;
      var text = 'Currently closed';

      if (today && now.minutes >= today.open && now.minutes < today.close) {
        isOpen = true;
        text = 'Open ' + today.label + ' today';
      } else if (today && now.minutes < today.open) {
        text = 'Opens ' + fmtTime(todayRaw.split('-')[0].trim()) + ' today';
      }

      textEl.textContent = text;
      el.classList.toggle('slh__status--open', isOpen);
      el.hidden = false;
    }

    function init() {
      var nodes = document.querySelectorAll('[data-slh-status]');
      for (var i = 0; i < nodes.length; i++) { render(nodes[i]); }
    }

    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var STORAGE_KEY = 'es:store-locator';

    // Google Maps "Ultra Light with Labels" theme (shared with the PDP block).
    var MAP_STYLE = [
      { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#e9e9e9' }, { lightness: 17 }] },
      { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 20 }] },
      { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }, { lightness: 17 }] },
      { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }] },
      { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 18 }] },
      { featureType: 'road.local', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 16 }] },
      { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 21 }] },
      { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dedede' }, { lightness: 21 }] },
      { elementType: 'labels.text.stroke', stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }] },
      { elementType: 'labels.text.fill', stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }] },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#f2f2f2' }, { lightness: 19 }] },
      { featureType: 'administrative', elementType: 'geometry.fill', stylers: [{ color: '#fefefe' }, { lightness: 20 }] },
      { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }] }
    ];

    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }

    // Format a 24h "HH:MM" into "9am" / "5:30pm".
    function fmtTime(hhmm) {
      var parts = hhmm.split(':');
      var h = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10);
      var ampm = h < 12 ? 'am' : 'pm';
      var hr = h % 12;
      if (hr === 0) { hr = 12; }
      var mm = m < 10 ? '0' + m : String(m);
      return hr + ':' + mm + ampm;
    }

    // "09:00-17:30" -> { open, close, label } or null.
    /* True when the store carries opening hours for at least one day.
       Distinguishes "shut right now" from "we do not hold this store's hours"
       (#19498863). Hours are populated on 0 of 57 AU stores against 57 of 57 on
       staging, so without this every AU store asserted it was closed. */
    function hasAnyHours(store) {
      for (var i = 0; i < DAY_KEYS.length; i++) {
        if ((store.getAttribute('data-hours-' + DAY_KEYS[i]) || '').trim()) { return true; }
      }
      return false;
    }

    function parseRange(raw) {
      if (!raw) { return null; }
      var bits = raw.split('-');
      if (bits.length !== 2) { return null; }
      var o = bits[0].trim().split(':');
      var c = bits[1].trim().split(':');
      if (o.length !== 2 || c.length !== 2) { return null; }
      var openMin = parseInt(o[0], 10) * 60 + parseInt(o[1], 10);
      var closeMin = parseInt(c[0], 10) * 60 + parseInt(c[1], 10);
      if (isNaN(openMin) || isNaN(closeMin)) { return null; }
      return {
        open: openMin,
        close: closeMin,
        label: fmtTime(bits[0].trim()) + '-' + fmtTime(bits[1].trim())
      };
    }

    function nowInTz(tz) {
      try {
        var fmt = new Intl.DateTimeFormat('en-AU', {
          timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
        });
        var parts = fmt.formatToParts(new Date());
        var wd = '', hh = 0, mm = 0;
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].type === 'weekday') { wd = parts[i].value.toLowerCase().slice(0, 3); }
          if (parts[i].type === 'hour') { hh = parseInt(parts[i].value, 10) % 24; }
          if (parts[i].type === 'minute') { mm = parseInt(parts[i].value, 10); }
        }
        var idx = DAYS.indexOf(wd);
        return { dayIndex: idx, minutes: hh * 60 + mm };
      } catch (e) {
        return null;
      }
    }

    function haversine(lat1, lng1, lat2, lng2) {
      var R = 6371;
      var dLat = (lat2 - lat1) * Math.PI / 180;
      var dLng = (lng2 - lng1) * Math.PI / 180;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    // ----- Store directory (#1085): sticky tabs, jump links, scroll-spy -----
    function initDirectory(root) {
      var dir = root.querySelector('[data-sd]');
      if (!dir) { return; }
      var bar = dir.querySelector('[data-sd-tabs]');
      var strip = dir.querySelector('[data-sd-strip]');
      var nudge = dir.querySelector('[data-sd-nudge]');
      var tabs = Array.prototype.slice.call(dir.querySelectorAll('[data-sd-tab]'));
      var groups = Array.prototype.slice.call(dir.querySelectorAll('[data-sd-group]'));
      if (!bar || !strip || !tabs.length || !groups.length) { return; }

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Publish the bar's rendered height for the groups' scroll-margin-top,
      // so a clicked tab lands its group's heading below the header AND the
      // bar rather than underneath them.
      function publishTabsHeight() {
        dir.style.setProperty('--sd-tabs-h', bar.offsetHeight + 'px');
      }
      if ('ResizeObserver' in window) {
        new ResizeObserver(publishTabsHeight).observe(bar);
      } else {
        publishTabsHeight();
        window.addEventListener('resize', publishTabsHeight);
      }

      var activeState = null;
      function setActive(state) {
        if (state === activeState) { return; }
        activeState = state;
        for (var i = 0; i < tabs.length; i++) {
          var on = tabs[i].getAttribute('data-sd-tab') === state;
          tabs[i].classList.toggle('is-active', on);
          if (on) {
            tabs[i].setAttribute('aria-current', 'true');
            // Keep the newly active tab visible inside the scrolling strip.
            var s = strip.getBoundingClientRect();
            var t = tabs[i].getBoundingClientRect();
            if (t.left < s.left || t.right > s.right) {
              strip.scrollTo({
                left: tabs[i].offsetLeft - strip.clientWidth / 2 + tabs[i].offsetWidth / 2,
                behavior: reduceMotion ? 'auto' : 'smooth'
              });
            }
          } else {
            tabs[i].removeAttribute('aria-current');
          }
        }
      }

      // State values can hold quotes (Hawke's Bay), so groups are matched by
      // attribute comparison rather than a selector string.
      function groupFor(state) {
        for (var i = 0; i < groups.length; i++) {
          if (groups[i].getAttribute('data-sd-group') === state) { return groups[i]; }
        }
        return null;
      }

      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sd-tab]');
        if (btn) {
          var state = btn.getAttribute('data-sd-tab');
          var row = groupFor(state);
          if (row) {
            setActive(state);
            // The target is computed by hand rather than left to
            // scrollIntoView + scroll-margin, because the offset MOVES during
            // the scroll: any upward travel makes the header peek its overlay
            // row back in (see header.liquid onScroll), which drops the sticky
            // bar by --header-nav-height AFTER scrollIntoView has already
            // fixed its target, hiding the group heading by exactly that much.
            // An upward jump therefore books the peek height in from the
            // start; a downward jump cancels any active peek, so it books none.
            var rootStyles = getComputedStyle(document.documentElement);
            var headerH = parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
            var navH = parseFloat(rootStyles.getPropertyValue('--header-nav-height')) || 0;
            var target = row.getBoundingClientRect().top + window.scrollY - headerH - bar.offsetHeight;
            if (target < window.scrollY) { target -= navH; }
            window.scrollTo({ top: Math.max(0, target), behavior: reduceMotion ? 'auto' : 'smooth' });
          }
          return;
        }
        if (nudge && e.target.closest('[data-sd-nudge]')) {
          strip.scrollBy({ left: Math.round(strip.clientWidth * 0.6), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });

      // The nudge shows only while more tabs remain past the strip's inline
      // end (CSS removes it on desktop regardless).
      function syncNudge() {
        if (!nudge) { return; }
        var max = strip.scrollWidth - strip.clientWidth;
        nudge.hidden = max <= 1 || strip.scrollLeft >= max - 1;
      }
      strip.addEventListener('scroll', syncNudge, { passive: true });
      window.addEventListener('resize', syncNudge);
      syncNudge();

      // Scroll-spy: the active group is the last one whose top has reached
      // the line drawn by the sticky bar's bottom edge. The line is measured
      // live from the bar itself, so header collapse/peek changes the offset
      // without any bookkeeping here, and a position-based spy behaves the
      // same for wheel scrolls, keyboard paging and anchor jumps. At the very
      // bottom of the page the last group wins even when it is too short to
      // ever reach the line.
      var spyQueued = false;
      function spy() {
        spyQueued = false;
        var line = bar.getBoundingClientRect().bottom + 2;
        var current = groups[0];
        for (var i = 0; i < groups.length; i++) {
          if (groups[i].getBoundingClientRect().top <= line) { current = groups[i]; }
          else { break; }
        }
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
          current = groups[groups.length - 1];
        }
        setActive(current.getAttribute('data-sd-group'));
      }
      window.addEventListener('scroll', function () {
        if (!spyQueued) { spyQueued = true; window.requestAnimationFrame(spy); }
      }, { passive: true });
      // The bar's `top` transitions (0.3s, matching the header slide) and can
      // still be mid-flight when the page scroll settles - the last
      // scroll-driven spy tick then reads a stale line and no further scroll
      // event ever corrects it. Re-evaluate once the bar finishes moving.
      bar.addEventListener('transitionend', function (ev) {
        if (ev.propertyName === 'top') { spy(); }
      });
      spy();
    }

    function init(root) {
      if (!root || root.__slInit) { return; }
      root.__slInit = true;

      initDirectory(root);

      var body = root.querySelector('[data-store-locator]');
      if (!body) { return; }

      var stores = Array.prototype.slice.call(root.querySelectorAll('[data-sl-store]'));
      var list = root.querySelector('[data-sl-list]');
      var empty = root.querySelector('[data-sl-empty]');
      var dataEl = root.querySelector('[data-sl-locations]');
      var locations = [];
      if (dataEl) {
        try { locations = JSON.parse(dataEl.textContent); } catch (e) { locations = []; }
      }

      // Default order is alphabetical by store name (the metaobject order is
      // arbitrary). Sort the array + reflow the DOM once so the list - and every
      // state-filtered subset of it - reads A-Z. Proximity search re-orders by
      // distance instead; clearing it restores this alphabetical order.
      stores.sort(function (a, b) {
        return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'), undefined, { sensitivity: 'base', numeric: true });
      });
      if (list) {
        stores.forEach(function (store) { list.appendChild(store); });
      }

      // Marks the last VISIBLE card (mobile drops its bottom border so the
      // seam against the directory's tab bar stays a single line). CSS cannot
      // express this once filtering hides trailing (proximity search) or
      // interleaved (state filter) cards, so it is re-marked wherever card
      // visibility changes: boot, locateAt, resetResults.
      function markLastVisibleCard() {
        for (var i = 0; i < stores.length; i++) { stores[i].classList.remove('sl-store--last'); }
        if (!list) { return; }
        var visible = list.querySelectorAll('[data-sl-store]:not([hidden])');
        if (visible.length) { visible[visible.length - 1].classList.add('sl-store--last'); }
      }
      markLastVisibleCard();

      // ----- Per-store: render hours table + today/tomorrow status -----
      stores.forEach(function (store) {
        var tz = store.getAttribute('data-tz') || 'Australia/Sydney';
        var now = nowInTz(tz);

        /* Nothing held for this store: leave the hours table and the status alone
           rather than filling them with "Closed". A blank single day inside a
           store that DOES have hours still means closed that day, so that
           fallback below is left as it is. */
        if (!hasAnyHours(store)) { return; }

        var dds = store.querySelectorAll('[data-sl-hours-day]');
        dds.forEach(function (dd) {
          var raw = store.getAttribute('data-hours-' + dd.getAttribute('data-sl-hours-day'));
          var r = parseRange(raw);
          dd.textContent = r ? r.label : 'Closed';
        });

        var todayEl = store.querySelector('[data-sl-openstatus-today]');
        var tomorrowEl = store.querySelector('[data-sl-openstatus-tomorrow]');
        if (!now || now.dayIndex < 0) { return; }

        var todayRaw = store.getAttribute('data-hours-' + DAY_KEYS[now.dayIndex]);
        var today = parseRange(todayRaw);
        if (todayEl) {
          if (today && now.minutes >= today.open && now.minutes < today.close) {
            todayEl.textContent = 'Open ' + today.label + ' today';
          } else if (today && now.minutes < today.open) {
            todayEl.textContent = 'Opens ' + fmtTime(todayRaw.split('-')[0].trim()) + ' today';
          } else {
            todayEl.textContent = 'Currently closed';
            todayEl.classList.remove('sl-status--open');
          }
        }

        if (tomorrowEl) {
          var tIdx = (now.dayIndex + 1) % 7;
          var tomorrow = parseRange(store.getAttribute('data-hours-' + DAY_KEYS[tIdx]));
          if (tomorrow) {
            tomorrowEl.textContent = 'Open ' + tomorrow.label + ' tomorrow';
          }
        }
      });

      // ----- Opening-hours accordion (max-height animation) -----
      // One accordion per card: opening hours, driven by the status chevron
      // ([data-sl-hours-toggle] -> [data-sl-hours-panel]). Only one card's hours
      // panel is open at a time. (The "Store details" button is a plain link to the
      // store's detail page, not an accordion.)
      function expandPanel(el) {
        el.style.maxHeight = el.scrollHeight + 'px';
        var done = function (ev) {
          if (ev && ev.propertyName !== 'max-height') { return; }
          el.style.maxHeight = 'none';
          el.removeEventListener('transitionend', done);
        };
        el.addEventListener('transitionend', done);
      }
      function collapsePanel(el) {
        el.style.maxHeight = el.scrollHeight + 'px';
        el.offsetHeight; // force reflow so the change to 0 transitions
        el.style.maxHeight = '0px';
      }

      function setHoursOpen(store, isOpen) {
        var toggle = store.querySelector('[data-sl-hours-toggle]');
        var panel = store.querySelector('[data-sl-hours-panel]');
        if (toggle) { toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); }
        if (panel) { if (isOpen) { expandPanel(panel); } else { collapsePanel(panel); } }
      }

      function zoomToStore(index) {
        if (!map) { return; }
        for (var i = 0; i < gMarkers.length; i++) {
          if (String(gMarkers[i].index) === String(index)) {
            /* setCenter + setZoom, NOT panTo: centring must be the
               deterministic positioner. The animated forms race each other
               and the popover's overflow fit - an idle can fire mid-zoom
               with the pin still off-screen, and the minimal fit then parks
               pin and popover at whichever edge they entered from (Alex's
               Canberra/Albury/Ballarat/Bendigo screenshots; reproduced with
               panTo-then-setZoom AND setZoom-then-panTo). setCenter is
               instant, setZoom preserves the centre, so the pin lands
               exactly centred with the popover rising above it, and the
               idle fit stays what it should be: a safety net for a popover
               that cannot fit above a CENTRED pin. */
            map.setCenter(gMarkers[i].marker.getPosition());
            map.setZoom(12);
            // Now zoomed in on one store: reveal the "View all stores" control.
            if (mapReset) { mapReset.hidden = false; }
            break;
          }
        }
      }

      // Open a store's HOURS panel: closes any other card's hours panel first (one
      // at a time). Does NOT zoom the map - the chevron only drives the accordion;
      // the map zoom is a whole-card click (see the click handler) or a pin click.
      function openStore(store) {
        var thisToggle = store.querySelector('[data-sl-hours-toggle]');
        var alreadyOpen = thisToggle && thisToggle.getAttribute('aria-expanded') === 'true';
        var openToggle = root.querySelector('[data-sl-hours-toggle][aria-expanded="true"]');
        if (openToggle) {
          var openS = openToggle.closest('[data-sl-store]');
          if (openS && openS !== store) { setHoursOpen(openS, false); }
        }
        if (!alreadyOpen) { setHoursOpen(store, true); }
      }

      function closeStore(store) {
        setHoursOpen(store, false);
      }

      root.addEventListener('click', function (e) {
        // The hours chevron toggles the accordion, selects the store (if it
        // wasn't already the active one) and zooms the map to it.
        var hoursToggle = e.target.closest('[data-sl-hours-toggle]');
        if (hoursToggle && root.contains(hoursToggle)) {
          var hStore = hoursToggle.closest('[data-sl-store]');
          if (!hStore) { return; }
          if (!hStore.classList.contains('is-active')) {
            stores.forEach(function (s) { s.classList.remove('is-active'); });
            hStore.classList.add('is-active');
          }
          if (hoursToggle.getAttribute('aria-expanded') === 'true') { closeStore(hStore); }
          else { openStore(hStore); }
          zoomToStore(hStore.getAttribute('data-index'));
          return;
        }
        // A click anywhere else on the card (not the chevron) marks it as the
        // selected store, zooms the map to it and - wherever the map is on
        // screen (desktop always, mobile Map view) - opens its popover.
        var card = e.target.closest('[data-sl-store]');
        if (card && root.contains(card)) {
          stores.forEach(function (s) { s.classList.remove('is-active'); });
          card.classList.add('is-active');
          zoomToStore(card.getAttribute('data-index'));
          if (desktopMq.matches || body.classList.contains('sl-show-map')) {
            openPopover(card.getAttribute('data-index'));
          } else {
            // Map off screen (mobile List view): open when they get there.
            pendingPopIndex = card.getAttribute('data-index');
          }
        }
      });


      // ----- My store (persisted, shared with the PDP block) -----
      function loadState() {
        try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {}; }
        catch (e) { return {}; }
      }
      function saveState(st) {
        try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(st)); } catch (e) {}
      }
      function setStore(index, name) {
        var st = loadState();
        st.index = index;
        st.name = name;
        saveState(st);
      }
      function clearStore() {
        var st = loadState();
        delete st.index;
        delete st.name;
        saveState(st);
      }
      /* `label` is the suburb shown in messages, most visibly the PDP's
         "Delivery to ..." row. This used to DELETE it, so any search here wiped
         the suburb off the product page and left it showing a postcode instead
         (#19498854). The state is shared, so this page has to maintain it too. */
      function setPostcode(pc, label) {
        var st = loadState();
        st.postcode = pc;
        if (label) { st.label = label; } else { delete st.label; }
        saveState(st);
      }

      /* The point the list and map are currently centred on. Persisted so a
         return visit can open where the shopper left off rather than zoomed out
         over the whole country (#19498854). Only ever coordinates - the postcode
         and the chosen store are stored separately and mean different things. */
      function savePoint(lat, lng) {
        var st = loadState();
        st.lat = lat;
        st.lng = lng;
        saveState(st);
      }
      function clearPoint() {
        var st = loadState();
        delete st.lat;
        delete st.lng;
        saveState(st);
      }
      function clearPostcode() {
        var st = loadState();
        delete st.postcode;
        delete st.label;
        saveState(st);
      }

      function reflectMyStoreButtons() {
        var my = loadState();
        var myIndex = my.index != null ? String(my.index) : null;
        stores.forEach(function (store) {
          var btn = store.querySelector('[data-sl-setstore]');
          if (!btn) { return; }
          var isMine = store.getAttribute('data-index') === myIndex;
          btn.setAttribute('aria-pressed', isMine ? 'true' : 'false');
          var lbl = btn.querySelector('[data-sl-setstore-label]');
          var check = btn.querySelector('.sl-store__check');
          if (lbl) { lbl.textContent = isMine ? 'My store' : 'Set as my store'; }
          if (check) { check.hidden = !isMine; }
        });
        // The popover carries its own my-store toggle; keep it in step with
        // the cards whichever side made the change.
        updatePopMyStore();
      }

      root.addEventListener('click', function (e) {
        var setBtn = e.target.closest('[data-sl-setstore]');
        if (!setBtn || !root.contains(setBtn)) { return; }
        var store = setBtn.closest('[data-sl-store]');
        var index = store.getAttribute('data-index');
        var current = loadState();
        if (current.name && String(current.index) === index) {
          clearStore();
        } else {
          setStore(index, store.getAttribute('data-name'));
        }
        reflectMyStoreButtons();
      });

      // The delivery info icon ([data-store-collection-open]) is revealed + wired
      // by sections/store-collection-prompt.liquid (Overlays group), not here.

      // ----- State filter (drives which stores/pins are eligible) -----
      // selectedStates is the set of checked state codes; empty = no filter (all
      // stores eligible). stateAllows() gates every visibility decision below.
      var selectedStates = [];
      function stateAllows(store) {
        if (!selectedStates.length) { return true; }
        return selectedStates.indexOf(store.getAttribute('data-state')) !== -1;
      }

      // ----- Distance search, catchment gating + sort -----
      var maxDistance = parseFloat(body.getAttribute('data-sl-max-distance')) || 0;
      var toofar = root.querySelector('[data-sl-toofar]');
      var nearestNameEl = root.querySelector('[data-sl-nearest-name]');
      var nearestDistEl = root.querySelector('[data-sl-nearest-distance]');
      // Last searched location, so a state-filter change can re-run the current
      // view (proximity search if one is active, else the full list).
      var lastLat = null, lastLng = null;

      function fmtKm(d) {
        return d < 10 ? d.toFixed(1) : String(Math.round(d));
      }

      function locateAt(lat, lng, skipFrame) {
        // The list is about to be re-ordered/re-gated and the selection may be
        // hidden by it, so the popover comes down first.
        closePopover();
        lastLat = lat;
        lastLng = lng;
        savePoint(lat, lng);
        stores.forEach(function (store) {
          var sLat = parseFloat(store.getAttribute('data-lat'));
          var sLng = parseFloat(store.getAttribute('data-lng'));
          var distEl = store.querySelector('[data-sl-distance]');
          if (isNaN(sLat) || isNaN(sLng)) {
            store._dist = Number.MAX_VALUE;
            return;
          }
          var d = haversine(lat, lng, sLat, sLng);
          store._dist = d;
          if (distEl) {
            distEl.textContent = fmtKm(d) + 'km';
            distEl.hidden = false;
          }
        });

        // Only stores in the selected states are eligible; hide everything first,
        // then reveal the eligible nearest set.
        var ordered = stores.filter(stateAllows).sort(function (a, b) { return (a._dist || 0) - (b._dist || 0); });
        var nearest = ordered.length ? ordered[0]._dist : Number.MAX_VALUE;
        stores.forEach(function (s) { s.hidden = true; });

        if (!ordered.length) {
          if (toofar) { toofar.hidden = true; }
          if (empty) { empty.hidden = false; }
        } else if (maxDistance > 0 && nearest > maxDistance) {
          if (empty) { empty.hidden = true; }
          if (toofar) {
            if (nearestNameEl) { nearestNameEl.textContent = ordered[0].getAttribute('data-name'); }
            if (nearestDistEl) { nearestDistEl.textContent = fmtKm(nearest); }
            toofar.hidden = false;
          }
        } else {
          if (empty) { empty.hidden = true; }
          if (toofar) { toofar.hidden = true; }
          ordered.forEach(function (store, rank) {
            list.appendChild(store);
            store.hidden = rank >= 10;
          });
        }
        markLastVisibleCard();

        /* Frame the shopper AND their nearest store, rather than dropping a
           fixed zoom 10 on the point and hoping a pin falls inside it. Only when
           that store is actually reachable: past maxDistance the nearest one can
           be hundreds of kilometres away, and fitting both would zoom further
           OUT than the fixed zoom it replaced. */
        /* skipFrame: the geolocate CONFIRM path centres the chosen nearest
           store itself (Alex's ruling - the store wins the centre exactly
           like a manual selection), so the shopper+store dual framing must
           not run underneath it. Every other caller frames as before. */
        if (map && !skipFrame) {
          var reachable = ordered.length && !(maxDistance > 0 && nearest > maxDistance);
          frameLocation(lat, lng, reachable ? ordered[0] : null);
        }
      }

      /* Fit the map to the shopper's point plus one store. Falls back to the old
         fixed zoom when there is no usable store to include. */
      function frameLocation(lat, lng, storeEl) {
        if (!map || !window.google) { return; }
        var sLat = storeEl ? parseFloat(storeEl.getAttribute('data-lat')) : NaN;
        var sLng = storeEl ? parseFloat(storeEl.getAttribute('data-lng')) : NaN;
        if (isNaN(sLat) || isNaN(sLng)) {
          map.setCenter({ lat: lat, lng: lng });
          map.setZoom(10);
          return;
        }
        var b = new google.maps.LatLngBounds();
        b.extend({ lat: lat, lng: lng });
        b.extend({ lat: sLat, lng: sLng });
        // Padding keeps both pins off the edge of the canvas.
        map.fitBounds(b, 64);
        /* A store almost on top of the shopper would otherwise fit to street
           level, which loses all sense of where they are. fitBounds settles
           asynchronously, so the cap has to wait for the map to be idle. */
        google.maps.event.addListenerOnce(map, 'idle', function () {
          if (map.getZoom() > 14) { map.setZoom(14); }
        });
      }

      function resetResults() {
        closePopover();
        lastLat = null;
        lastLng = null;
        clearPoint();
        if (toofar) { toofar.hidden = true; }
        var anyVisible = false;
        stores.forEach(function (store) {
          list.appendChild(store);
          store.hidden = !stateAllows(store);
          if (!store.hidden) { anyVisible = true; }
          store.classList.remove('is-active');
          var distEl = store.querySelector('[data-sl-distance]');
          if (distEl) { distEl.hidden = true; distEl.textContent = ''; }
        });
        if (empty) { empty.hidden = anyVisible; }
        markLastVisibleCard();
        fitAllMarkers();
      }

      // Re-run the current view after a state-filter change: proximity search if
      // one is active, otherwise the full (filtered) list.
      function reapply() {
        if (lastLat !== null && lastLng !== null) { locateAt(lastLat, lastLng); }
        else { resetResults(); }
      }

      /* Restrict the typeahead to places a store search makes sense against
         (#19498861). Without this Places returns every type it has, so "300"
         offered "300 La Trobe Street" and "Preston" offered "Preston Market".

         postal_code, locality and sublocality are all needed. AU suburbs are
         localities, but NZ suburbs are SUBLOCALITIES - drop it and Ponsonby and
         Takapuna return nothing at all on the NZ store, while AU looks perfectly
         fine. administrative_area_level_1 is the state, which the ticket asks
         for alongside postcode and suburb. Four of the five types the API
         allows; country is deliberately left out.

         Google's own docs are ambiguous here - postal_code and locality sit in
         their "Table B", documented as usable only by the Autocomplete WIDGET -
         but the data API does accept them. Confirmed by request, not by doc. */
      var PLACE_TYPES = ['postal_code', 'locality', 'sublocality', 'administrative_area_level_1'];

      /* Country restriction from the "Limit address results to countries" theme
         setting. Blank means no restriction (worldwide results).

         Module scope on purpose: BOTH search paths need it. The typeahead
         restricts its predictions with it, and the Enter/geocode path restricts
         its lookup with it. When only the typeahead had it, typing "blackburn"
         and pressing Enter geocoded to Blackburn in England - 14,623km from
         Perth - while tapping the suggestion resolved to Blackburn VIC. */
      /* Postcode-to-suburb suggestions (#1190). Same two values the PDP block
         reads off its own root. */
      var transitUrl = (body.getAttribute('data-transit-url') || '').replace(/\/$/, '');
      var slCountry = (body.getAttribute('data-country') || 'AU').toUpperCase();

      var regions = (body.getAttribute('data-maps-regions') || '')
        .split(',')
        .map(function (c) { return c.trim().toLowerCase(); })
        .filter(function (c) { return c.length === 2; })
        .slice(0, 15);

      // ----- Google Map -----
      var map = null, gMarkers = [], geocoder = null, mapsRequested = false;
      var acFetch = null, pendingTerm = null;
      var mapReset = root.querySelector('[data-sl-map-reset]');
      // Selected/unselected pin icons (assigned in buildMap): with a store
      // selected its pin stays dark oak and every OTHER pin goes warm grey
      // (Figma 19442:74906 / 74912); with nothing selected all pins are dark.
      var markerIcon = null, markerIconMuted = null;

      // ----- Store popover (#1085 slice two) -----
      // One Liquid-rendered shell ([data-sl-pop]), repopulated per store and
      // positioned over the selected marker (see positionPopover below). It
      // replaced the mobile under-map detail card on every breakpoint, so the
      // map's aspect never changes and cards never leave the list.
      var popEl = root.querySelector('[data-sl-pop]');
      var popIndex = null;
      // A user-initiated selection made while the map is OFF-SCREEN (mobile
      // List view) defers its popover until the user enters Map view (Alex,
      // retest 3). Cleared by any dismissal or replacement selection; NEVER
      // set by passive restores (remembered my-store, saved point), which
      // still open nothing.
      var pendingPopIndex = null;
      // True from open until the popover measures fully inside the map; the
      // idle-driven fit below pans only while it is set, so a LATER user pan
      // clips the popover at the edge instead of being fought back.
      var popNeedsFit = false;

      function markerByIndex(index) {
        for (var i = 0; i < gMarkers.length; i++) {
          if (String(gMarkers[i].index) === String(index)) { return gMarkers[i]; }
        }
        return null;
      }

      function syncMarkerColours() {
        if (!markerIcon || !markerIconMuted) { return; }
        gMarkers.forEach(function (m) {
          var muted = popIndex !== null && String(m.index) !== String(popIndex);
          m.marker.setIcon(muted ? markerIconMuted : markerIcon);
        });
      }

      /* The popover element STAYS in .sl-page__map rather than entering the
         map's panes: .sl-map__canvas is composited with mix-blend-mode:
         multiply (what mutes the map imagery against the sand ground) and
         everything inside it renders darkened - pane-parenting turned the
         mist box into the exact multiply product. The PINS stay inside the
         blend; Alex signed their rendered colour off as-is.

         Positioning is plain Mercator maths from map.getCenter()/getZoom()
         rather than OverlayView.getProjection(): the projection object goes
         STALE between gmaps' own draw callbacks, and a fit that measures a
         stale-positioned popover right after setCenter pans the map away
         from a perfectly centred pin (the +327px edge-parking Alex
         screenshotted). getCenter/getZoom are always current, so the
         popover lands where the pin actually is, every time. */
      var popTracking = false;

      function positionPopover() {
        if (!map || !popEl || popEl.hidden || popIndex === null) { return; }
        var m = markerByIndex(popIndex);
        var canvas = root.querySelector('.sl-map__canvas');
        if (!m || !canvas) { return; }
        var z = map.getZoom();
        var c = map.getCenter();
        var pos = m.marker.getPosition();
        if (z == null || !c || !pos) { return; }
        var scale = Math.pow(2, z) * 256;
        function worldX(lng) { return lng / 360 + 0.5; }
        function worldY(lat) {
          var sin = Math.sin(lat * Math.PI / 180);
          sin = Math.min(Math.max(sin, -0.9999), 0.9999);
          return 0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI);
        }
        var x = canvas.clientWidth / 2 + (worldX(pos.lng()) - worldX(c.lng())) * scale;
        var y = canvas.clientHeight / 2 + (worldY(pos.lat()) - worldY(c.lat())) * scale;
        popEl.style.left = x + 'px';
        popEl.style.top = y + 'px';
      }

      function ensurePopTracking() {
        if (popTracking || !popEl || !map || !window.google) { return; }
        popTracking = true;
        var popRaf = false;
        map.addListener('bounds_changed', function () {
          if (popRaf) { return; }
          popRaf = true;
          window.requestAnimationFrame(function () {
            popRaf = false;
            positionPopover();
          });
        });
        /* Idle-driven fit: a freshly opened popover pans the map by its
           overflow delta until it measures fully inside (safety net only -
           selection CENTRES the pin, which normally already fits). Once
           fitted, later user pans clip at the edge and are never fought. */
        map.addListener('idle', function () {
          if (popNeedsFit && popEl && !popEl.hidden) { panPopoverIntoView(); }
        });
      }

      function updatePopMyStore() {
        if (!popEl || popIndex === null) { return; }
        var btn = popEl.querySelector('[data-sl-pop-mystore]');
        var lbl = popEl.querySelector('[data-sl-pop-mystore-label]');
        if (!btn || !lbl) { return; }
        var my = loadState();
        var mine = my.index != null && String(my.index) === String(popIndex);
        btn.setAttribute('aria-pressed', mine ? 'true' : 'false');
        lbl.textContent = mine ? 'My store' : 'Set as my store';
      }

      function openPopover(index) {
        if (!popEl || !map) { return; }
        var store = root.querySelector('[data-sl-store][data-index="' + index + '"]');
        if (!store || !markerByIndex(index)) { return; }
        ensurePopTracking();

        popEl.querySelector('[data-sl-pop-name]').textContent = store.getAttribute('data-name') || '';

        // Hours summary re-uses the per-card status lines computed at boot; a
        // store we hold no hours for shows none, same as its card (#19498863).
        var hoursEl = popEl.querySelector('[data-sl-pop-hours]');
        var todayEl = store.querySelector('[data-sl-openstatus-today]');
        var tomorrowEl = store.querySelector('[data-sl-openstatus-tomorrow]');
        var lines = [];
        if (todayEl && todayEl.textContent.trim()) { lines.push(todayEl.textContent.trim()); }
        if (tomorrowEl && tomorrowEl.textContent.trim()) { lines.push(tomorrowEl.textContent.trim()); }
        hoursEl.textContent = '';
        lines.forEach(function (line, i) {
          if (i > 0) { hoursEl.appendChild(document.createElement('br')); }
          hoursEl.appendChild(document.createTextNode(line));
        });
        hoursEl.hidden = !lines.length;

        // Address WITHOUT the country line, per the popover node.
        var addrEl = popEl.querySelector('[data-sl-pop-address]');
        addrEl.textContent = '';
        ['data-address1', 'data-address2', 'data-locality'].forEach(function (attr) {
          var val = (store.getAttribute(attr) || '').trim();
          if (!val) { return; }
          if (addrEl.childNodes.length) { addrEl.appendChild(document.createElement('br')); }
          addrEl.appendChild(document.createTextNode(val));
        });

        var phone = (store.getAttribute('data-phone') || '').trim();
        var phoneEl = popEl.querySelector('[data-sl-pop-phone]');
        phoneEl.hidden = !phone;
        if (phone) {
          phoneEl.href = 'tel:' + phone.replace(/\s/g, '');
          phoneEl.textContent = phone;
        }

        var dirEl = popEl.querySelector('[data-sl-pop-directions]');
        var lat = store.getAttribute('data-lat');
        var lng = store.getAttribute('data-lng');
        dirEl.hidden = !lat || !lng;
        if (lat && lng) {
          dirEl.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(lat + ',' + lng);
        }

        var pageUrl = store.getAttribute('data-page-url');
        var pageEl = popEl.querySelector('[data-sl-pop-page]');
        pageEl.hidden = !pageUrl;
        if (pageUrl) { pageEl.href = pageUrl; }

        // A lone CTA in the last grid row spans both columns, so a store
        // missing its phone or detail page never shows an empty mist slot.
        var ctas = popEl.querySelectorAll('.sl-pop__cta');
        var visible = [];
        ctas.forEach(function (c) {
          c.classList.remove('sl-pop__cta--wide');
          if (!c.hidden) { visible.push(c); }
        });
        if (visible.length % 2 === 1) { visible[visible.length - 1].classList.add('sl-pop__cta--wide'); }

        popIndex = index;
        pendingPopIndex = null;
        popNeedsFit = true;
        updatePopMyStore();
        popEl.hidden = false;
        syncMarkerColours();
        positionPopover();
        panPopoverIntoView();
      }

      function closePopover() {
        popIndex = null;
        pendingPopIndex = null;
        popNeedsFit = false;
        if (popEl && !popEl.hidden) { popEl.hidden = true; }
        syncMarkerColours();
      }

      /* Auto-pan on open, like a native InfoWindow: when the freshly opened
         popover would cross the container's edge, pan the map by the
         overflow delta so pin and popover both fit (both axes, so corner
         pins pan diagonally). Runs immediately for opens on a still map AND
         once more on the next idle, because most opens follow a panTo /
         fitBounds that is still animating when the popover shows - the fit
         must be measured against where the map SETTLES (the geolocate flow's
         frameLocation is the case that overflowed). panBy animates and the
         bounds_changed redraw re-anchors the popover every frame, so the
         two never fight. */
      function panPopoverIntoView() {
        if (!map || !popEl || popEl.hidden) { return; }
        positionPopover();
        var mapBox = root.querySelector('.sl-page__map');
        if (!mapBox) { return; }
        var mr = mapBox.getBoundingClientRect();
        var pr = popEl.getBoundingClientRect();
        var pad = 8;
        var dx = 0;
        var dy = 0;
        if (pr.left < mr.left + pad) { dx = pr.left - (mr.left + pad); }
        else if (pr.right > mr.right - pad) { dx = pr.right - (mr.right - pad); }
        if (pr.top < mr.top + pad) { dy = pr.top - (mr.top + pad); }
        else if (pr.bottom > mr.bottom - pad) { dy = pr.bottom - (mr.bottom - pad); }
        if (dx || dy) { map.panBy(dx, dy); }
        else { popNeedsFit = false; }
      }

      // Popover controls: close button, and the popover's own my-store toggle
      // (kept in step with the cards' buttons in both directions). Listeners
      // sit ON the popover element - self-contained regardless of where the
      // shell lives (it once sat inside the gmaps panes, which do not let
      // clicks bubble out to the section root).
      if (popEl) {
        popEl.addEventListener('click', function (e) {
          if (e.target.closest('[data-sl-pop-close]')) { closePopover(); return; }
          var myBtn = e.target.closest('[data-sl-pop-mystore]');
          if (myBtn && popIndex !== null) {
            var current = loadState();
            var popStore = root.querySelector('[data-sl-store][data-index="' + popIndex + '"]');
            if (current.index != null && String(current.index) === String(popIndex)) {
              clearStore();
            } else if (popStore) {
              setStore(String(popIndex), popStore.getAttribute('data-name'));
            }
            reflectMyStoreButtons();
          }
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popEl && !popEl.hidden) { closePopover(); }
      });

      // Show only pins for the selected states (all when no filter). Does not
      // refit the viewport - used when a search has already framed the map.
      function syncMarkerVisibility() {
        if (!map || !window.google) { return; }
        gMarkers.forEach(function (m) {
          var visible = !selectedStates.length || selectedStates.indexOf(m.state) !== -1;
          m.marker.setMap(visible ? map : null);
        });
      }

      // Re-frame the map to show every eligible store pin, and hide the reset
      // control. Honours the active state filter.
      function fitAllMarkers() {
        if (mapReset) { mapReset.hidden = true; }
        if (!map || !gMarkers.length || !window.google) { return; }
        var b = new google.maps.LatLngBounds();
        var any = false;
        gMarkers.forEach(function (m) {
          var visible = !selectedStates.length || selectedStates.indexOf(m.state) !== -1;
          m.marker.setMap(visible ? map : null);
          if (visible) { b.extend(m.marker.getPosition()); any = true; }
        });
        if (any) { map.fitBounds(b); }
      }

      function buildMap() {
        var canvas = root.querySelector('[data-sl-map-canvas]');
        if (!canvas || !window.google || !window.google.maps) { return; }
        map = new google.maps.Map(canvas, { zoom: 4, center: { lat: -25.27, lng: 133.77 }, mapTypeControl: false, streetViewControl: false, fullscreenControl: false, styles: MAP_STYLE });
        geocoder = new google.maps.Geocoder();
        /* Pin per Figma 19442:74906 (selected, dark oak) / 19442:74912
           (unselected, warm grey): 25x30 - the old cream-dot 24x29 pin and its
           double-size selected variant are gone with the under-map detail
           flow. The nodes render the inner circle as a transparent cutout;
           Alex ruled it SOLID #edebe4 for both variants (retest, 1 Sep) so it
           reads as a dot against any map imagery. */
        function pinIcon(colour) {
          var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 25 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.4133 0C19.2691 0 24.8274 5.55759 24.8276 12.4133C24.8276 20.689 12.4133 30 12.4133 30C12.4102 29.9977 0 20.688 0 12.4133C0.000176084 5.5577 5.5577 0.00017608 12.4133 0ZM12.5179 7.66136C10.5822 7.66136 9.01291 9.23061 9.01291 11.1664C9.01291 13.1022 10.5822 14.6714 12.5179 14.6714C14.4537 14.6714 16.0229 13.1022 16.0229 11.1664C16.0229 9.23061 14.4537 7.66136 12.5179 7.66136Z" fill="' + colour + '"/><circle cx="12.5179" cy="11.1664" r="3.505" fill="#edebe4"/></svg>';
          return {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
            scaledSize: new google.maps.Size(25, 30),
            anchor: new google.maps.Point(12.5, 30)
          };
        }
        markerIcon = pinIcon('#302520');
        markerIconMuted = pinIcon('#70675B');
        // A click on the bare map dismisses the popover (pins handle their own).
        map.addListener('click', closePopover);
        locations.forEach(function (loc) {
          var pos = { lat: loc.lat, lng: loc.lng };
          // optimized: false keeps each pin a real DOM element (not canvas),
          // so its title is exposed and the icon swap on selection is cheap.
          var marker = new google.maps.Marker({ position: pos, map: map, title: loc.name, icon: markerIcon, optimized: false });
          marker.addListener('click', function () { focusStore(loc.i); });
          gMarkers.push({ index: loc.i, state: loc.s, marker: marker });
        });
        /* Open where the shopper left off. The map used to always fit every pin
           in the country, even for someone whose location was already known
           (#19498854), so the first thing they had to do was tell it again.

           Three ways in, most precise first:
             - a stored point, from any previous search on any surface
             - a stored postcode with no point, which is what earlier visits left
               behind before the point was persisted. Geocoding it costs a
               request, but only once: locateAt then writes the point.
             - nothing known, so frame the country as before.
           A stored CHOSEN store is deliberately not used to centre the map: the
           shopper picked that store, which does not mean they are standing at
           it. */
        /* A selection deferred from List view IS the navigation intent, so
           it REPLACES the default framing entirely: running fitAllMarkers or
           a saved-point locateAt first starts an async fitBounds animation
           that stomps the pending setCenter and strands the pin off-centre
           (caught live at 375). It also has to be read before those branches
           anyway - the geolocate flow persists a point, and locateAt's
           closePopover would wipe the pending index. Passive restores never
           set pendingPopIndex, so they always take the ordinary branches. */
        var bootPending = pendingPopIndex;
        if (bootPending !== null && body.classList.contains('sl-show-map')) {
          pendingPopIndex = null;
          zoomToStore(bootPending);
          openPopover(bootPending);
        } else {
          var saved = loadState();
          if (typeof saved.lat === 'number' && typeof saved.lng === 'number') {
            locateAt(saved.lat, saved.lng);
          } else if (saved.postcode) {
            runSearch(saved.postcode);
          } else {
            // Apply the current state filter and frame the visible pins.
            fitAllMarkers();
          }
        }
        setupAutocomplete();
      }

      /* Suggestion list and its loading state, hoisted out of setupAutocomplete
         so the field can respond before Places has finished downloading - see
         the focus/input listeners further down. */
      var suggestionsList = root.querySelector('[data-sl-suggestions]');

      function showSkeleton() {
        if (!suggestionsList) { return; }
        suggestionsList.innerHTML = '';
        for (var i = 0; i < 5; i++) {
          var li = document.createElement('li');
          li.className = 'sl-suggestions__item sl-suggestions__item--skeleton';
          li.setAttribute('aria-hidden', 'true');
          var bar = document.createElement('span');
          bar.className = 'sl-skeleton';
          li.appendChild(bar);
          suggestionsList.appendChild(li);
        }
        suggestionsList.hidden = false;
      }

      function clearSuggestions() {
        if (!suggestionsList) { return; }
        suggestionsList.hidden = true;
        suggestionsList.innerHTML = '';
      }

      function setupAutocomplete() {
        if (!searchInput || searchInput.__acInit) { return; }
        var places = google.maps.places;
        if (!places || !places.AutocompleteSuggestion || !places.AutocompleteSessionToken) { return; }
        searchInput.__acInit = true;

        var listbox = suggestionsList;
        // One per listbox row - see googleEntry / suburbEntry.
        var entries = [];
        var activeIndex = -1;
        var token = null;
        var debounce = null;
        function closeList() {
          if (listbox) { listbox.hidden = true; listbox.innerHTML = ''; }
          entries = [];
          activeIndex = -1;
        }

        function highlight() {
          if (!listbox) { return; }
          var items = listbox.children;
          for (var i = 0; i < items.length; i++) {
            items[i].classList.toggle('is-active', i === activeIndex);
          }
        }

        /* One entry per ROW in the listbox, whatever fed it - a Google
           prediction or a suburb from our own postcode data (#1190). Keeps the
           keyboard index aligned with the DOM once the list holds both.

           TWIN of the same block in blocks/product-store-locator.liquid; the
           shared parts (postcode detection, the worker fetch, the dedupe) live
           in snippets/suburb-suggestions.liquid so they cannot drift. What is
           mirrored here is only the wiring into this file's own listbox and
           setLocation. */
        function googleEntry(sugg) {
          var pred = sugg && sugg.placePrediction;
          if (!pred) { return null; }
          return {
            label: pred.text ? pred.text.text : '',
            /* The suburb Google MEANT, via the same helper the pick path uses -
               not the raw main text. For a postcode query Google packs the
               state in with it ("Harman ACT 2600"), which normalises to
               something our "Harman" can never match, and the suburb then
               appeared twice (#1190). */
            main: suburbFromPrediction(pred),
            pick: function () { chooseGoogle(sugg); }
          };
        }

        function countryName() {
          return slCountry === 'NZ' ? 'New Zealand' : 'Australia';
        }

        function suburbEntry(name, padded) {
          return {
            label: name + ' ' + padded + ', ' + countryName(),
            main: name,
            pick: function () { chooseSuburb(name, padded); }
          };
        }

        /* A suburb picked from OUR data. Postcode and suburb are already known,
           so only the point has to be resolved - through the same geocoder the
           free-text fallback uses - after which the normal setLocation flow
           runs untouched. */
        function chooseSuburb(name, padded) {
          if (!geocoder) { return; }
          searchInput.value = name;
          token = null;
          closeList();
          geocoder.geocode(
            { address: name + ' ' + padded + ' ' + countryName(), region: slCountry.toLowerCase() },
            function (results, status) {
              if (status !== 'OK' || !results[0] || !results[0].geometry) { return; }
              var loc = results[0].geometry.location;
              setLocation(loc.lat(), loc.lng(), padded, name);
            }
          );
        }

        function chooseGoogle(sugg) {
          var pred = sugg && sugg.placePrediction;
          if (!pred) { return; }
          var place = pred.toPlace();
          place.fetchFields({ fields: ['location', 'addressComponents'] }).then(function () {
            if (!place.location) { return; }
            var pc = postcodeFromComponents(place.addressComponents, function (c) { return c.longText; });
            /* Suburb the shopper picked, matching the product page. Places puts
               it in the main text for a suburb, but for a POSTCODE the main text
               is the postcode itself and the suburb sits at the front of the
               secondary text. */
            var label = suburbFromPrediction(pred);
            searchInput.value = label || (pred.text ? pred.text.text : searchInput.value);
            token = null;
            setLocation(place.location.lat(), place.location.lng(), pc, label);
            closeList();
          }).catch(function () {});
        }

        /* Every row is built here, from either source, so one of our suburbs is
           indistinguishable from a Google row. */
        function appendRow(entry) {
          var li = document.createElement('li');
          li.className = 'sl-suggestions__item';
          li.setAttribute('role', 'option');
          li.textContent = entry.label;
          li.addEventListener('mousedown', function (ev) { ev.preventDefault(); entry.pick(); });
          listbox.appendChild(li);
          return li;
        }

        function renderSuggestions(res) {
          entries = [];
          activeIndex = -1;
          if (!listbox) { return; }
          listbox.innerHTML = '';
          (res || []).forEach(function (sugg) {
            var entry = googleEntry(sugg);
            if (!entry) { return; }
            entries.push(entry);
            appendRow(entry);
          });
          listbox.hidden = listbox.children.length === 0;
        }

        /* Our suburbs, appended AFTER Google's rows and only where Google has
           not already offered the same suburb (#1190). */
        function appendSuburbs(suburbs, padded) {
          var helper = window.__esSuburbSuggest;
          if (!helper || !listbox || !suburbs || !suburbs.length) { return; }
          var offered = entries.map(function (e) { return e.main; });
          helper.extras(offered, suburbs).forEach(function (name) {
            var entry = suburbEntry(name, padded);
            entries.push(entry);
            appendRow(entry);
          });
          listbox.hidden = listbox.children.length === 0;
        }

        /* Guards against a slow response landing on a query already typed past. */
        var reqSeq = 0;

        function fetchSuggestions(value) {
          if (!token) { token = new places.AutocompleteSessionToken(); }
          showSkeleton();
          var seq = ++reqSeq;
          var helper = window.__esSuburbSuggest;
          // Only a postcode query gets the extra suburbs (#1190).
          var padded = helper ? helper.asPostcode(value) : '';
          /* Started in PARALLEL and never awaited, so Google's list renders on
             its own timing whatever the worker does. */
          var extrasPromise = padded
            ? helper.fetchSuburbs(transitUrl, slCountry, padded)
            : null;
          var req = { input: value, sessionToken: token, includedPrimaryTypes: PLACE_TYPES };
          if (regions.length) { req.includedRegionCodes = regions; }
          places.AutocompleteSuggestion.fetchAutocompleteSuggestions(req).then(function (res) {
            if (seq !== reqSeq) { return; }
            renderSuggestions(res && res.suggestions ? res.suggestions : []);
            if (!extrasPromise) { return; }
            extrasPromise.then(function (suburbs) {
              if (seq !== reqSeq) { return; }
              appendSuburbs(suburbs, padded);
            });
          }).catch(function () { closeList(); });
        }

        searchInput.addEventListener('input', function () {
          var value = searchInput.value.trim();
          window.clearTimeout(debounce);
          if (value.length < 3) { closeList(); return; }
          debounce = window.setTimeout(function () { fetchSuggestions(value); }, 200);
        });

        searchInput.addEventListener('keydown', function (e) {
          if (listbox.hidden || !listbox.children.length) {
            if (e.key === 'Enter') { e.preventDefault(); runSearch(searchInput.value.trim()); }
            return;
          }
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            activeIndex = Math.min(activeIndex + 1, listbox.children.length - 1);
            highlight();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            activeIndex = Math.max(activeIndex - 1, 0);
            highlight();
          } else if (e.key === 'Enter') {
            e.preventDefault();
            /* With the list open, Enter takes a suggestion - the highlighted one
               if the shopper arrowed to it, otherwise the first, which is what
               every other typeahead does and what a phone's "go" key should do.
               It used to fall through to the free-text geocode here, which is
               how "blackburn" + Enter ended up in England. */
            if (activeIndex >= 0 && entries[activeIndex]) { entries[activeIndex].pick(); }
            else if (entries[0]) { entries[0].pick(); }
            else { runSearch(searchInput.value.trim()); }
          } else if (e.key === 'Escape') {
            closeList();
          }
        });

        document.addEventListener('click', function (e) {
          if (!e.target.closest('.sl-search')) { closeList(); }
        });

        acFetch = fetchSuggestions;
        if (pendingTerm) { fetchSuggestions(pendingTerm); pendingTerm = null; }
      }

      function loadMaps() {
        if (mapsRequested) { return; }
        mapsRequested = true;
        if (window.google && window.google.maps) { buildMap(); return; }
        var key = body.getAttribute('data-maps-key');
        if (!key) { return; }
        window.__esSlMapInit = function () {
          document.dispatchEvent(new CustomEvent('es:sl-maps-ready'));
        };
        document.addEventListener('es:sl-maps-ready', function handler() {
          document.removeEventListener('es:sl-maps-ready', handler);
          buildMap();
        });
        if (window.__esSlMapsLoading) { return; }
        window.__esSlMapsLoading = true;
        var s = document.createElement('script');
        s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&callback=__esSlMapInit';
        s.async = true;
        document.head.appendChild(s);
      }

      // Map-pin click: select the store, zoom to it and open its popover over
      // the pin - the same behaviour on every breakpoint now the popover has
      // replaced the mobile under-map detail. The in-list hours accordion no
      // longer auto-opens (the popover carries the hours summary); the list
      // still scrolls to the card where the list is actually visible.
      function focusStore(index) {
        var store = root.querySelector('[data-sl-store][data-index="' + index + '"]');
        if (!store) { return; }
        stores.forEach(function (s) { s.classList.remove('is-active'); });
        store.classList.add('is-active');
        zoomToStore(index);
        openPopover(index);
        if (desktopMq.matches) {
          window.setTimeout(function () {
            store.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 320);
        }
      }

      function setLocation(lat, lng, postcode, label, skipFrame) {
        if (postcode) { setPostcode(postcode, label); } else { clearPostcode(); }
        locateAt(lat, lng, skipFrame);
      }

      function postcodeFromComponents(components, getText) {
        if (!components) { return ''; }
        for (var i = 0; i < components.length; i++) {
          var types = components[i].types || [];
          if (types.indexOf('postal_code') !== -1) { return getText(components[i]); }
        }
        return '';
      }

      /* Free-text fallback: only reached when the typeahead has nothing to offer.
         `componentRestrictions.country` is a RESTRICTION - results outside those
         countries are not returned at all. The previous `region: 'au'` was only a
         ccTLD bias, which a more prominent foreign match simply outvotes, and it
         was hardcoded to AU on a section that also ships to the NZ store. The
         codes come from the same theme setting the typeahead uses, so the two
         paths can no longer disagree about where in the world we are searching.

         `country` must be a STRING here, not an array. The array form is what
         the Places autocomplete takes; the Geocoder rejects it with "in property
         componentRestrictions: in property country: not a string", and because
         this is the callback form the rejection is silent - no callback, no
         error, the search just does nothing. Verified against the live API.
         The setting is one country per store today (AU here, NZ on the NZ
         store); if it ever lists several, the typeahead offers all of them and
         this narrows to the first. */
      function runSearch(query) {
        if (!query || !geocoder) { return; }
        var req = { address: query };
        if (regions.length) { req.componentRestrictions = { country: regions[0] }; }
        geocoder.geocode(req, function (results, status) {
          /* Restricting to a country means the Geocoder never says ZERO_RESULTS
             for junk - it falls back to the COUNTRY CENTROID and returns "OK,
             Australia", which is in the Northern Territory and put the nearest
             store 1,169km away in Adelaide. A country-level hit is not a place
             anyone searched for, so it counts as no match. */
          var types = results && results[0] ? (results[0].types || []) : [];
          var countryOnly = types.indexOf('country') !== -1;
          if (status === 'OK' && results[0] && !countryOnly) {
            var loc = results[0].geometry.location;
            var pc = postcodeFromComponents(results[0].address_components, function (c) { return c.long_name; });
            // No prediction on this path, so the suburb comes from the geocode.
            var label = localityFromComponents(results[0].address_components, function (c) { return c.long_name; });
            setLocation(loc.lat(), loc.lng(), pc, label);
          } else {
            /* Nothing matched. Show the empty state and take the too-far callout
               down with it: they are alternatives, and a stale one left standing
               reads as "no results" and "the closest store is X" at once. */
            if (toofar) { toofar.hidden = true; }
            if (empty) { empty.hidden = false; }
          }
        });
      }

      /* Nearest store to a point, worked out without touching the list, so the
         prompt can name the store BEFORE the shopper agrees and nothing on
         screen moves until they do. Hidden rows are skipped: a store filtered
         out of the list is not one to hand them. */
      function nearestStoreTo(lat, lng) {
        var best = null;
        var bestDist = Infinity;
        for (var i = 0; i < stores.length; i++) {
          var candidate = stores[i];
          if (candidate.hidden) { continue; }
          var sLat = parseFloat(candidate.getAttribute('data-lat'));
          var sLng = parseFloat(candidate.getAttribute('data-lng'));
          if (isNaN(sLat) || isNaN(sLng)) { continue; }
          var d = haversine(lat, lng, sLat, sLng);
          if (d < bestDist) { bestDist = d; best = candidate; }
        }
        return best;
      }

      /* Suburb name from a Places prediction - the same rule as the product
         page, so both surfaces name a location identically.

         Taken from what the shopper picked rather than the address components,
         which disagree with the dropdown: the 3083 place carries a locality of
         Bundoora while the dropdown offers Kingsbury, and Ponsonby resolves to a
         locality of Auckland, losing the suburb entirely. For a suburb the name
         is the main text; for a POSTCODE the main text is the postcode itself
         and the suburb sits at the front of the secondary text. */
      function suburbFromPrediction(pred) {
        if (!pred) { return ''; }
        var main = pred.mainText && pred.mainText.text ? pred.mainText.text : '';
        var secondary = pred.secondaryText && pred.secondaryText.text ? pred.secondaryText.text : '';
        var name = main;
        if (/^\d+$/.test(main.replace(/\s/g, ''))) { name = secondary; }
        name = name.split(',')[0];
        /* Trailing state abbreviation, e.g. "Kingsbury VIC". AU only - NZ
           secondary text carries a city rather than a state code. */
        return name.replace(/\s+(VIC|NSW|QLD|SA|WA|TAS|ACT|NT)$/i, '').trim();
      }

      /* Suburb from geocoder address components. Prefers a locality and falls
         back to a sublocality, which is what carries NZ suburbs. */
      function localityFromComponents(components, getText) {
        if (!components) { return ''; }
        var fallback = '';
        for (var i = 0; i < components.length; i++) {
          var types = components[i].types || [];
          if (types.indexOf('locality') !== -1) { return getText(components[i]); }
          if (!fallback && (types.indexOf('sublocality') !== -1 || types.indexOf('sublocality_level_1') !== -1)) {
            fallback = getText(components[i]);
          }
        }
        return fallback;
      }

      /* This page only ever geocoded FORWARDS (typed text to a place), so there
         was nothing to turn browser coordinates into a name. Added for the
         locate-me confirmation (#19498854). */
      function reverseGeocode(lat, lng, cb) {
        if (!geocoder) { cb('', ''); return; }
        geocoder.geocode({ location: { lat: lat, lng: lng } }, function (results, status) {
          var pc = '';
          var suburb = '';
          var text = function (c) { return c.long_name; };
          if (status === 'OK' && results) {
            for (var i = 0; i < results.length && !pc; i++) {
              pc = postcodeFromComponents(results[i].address_components, text);
            }
            for (var j = 0; j < results.length && !suburb; j++) {
              suburb = localityFromComponents(results[j].address_components, text);
            }
          }
          cb(pc, suburb);
        });
      }

      /* The Geocoder only exists once Maps has built the map, and on this page
         that can be lazy - the map is display:none in mobile List view. Wait for
         it rather than reporting a failure that is only a race. */
      function whenGeocoderReady(cb) {
        if (geocoder) { cb(true); return; }
        loadMaps();
        var waited = 0;
        var poll = window.setInterval(function () {
          waited += 100;
          if (geocoder) { window.clearInterval(poll); cb(true); }
          else if (waited >= 5000) { window.clearInterval(poll); cb(false); }
        }, 100);
      }

      /* "Use my current location" (#19498854).

         This used to call locateAt() straight from the coordinates, which only
         re-sorts the list by distance. Nothing was reverse geocoded, the field
         stayed empty and nothing was saved, so the shopper could not tell what
         had been detected. It now resolves the place, shows it for
         confirmation, and only commits when they agree.

         The confirmation lives in the Location prompt section, which is
         merchant content and can be absent from a store, so a missing prompt
         applies the location directly rather than doing nothing at all. */
      /* Pressing "use my current location" can sit for several seconds - the
         browser's own permission prompt first, then the fix, then the reverse
         geocode - with nothing on screen to say the press landed (#19500365,
         reported as "it can feel like nothing is happening"). For that whole
         wait the button shows a spinner in place of its icon.

         geoDone() is idempotent and runs on EVERY exit: the confirmation prompt
         appearing, a geocoder that never readied, a lookup that found nothing,
         and a denied or dismissed permission. It also runs on a watchdog,
         because getCurrentPosition has no timeout of its own - an unanswered
         permission prompt would otherwise leave the button spinning forever,
         which is worse than the dead button it replaced. */
      var geoTimer = null;

      function geoButtons() {
        /* Every geo control in this component, not just one. This page has a
           single search field, so today that is one button - the shape is kept
           identical to the PDP block, where the inline field and the drawer
           each have one and they share a single pending state. */
        var found = [];
        [root].forEach(function (scope) {
          if (!scope) { return; }
          scope.querySelectorAll('[data-sl-geo], [data-sl-inline-geo]').forEach(function (btn) {
            if (found.indexOf(btn) === -1) { found.push(btn); }
          });
        });
        return found;
      }

      function geoBusy() {
        geoButtons().forEach(function (btn) {
          btn.classList.add('is-loading');
          btn.setAttribute('aria-busy', 'true');
        });
        if (geoTimer) { clearTimeout(geoTimer); }
        geoTimer = setTimeout(geoDone, 20000);
      }

      function geoDone() {
        if (geoTimer) { clearTimeout(geoTimer); geoTimer = null; }
        geoButtons().forEach(function (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
      }

      function geolocate() {
        if (!navigator.geolocation) { return; }
        /* Already pending: ignore the repeat press rather than starting
           a second lookup behind the first. */
        var pending = geoButtons().filter(function (btn) { return btn.classList.contains('is-loading'); });
        if (pending.length) { return; }
        geoBusy();
        navigator.geolocation.getCurrentPosition(function (pos) {
          var lat = pos.coords.latitude;
          var lng = pos.coords.longitude;
          whenGeocoderReady(function (ready) {
            if (!ready) {
              geoDone();
              if (window.esLocationPrompt) { window.esLocationPrompt.notify('failed'); }
              return;
            }
            reverseGeocode(lat, lng, function (pc, suburb) {
              if (!pc && !suburb) {
                geoDone();
                if (window.esLocationPrompt) { window.esLocationPrompt.notify('failed'); }
                return;
              }
              var near = nearestStoreTo(lat, lng);
              var apply = function () {
                // A confirmed nearest store takes the centre itself below, so
                // skip the dual shopper+store framing only in that case.
                setLocation(lat, lng, pc, suburb, !!near);
                var shown = suburb || pc;
                if (searchInput && shown) { searchInput.value = shown; }

                /* Set the nearest store as theirs. The store was named in the
                   prompt and the shopper pressed the button, so this is their
                   choice rather than a silent reassignment - which is why a
                   typed search still only sorts the list and leaves the choice
                   to them. */
                if (near) {
                  setStore(near.getAttribute('data-index'), near.getAttribute('data-name'));
                  reflectMyStoreButtons();
                  /* A confirmed nearest store is a user-initiated selection,
                     so it opens its popover exactly like a pin or card click
                     (Alex, retest 1 Sep). The popover re-positions on every
                     bounds change, so opening during the result pan cannot
                     leave it at a stale position. Same visibility gate as
                     card clicks: mobile List view has no map on screen. */
                  stores.forEach(function (s) { s.classList.remove('is-active'); });
                  near.classList.add('is-active');
                  if (desktopMq.matches || body.classList.contains('sl-show-map')) {
                    // Same deterministic path as a list/pin click: the store
                    // lands dead-centre with the popover above it (Alex's
                    // ruling; the shopper's own location may leave the view).
                    zoomToStore(near.getAttribute('data-index'));
                    openPopover(near.getAttribute('data-index'));
                  } else {
                    pendingPopIndex = near.getAttribute('data-index');
                  }
                }
              };
              if (!window.esLocationPrompt) { geoDone(); apply(); return; }
              /* Cleared as the prompt opens, NOT when it is answered - the wait
                 the spinner covers is over the moment there is something to
                 look at, and the button sits behind the prompt until then. */
              geoDone();
              window.esLocationPrompt
                .confirm({
                  suburb: suburb,
                  postcode: pc,
                  store: near ? near.getAttribute('data-name') : ''
                })
                .then(function (ok) { if (ok) { apply(); } });
            });
          });
        }, function () {
          // Blocked, dismissed, or timed out. Silence here reads as a dead
          // button, which is what was reported.
          geoDone();
          if (window.esLocationPrompt) { window.esLocationPrompt.notify('denied'); }
        });
      }

      // ----- Wire search controls -----
      var searchInput = root.querySelector('[data-sl-search-input]');
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-sl-search]')) { runSearch(searchInput ? searchInput.value.trim() : ''); }
        if (e.target.closest('[data-sl-geo]')) { geolocate(); }
        if (e.target.closest('[data-sl-clear]')) {
          if (searchInput) { searchInput.value = ''; searchInput.focus(); }
          clearPostcode();
          resetResults();
        }
        if (e.target.closest('[data-sl-map-reset]')) {
          closePopover();
          fitAllMarkers();
          stores.forEach(function (s) { s.classList.remove('is-active'); });
        }
      });
      if (searchInput) {
        searchInput.addEventListener('keydown', function (e) {
          if (searchInput.__acInit) { return; }
          if (e.key === 'Enter') { e.preventDefault(); runSearch(searchInput.value.trim()); }
        });

        /* The map is display:none in the mobile List view, which is the default,
           so the IntersectionObserver at the bottom of this file never fires
           there and Places was never initialised - typing a postcode on a phone
           produced no suggestions at all. Loading on first contact with the
           field covers both views. loadMaps() guards on mapsRequested, so
           repeat calls cost nothing. */
        searchInput.addEventListener('focus', function () { loadMaps(); });

        /* Places takes over the 'input' event once setupAutocomplete has run
           (it checks __acInit and bails). Until then, hold the term and show the
           skeleton so the field does not look dead while the script downloads;
           setupAutocomplete picks pendingTerm up as soon as it is ready. */
        searchInput.addEventListener('input', function () {
          if (searchInput.__acInit) { return; }
          var value = searchInput.value.trim();
          if (value.length < 3) { pendingTerm = null; clearSuggestions(); return; }
          pendingTerm = value;
          showSkeleton();
          loadMaps();
        });
      }

      // ----- Mobile view tabs -----
      var tabs = root.querySelectorAll('[data-sl-tab]');
      for (var t = 0; t < tabs.length; t++) {
        tabs[t].addEventListener('click', function (e) {
          var view = e.currentTarget.getAttribute('data-sl-tab');
          for (var i = 0; i < tabs.length; i++) {
            var isActive = tabs[i] === e.currentTarget;
            tabs[i].classList.toggle('is-active', isActive);
            tabs[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
          }
          if (view === 'map') {
            body.classList.add('sl-show-map');
            loadMaps();
            // A selection made in List view opens now (buildMap's tail
            // handles the very first switch, while the maps script is still
            // loading). An already-open popover simply becomes visible again
            // with the map - the view toggle is not a dismissal.
            // The map may have been BUILT while display:none (the geolocate
            // flow loads it from List view), leaving gmaps with stale
            // container dimensions - setCenter then lands off-centre. Nudge
            // a resize and give the unhide a beat before centring.
            if (pendingPopIndex !== null && map) {
              var pendingIdx = pendingPopIndex;
              pendingPopIndex = null;
              window.setTimeout(function () {
                if (window.google && map) { google.maps.event.trigger(map, 'resize'); }
                zoomToStore(pendingIdx);
                openPopover(pendingIdx);
              }, 60);
            }
          } else {
            body.classList.remove('sl-show-map');
          }
        });
      }

      // ----- Filter by state -----
      // One <dialog>, two presentations: a bottom-sheet modal on mobile
      // (showModal -> top layer, backdrop, Esc, focus trap, matching the site's
      // other pop-ups) and a non-modal anchored dropdown on desktop (show()).
      var filter = root.querySelector('[data-sl-filter]');
      var filterDialog = root.querySelector('[data-sl-filter-dialog]');
      var filterToggle = root.querySelector('[data-sl-filter-toggle]');
      var stateInputs = filter ? filter.querySelectorAll('.sl-filter__list input') : [];
      var desktopMq = window.matchMedia('(min-width: 1104px)');

      function openFilter() {
        if (!filterDialog || filterDialog.open) { return; }
        if (desktopMq.matches) {
          if (typeof filterDialog.show === 'function') { filterDialog.show(); }
        } else if (typeof filterDialog.showModal === 'function') {
          filterDialog.showModal();
        }
        if (filterToggle) { filterToggle.setAttribute('aria-expanded', 'true'); }
      }
      function closeFilter() {
        if (filterDialog && filterDialog.open) { filterDialog.close(); }
      }

      if (filterToggle) {
        filterToggle.addEventListener('click', function (e) {
          e.stopPropagation();
          if (filterDialog && filterDialog.open) { closeFilter(); } else { openFilter(); }
        });
      }
      if (filterDialog) {
        // Reset the trigger state whenever the dialog closes (button, Esc, or
        // backdrop). The native modal handles Esc + focus itself.
        filterDialog.addEventListener('close', function () {
          if (filterToggle) { filterToggle.setAttribute('aria-expanded', 'false'); }
        });
        // Mobile modal: a click on the backdrop lands on the dialog element.
        // Close button (both presentations) also closes.
        filterDialog.addEventListener('click', function (e) {
          if (e.target === filterDialog || e.target.closest('[data-sl-filter-close]')) { closeFilter(); }
        });
        // Desktop dropdown is non-modal, so wire click-outside + Esc ourselves.
        document.addEventListener('click', function (e) {
          if (!filterDialog.open || !desktopMq.matches) { return; }
          if (e.target.closest('[data-sl-filter]')) { return; }
          closeFilter();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && filterDialog.open && desktopMq.matches) { closeFilter(); }
        });
        // Close on breakpoint change so a modal never lingers as a dropdown;
        // the popover comes down too rather than straddling layouts.
        var onMqChange = function () { closeFilter(); closePopover(); };
        if (desktopMq.addEventListener) { desktopMq.addEventListener('change', onMqChange); }
        else if (desktopMq.addListener) { desktopMq.addListener(onMqChange); }
      }

      function readSelectedStates() {
        selectedStates = [];
        Array.prototype.forEach.call(stateInputs, function (input) {
          if (input.checked) { selectedStates.push(input.value); }
        });
      }
      function onFilterChange() {
        readSelectedStates();
        reapply();
        syncMarkerVisibility();
      }
      // New selections (checkbox toggle, radio pick, keyboard) fire 'change'.
      Array.prototype.forEach.call(stateInputs, function (input) {
        input.addEventListener('change', onFilterChange);
      });
      // Single choice (radio): clicking the already-selected state clears it
      // (back to "all states"). The visible target is the label, so the hidden
      // input never gets its own mousedown - snapshot the row's radio on
      // pointerdown, then clear it if the same selected radio is clicked.
      // Unchecking a radio in code fires no 'change', so call onFilterChange here.
      var filterList = filter ? filter.querySelector('.sl-filter__list') : null;
      if (filterList) {
        var armedRadio = null;
        filterList.addEventListener('pointerdown', function (e) {
          var item = e.target.closest('.sl-filter__item');
          var input = item ? item.querySelector('input') : null;
          armedRadio = (input && input.type === 'radio' && input.checked) ? input : null;
        });
        filterList.addEventListener('click', function (e) {
          if (!armedRadio) { return; }
          var item = e.target.closest('.sl-filter__item');
          var input = item ? item.querySelector('input') : null;
          if (input && input === armedRadio) {
            input.checked = false;
            onFilterChange();
          }
          armedRadio = null;
        });
      }

      // ----- Lazy-load the map when it scrolls into view (desktop always shows
      // it; on mobile the tab click above also triggers the load). -----
      var mapEl = root.querySelector('[data-sl-map]');
      if (mapEl && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { loadMaps(); io.disconnect(); break; }
          }
        }, { rootMargin: '200px' });
        io.observe(mapEl);
      } else if (mapEl) {
        loadMaps();
      }

      // Pre-fill the search input with any persisted postcode.
      /* Suburb first, postcode only as a fallback - the same value the PDP
         field restores, so the two pages never disagree about where the shopper
         is (#19498854). */
      var savedState = loadState();
      var savedValue = savedState.label || savedState.postcode;
      if (savedValue && searchInput) { searchInput.value = savedValue; }

      reflectMyStoreButtons();
    }

    function boot() {
      var roots = document.querySelectorAll('[data-sl-page]');
      for (var i = 0; i < roots.length; i++) { init(roots[i]); }
    }

    ready(boot);
    document.addEventListener('shopify:section:load', function () { ready(boot); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-reviews"] && !Shopify.designMode) return;
  try {
    
  class StoreReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sr-track]');
      this.tpl = this.querySelector('[data-sr-card-template]');
      this.nav = this.querySelector('[data-sr-nav]');
      this.prevBtn = this.querySelector('[data-sr-prev]');
      this.nextBtn = this.querySelector('[data-sr-next]');

      this.apiUrl = this.getAttribute('data-api-url');
      this.storeId = this.getAttribute('data-store-id');
      this.apiKey = this.getAttribute('data-api-key');
      this.reviewType = this.getAttribute('data-type') || 'store_third_party_review';
      this.branch = this.getAttribute('data-branch');
      this.fallbackLocation = this.getAttribute('data-location') || '';
      this.max = parseInt(this.getAttribute('data-max'), 10) || 12;
      this.minRating = parseInt(this.getAttribute('data-min-rating'), 10) || 0;
      this.hideWhenEmpty = this.getAttribute('data-hide-empty') === 'true';

      this.update = this.update.bind(this);
      if (this.prevBtn) { this.prevBtn.addEventListener('click', this.page.bind(this, -1)); }
      if (this.nextBtn) { this.nextBtn.addEventListener('click', this.page.bind(this, 1)); }
      if (this.track) { this.track.addEventListener('scroll', this.update, { passive: true }); }
      if (this.track) { this.track.addEventListener('click', this.onToggle.bind(this)); }
      window.addEventListener('resize', this.update, { passive: true });

      /* No request possible - either the REVIEWS.io credentials are unset or this
         store has no Branch Name (reviews_branch). To a shopper that is simply "no
         reviews", so it takes the SAME path as an empty response and honours "Hide
         when no reviews".

         It used to `return` here without consulting the setting, which left the
         placeholder skeletons on the page for good: with the toggle ON the section
         still rendered rows of empty stars, because the setting was only ever
         checked after a fetch came back (#19504385 follow-up). Every AU store
         currently has an empty Branch Name, so this was every store page. */
      if (!this.apiUrl || !this.storeId || !this.apiKey || !this.branch) {
        this.render([]);
        return;
      }

      var self = this;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { io.disconnect(); self.load(); }
          });
        }, { rootMargin: '200px' });
        io.observe(this);
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
    }

    buildUrl() {
      return this.apiUrl.replace(/\/+$/, '') +
        '/reviews?store=' + encodeURIComponent(this.storeId) +
        '&apikey=' + encodeURIComponent(this.apiKey) +
        '&type=' + encodeURIComponent(this.reviewType) +
        '&branch=' + encodeURIComponent(this.branch) +
        '&per_page=' + this.max;
    }

    load() {
      var self = this;
      fetch(this.buildUrl(), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var reviews = data && data.reviews ? data.reviews : [];
          self.render(reviews);
        })
        .catch(function () { self.render([]); });
    }

    render(reviews) {
      if (!this.track || !this.tpl) { return; }

      // Only render reviews that have written comments (skip rating-only entries).
      reviews = reviews.filter(function (rv) {
        return rv.comments && String(rv.comments).trim() !== '';
      });

      var minR = this.minRating || 0;
      if (minR > 0) {
        reviews = reviews.filter(function (rv) { return (Number(rv.rating) || 0) >= minR; });
      }

      if (!reviews.length) {
        /* Nothing to show. The skeletons go regardless, so a visible section never
           shows rows of empty stars as if they were real reviews, and "Hide when no
           reviews" hides the whole thing - in the theme editor as well as on the
           storefront, so what the merchant previews is what a shopper gets. The
           section stays reachable from the editor's section list either way. */
        this.clearSkeletons();
        if (this.hideWhenEmpty) {
          /* A class with !important rather than the `hidden` attribute: `hidden`
             only works while nothing else sets `display` on the element, and it
             fails silently the moment something does. The class also hides the
             Shopify section wrapper, so no padding or background is left behind
             even if that wrapper is ever given styling of its own. */
          this.classList.add('store-reviews--empty');
          var wrapper = this.closest('.shopify-section');
          if (wrapper) { wrapper.classList.add('store-reviews-empty-wrapper'); }
        }
        this.update();
        return;
      }

      this.clearSkeletons();

      var frag = document.createDocumentFragment();
      var limit = Math.min(reviews.length, this.max);
      for (var i = 0; i < limit; i++) {
        var review = reviews[i];
        var node = this.tpl.content.firstElementChild.cloneNode(true);

        var rating = Number(review.rating) || 0;
        if (rating < 0) { rating = 0; }
        if (rating > 5) { rating = 5; }
        var fill = node.querySelector('[data-sr-fill]');
        if (fill) { fill.style.setProperty('--fill', (rating / 5 * 100) + '%'); }
        var srLabel = node.querySelector('[data-sr-rating]');
        if (srLabel) { srLabel.textContent = rating + ' out of 5 stars'; }

        var comments = review.comments || review.title || '';
        var titleEl = node.querySelector('[data-sr-title]');
        if (titleEl) { titleEl.textContent = this.snippet(comments, 90); }
        var quote = node.querySelector('[data-sr-quote]');
        if (quote) { quote.textContent = comments; }
        // Wire the accordion toggle to its collapsible quote by a unique id.
        var toggle = node.querySelector('[data-sr-toggle]');
        var wrap = node.querySelector('[data-sr-quote-wrap]');
        if (toggle && wrap) {
          var qid = (this.id || 'sr') + '-quote-' + i;
          wrap.id = qid;
          toggle.setAttribute('aria-controls', qid);
        }

        var name = node.querySelector('[data-sr-name]');
        if (name) { name.textContent = (review.author && review.author.name) ? review.author.name : ''; }

        var source = node.querySelector('[data-sr-source]');
        if (source) { source.textContent = review.source || 'Review'; }

        var locationText = (review.author && review.author.location) ? review.author.location : this.fallbackLocation;
        var locationEl = node.querySelector('[data-sr-location]');
        if (locationEl) { locationEl.textContent = locationText; }
        var sourceRow = node.querySelector('.store-reviews__source');
        if (sourceRow && locationText) { sourceRow.setAttribute('data-has-location', ''); }

        frag.appendChild(node);
      }
      this.track.appendChild(frag);
      this.update();
    }

    clearSkeletons() {
      var skeletons = this.track.querySelectorAll('.store-reviews__card--skeleton');
      for (var i = 0; i < skeletons.length; i++) { skeletons[i].remove(); }
    }

    page(direction) {
      if (!this.track) { return; }
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    // Shortened teaser of the comment for the (always-visible) title toggle.
    snippet(text, max) {
      text = String(text || '').trim();
      if (text.length <= max) { return text; }
      var cut = text.slice(0, max);
      var lastSpace = cut.lastIndexOf(' ');
      if (lastSpace > max * 0.5) { cut = cut.slice(0, lastSpace); }
      return cut + '...';
    }

    // Accordion: the title toggles its card's full comment open/closed.
    onToggle(event) {
      var btn = event.target.closest('[data-sr-toggle]');
      if (!btn || !this.contains(btn)) { return; }
      var card = btn.closest('.store-reviews__card');
      if (!card) { return; }
      var open = card.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    update() {
      if (!this.nav || !this.track) { return; }
      var overflow = this.track.scrollWidth - this.track.clientWidth > 2;
      this.nav.hidden = !overflow;
      var atStart = this.track.scrollLeft <= 2;
      var atEnd = this.track.scrollLeft >= (this.track.scrollWidth - this.track.clientWidth - 2);
      if (this.prevBtn) { this.prevBtn.disabled = atStart; }
      if (this.nextBtn) { this.nextBtn.disabled = atEnd; }
    }
  }

  if (!customElements.get('store-reviews')) {
    customElements.define('store-reviews', StoreReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-prompt"]) return;
  try {
    
  class WishlistPrompt extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-wishlist-dialog]');
      if (!this.dialog) return;

      this.headerTrigger = this.getAttribute('data-header-trigger') === 'true';

      // Default (product-card) copy + the optional header-trigger overrides.
      this.headingEl = this.querySelector('.wishlist-prompt__heading');
      this.bodyEl = this.querySelector('.wishlist-prompt__body');
      this.defaultHeading = this.headingEl ? this.headingEl.textContent.trim() : '';
      this.defaultBody = this.bodyEl ? this.bodyEl.textContent.trim() : '';
      this.headerHeading = this.getAttribute('data-header-heading');
      this.headerBody = this.getAttribute('data-header-body');

      this.dialog.addEventListener('cancel', this.onCancel.bind(this));
      this.dialog.addEventListener('click', this.onDialogClick.bind(this));
      var closeButton = this.querySelector('[data-wishlist-close]');
      if (closeButton) closeButton.addEventListener('click', this.close.bind(this));

      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      if (this.designMode) {
        this.setupEditorPreview();
        return;
      }

      // Intercept logged-out wishlist clicks in the CAPTURE phase so we run
      // before theWishlist.io's own (bubble-phase) handler and stop it.
      this.onCaptureClick = this.handleCaptureClick.bind(this);
      document.addEventListener('click', this.onCaptureClick, true);
    }

    disconnectedCallback() {
      if (this.onCaptureClick) {
        document.removeEventListener('click', this.onCaptureClick, true);
      }
      if (this.onEditorSelect) {
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:block:select', this.onEditorSelect);
      }
      if (this.onEditorDeselect) {
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
        document.removeEventListener('shopify:block:deselect', this.onEditorDeselect);
      }
    }

    handleCaptureClick(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var heart = target.closest('.btn-wishlist');
      var headerLink = this.headerTrigger ? target.closest('[data-wishlist-link]') : null;
      if (!heart && !headerLink) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.open(headerLink ? 'header' : 'card');
    }

    applyContent(source) {
      // Swap to the header-specific copy when opened from the header wishlist
      // icon; otherwise use the default (product-card) copy. Each field falls
      // back to the default when its header override is blank.
      if (this.headingEl) {
        this.headingEl.textContent = (source === 'header' && this.headerHeading) ? this.headerHeading : this.defaultHeading;
      }
      if (this.bodyEl) {
        this.bodyEl.textContent = (source === 'header' && this.headerBody) ? this.headerBody : this.defaultBody;
      }
    }

    open(source) {
      this.applyContent(source);
      // User-initiated, so take precedence: close any other overlay dialog
      // (e.g. the newsletter pop-up) that happens to be open first.
      var current = document.querySelector('dialog[open]');
      if (current && current !== this.dialog) {
        try { current.close(); } catch (e) {}
      }
      if (typeof this.dialog.showModal === 'function' && !this.dialog.open) {
        this.lockScroll();
        this.dialog.showModal();
      }
    }

    onCancel(event) {
      event.preventDefault();
      this.close();
    }

    onDialogClick(event) {
      if (event.target === this.dialog) this.close();
    }

    close() {
      this.unlockScroll();
      if (this.dialog.open) this.dialog.close();
    }

    lockScroll() {
      document.documentElement.style.overflow = 'hidden';
    }

    unlockScroll() {
      document.documentElement.style.overflow = '';
    }

    setupEditorPreview() {
      this.sectionId = this.getAttribute('data-section-id');
      this.onEditorSelect = (event) => {
        if (!event.detail || event.detail.sectionId !== this.sectionId) return;
        if (typeof this.dialog.showModal === 'function' && !this.dialog.open) {
          this.dialog.showModal();
        }
      };
      this.onEditorDeselect = (event) => {
        if (event.detail && event.detail.sectionId !== this.sectionId) return;
        if (this.dialog.open) this.dialog.close();
      };
      document.addEventListener('shopify:section:select', this.onEditorSelect);
      document.addEventListener('shopify:block:select', this.onEditorSelect);
      document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
      document.addEventListener('shopify:block:deselect', this.onEditorDeselect);
    }
  }

  if (!customElements.get('wishlist-prompt')) {
    customElements.define('wishlist-prompt', WishlistPrompt);
  }

  } catch(e) { console.error(e); }
})();
})();
